import type { KnowledgeItem } from '../types';

export const builtinCharacterKnowledge: KnowledgeItem[] = [
  {
    id: "builtin-char-0001",
    type: "character",
    title: "的",
    content: "的",
    pronunciation: "de",
    meaning: "表示所属或修饰关系，常放在词语后面。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0002",
    type: "character",
    title: "一",
    content: "一",
    pronunciation: "yī",
    meaning: "表示数量一，也可以表示同一个或全部。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0003",
    type: "character",
    title: "是",
    content: "是",
    pronunciation: "shì",
    meaning: "表示判断、肯定或正确。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0004",
    type: "character",
    title: "不",
    content: "不",
    pronunciation: "bù",
    meaning: "表示否定，意思和“不是、不要”有关。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0005",
    type: "character",
    title: "了",
    content: "了",
    pronunciation: "le",
    meaning: "放在动词或形容词后，表示动作已经完成。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0006",
    type: "character",
    title: "在",
    content: "在",
    pronunciation: "zài",
    meaning: "表示存在、处于某个地方或正在做某事。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0007",
    type: "character",
    title: "人",
    content: "人",
    pronunciation: "rén",
    meaning: "会说话、会思考、能制造和使用工具的生命。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0008",
    type: "character",
    title: "有",
    content: "有",
    pronunciation: "yǒu",
    meaning: "表示拥有、存在或发生。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0009",
    type: "character",
    title: "我",
    content: "我",
    pronunciation: "wǒ",
    meaning: "说话的人称呼自己。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0010",
    type: "character",
    title: "他",
    content: "他",
    pronunciation: "tā",
    meaning: "指说话双方之外的另一个人。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0011",
    type: "character",
    title: "这",
    content: "这",
    pronunciation: "zhè",
    meaning: "指离说话人比较近的人或事物。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0012",
    type: "character",
    title: "个",
    content: "个",
    pronunciation: "ɡè",
    meaning: "单，独",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0013",
    type: "character",
    title: "们",
    content: "们",
    pronunciation: "mén",
    meaning: "用在代词或指人的名词后面,表示复数。如孩子们",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0014",
    type: "character",
    title: "中",
    content: "中",
    pronunciation: "zhōnɡ",
    meaning: "表示里面、中间或一定范围之内。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0015",
    type: "character",
    title: "来",
    content: "来",
    pronunciation: "lái",
    meaning: "表示从别处到这里。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0016",
    type: "character",
    title: "上",
    content: "上",
    pronunciation: "shànɡ",
    meaning: "表示位置在高处，也可以表示向上。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0017",
    type: "character",
    title: "大",
    content: "大",
    pronunciation: "dà",
    meaning: "表示体积、数量、程度等比较大。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0018",
    type: "character",
    title: "为",
    content: "为",
    pronunciation: "wéi",
    meaning: "表示做、成为、因为或为了。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0019",
    type: "character",
    title: "和",
    content: "和",
    pronunciation: "hé",
    meaning: "表示一起、跟，或者关系融洽。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0020",
    type: "character",
    title: "国",
    content: "国",
    pronunciation: "ɡuó",
    meaning: "指国家或一片土地。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0021",
    type: "character",
    title: "地",
    content: "地",
    pronunciation: "dì",
    meaning: "指土地、地面或某个地方。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0022",
    type: "character",
    title: "到",
    content: "到",
    pronunciation: "dào",
    meaning: "表示到达某个地方或达到某个程度。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0023",
    type: "character",
    title: "以",
    content: "以",
    pronunciation: "yǐ",
    meaning: "表示用、按照、因为或从这里开始。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0024",
    type: "character",
    title: "说",
    content: "说",
    pronunciation: "shuō",
    meaning: "用语言表达意思。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0025",
    type: "character",
    title: "时",
    content: "时",
    pronunciation: "shí",
    meaning: "表示时间、时候或经常。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0026",
    type: "character",
    title: "要",
    content: "要",
    pronunciation: "yào",
    meaning: "表示需要、想要或将要发生。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0027",
    type: "character",
    title: "就",
    content: "就",
    pronunciation: "jiù",
    meaning: "表示很快发生、紧接着或只、仅仅。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0028",
    type: "character",
    title: "出",
    content: "出",
    pronunciation: "chū",
    meaning: "表示从里面到外面或出现。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0029",
    type: "character",
    title: "会",
    content: "会",
    pronunciation: "huì",
    meaning: "表示懂得、能够或有可能。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0030",
    type: "character",
    title: "可",
    content: "可",
    pronunciation: "kě",
    meaning: "表示可以、能够或值得。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0031",
    type: "character",
    title: "也",
    content: "也",
    pronunciation: "yě",
    meaning: "表示同样、并列或语气舒缓。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0032",
    type: "character",
    title: "你",
    content: "你",
    pronunciation: "nǐ",
    meaning: "称呼对方，也就是和你说话的人。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0033",
    type: "character",
    title: "对",
    content: "对",
    pronunciation: "duì",
    meaning: "唐且对曰臣未尝闻也。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0034",
    type: "character",
    title: "生",
    content: "生",
    pronunciation: "shēnɡ",
    meaning: "草木长出、成长",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0035",
    type: "character",
    title: "能",
    content: "能",
    pronunciation: "nénɡ",
    meaning: "才干，本领",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0036",
    type: "character",
    title: "而",
    content: "而",
    pronunciation: "ér",
    meaning: "从古沿用下来的连词,可连接词、短语和分句,表示多种关系",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0037",
    type: "character",
    title: "子",
    content: "子",
    pronunciation: "zǐ",
    meaning: "儿，儿或女",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0038",
    type: "character",
    title: "那",
    content: "那",
    pronunciation: "nà",
    meaning: "跟\"这\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0039",
    type: "character",
    title: "得",
    content: "得",
    pronunciation: "dé",
    meaning: "同本义(本来没有而争取得来成为己有)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0040",
    type: "character",
    title: "于",
    content: "于",
    pronunciation: "yú",
    meaning: "介词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0041",
    type: "character",
    title: "着",
    content: "着",
    pronunciation: "zhe",
    meaning: "感到，受到",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0042",
    type: "character",
    title: "下",
    content: "下",
    pronunciation: "xià",
    meaning: "位置在低处，跟\"上\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0043",
    type: "character",
    title: "自",
    content: "自",
    pronunciation: "zì",
    meaning: "本人，己身",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0044",
    type: "character",
    title: "之",
    content: "之",
    pronunciation: "zhī",
    meaning: "到，往由京",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0045",
    type: "character",
    title: "年",
    content: "年",
    pronunciation: "nián",
    meaning: "时间单位",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0046",
    type: "character",
    title: "过",
    content: "过",
    pronunciation: "ɡuò",
    meaning: "经历，经历某个空间、时间、地点",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0047",
    type: "character",
    title: "发",
    content: "发",
    pronunciation: "fā",
    meaning: "长出，产生",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0048",
    type: "character",
    title: "后",
    content: "后",
    pronunciation: "hòu",
    meaning: "跟\"前\"、\"先\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0049",
    type: "character",
    title: "作",
    content: "作",
    pronunciation: "zuò",
    meaning: "起，兴起振",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0050",
    type: "character",
    title: "里",
    content: "里",
    pronunciation: "lǐ",
    meaning: "长度单位1公",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0051",
    type: "character",
    title: "用",
    content: "用",
    pronunciation: "yònɡ",
    meaning: "使人、物等发挥其功能使",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0052",
    type: "character",
    title: "道",
    content: "道",
    pronunciation: "dào",
    meaning: "又如大道,问道于盲;要道;人行",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0053",
    type: "character",
    title: "行",
    content: "行",
    pronunciation: "xínɡ",
    meaning: "排，队列",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0054",
    type: "character",
    title: "所",
    content: "所",
    pronunciation: "suǒ",
    meaning: "地方处",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0055",
    type: "character",
    title: "然",
    content: "然",
    pronunciation: "rán",
    meaning: "是，对以为",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0056",
    type: "character",
    title: "家",
    content: "家",
    pronunciation: "jiā",
    meaning: "家庭，人家，也指有关家庭的我",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0057",
    type: "character",
    title: "种",
    content: "种",
    pronunciation: "zhǒnɡ",
    meaning: "植物的种子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0058",
    type: "character",
    title: "事",
    content: "事",
    pronunciation: "shì",
    meaning: "人的一切活动，自然界、社会中的一切现象或活动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0059",
    type: "character",
    title: "成",
    content: "成",
    pronunciation: "chénɡ",
    meaning: "又如落成(建筑物完工)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0060",
    type: "character",
    title: "方",
    content: "方",
    pronunciation: "fānɡ",
    meaning: "四角都是直角的四边形或每个面都是直角四边形的六面体正",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0061",
    type: "character",
    title: "多",
    content: "多",
    pronunciation: "duō",
    meaning: "超过正确的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0062",
    type: "character",
    title: "经",
    content: "经",
    pronunciation: "jīnɡ",
    meaning: "织布的纵线叫\"经\"，横线叫\"纬\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0063",
    type: "character",
    title: "么",
    content: "么",
    pronunciation: "me",
    meaning: "用于词尾什",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0064",
    type: "character",
    title: "去",
    content: "去",
    pronunciation: "qù",
    meaning: "离开",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0065",
    type: "character",
    title: "法",
    content: "法",
    pronunciation: "fǎ",
    meaning: "由国家机关制定或认可，颁布后强制执行的规则",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0066",
    type: "character",
    title: "学",
    content: "学",
    pronunciation: "xué",
    meaning: "学习",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0067",
    type: "character",
    title: "如",
    content: "如",
    pronunciation: "rú",
    meaning: "像，相似，同样",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0068",
    type: "character",
    title: "都",
    content: "都",
    pronunciation: "dōu",
    meaning: "表示全部包括在内",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0069",
    type: "character",
    title: "同",
    content: "同",
    pronunciation: "tónɡ",
    meaning: "一样",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0070",
    type: "character",
    title: "现",
    content: "现",
    pronunciation: "xiàn",
    meaning: "显出，出现，显露表",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0071",
    type: "character",
    title: "当",
    content: "当",
    pronunciation: "dānɡ",
    meaning: "对等;相当于",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0072",
    type: "character",
    title: "没",
    content: "没",
    pronunciation: "méi",
    meaning: "不领有,不具有,不存在",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0073",
    type: "character",
    title: "动",
    content: "动",
    pronunciation: "dònɡ",
    meaning: "摇动,震动,移动。与静相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0074",
    type: "character",
    title: "面",
    content: "面",
    pronunciation: "miàn",
    meaning: "脸，头的前部",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0075",
    type: "character",
    title: "起",
    content: "起",
    pronunciation: "qǐ",
    meaning: "由卧而坐，由坐而立，由下而上等",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0076",
    type: "character",
    title: "看",
    content: "看",
    pronunciation: "kàn",
    meaning: "守护，监视",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0077",
    type: "character",
    title: "定",
    content: "定",
    pronunciation: "dìnɡ",
    meaning: "同本义,与乱或动相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0078",
    type: "character",
    title: "天",
    content: "天",
    pronunciation: "tiān",
    meaning: "高空",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0079",
    type: "character",
    title: "分",
    content: "分",
    pronunciation: "fēn",
    meaning: "划，划开，跟\"合\"相对划",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0080",
    type: "character",
    title: "还",
    content: "还",
    pronunciation: "hái",
    meaning: "仍旧，依然他身体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0081",
    type: "character",
    title: "进",
    content: "进",
    pronunciation: "jìn",
    meaning: "向前，跟\"退\"相对跃",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0082",
    type: "character",
    title: "好",
    content: "好",
    pronunciation: "hǎo",
    meaning: "勇敢，优点多的，使人满意的，跟\"坏\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0083",
    type: "character",
    title: "小",
    content: "小",
    pronunciation: "xiǎo",
    meaning: "跟\"大\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0084",
    type: "character",
    title: "部",
    content: "部",
    pronunciation: "bù",
    meaning: "古代军事编制单位,后泛指部队,军队",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0085",
    type: "character",
    title: "其",
    content: "其",
    pronunciation: "qí",
    meaning: "第三人称代词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0086",
    type: "character",
    title: "些",
    content: "些",
    pronunciation: "xiē",
    meaning: "少许，一点儿",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0087",
    type: "character",
    title: "主",
    content: "主",
    pronunciation: "zhǔ",
    meaning: "最重要的，最基本的，事物的根本",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0088",
    type: "character",
    title: "样",
    content: "样",
    pronunciation: "yànɡ",
    meaning: "形状",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0089",
    type: "character",
    title: "理",
    content: "理",
    pronunciation: "lǐ",
    meaning: "条纹",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0090",
    type: "character",
    title: "心",
    content: "心",
    pronunciation: "xīn",
    meaning: "人和高等动物身体内推动血液循环的脏器",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0091",
    type: "character",
    title: "她",
    content: "她",
    pronunciation: "tā",
    meaning: "称代美好的事物或者自己所敬重、热爱和喜欢的事物,往往用她字",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0092",
    type: "character",
    title: "本",
    content: "本",
    pronunciation: "běn",
    meaning: "又如水有源,木有本;本干(草木的根干)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0093",
    type: "character",
    title: "前",
    content: "前",
    pronunciation: "qián",
    meaning: "跟\"后\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0094",
    type: "character",
    title: "开",
    content: "开",
    pronunciation: "kāi",
    meaning: "跟\"关\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0095",
    type: "character",
    title: "但",
    content: "但",
    pronunciation: "dàn",
    meaning: "表示范围,相当于只,仅",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0096",
    type: "character",
    title: "因",
    content: "因",
    pronunciation: "yīn",
    meaning: "根源，缘故原",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0097",
    type: "character",
    title: "只",
    content: "只",
    pronunciation: "zhī",
    meaning: "仅仅",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0098",
    type: "character",
    title: "从",
    content: "从",
    pronunciation: "cónɡ",
    meaning: "顺从;依从",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0099",
    type: "character",
    title: "想",
    content: "想",
    pronunciation: "xiǎnɡ",
    meaning: "思索，动脑筋",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0100",
    type: "character",
    title: "实",
    content: "实",
    pronunciation: "shí",
    meaning: "满，充满",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0102",
    type: "character",
    title: "军",
    content: "军",
    pronunciation: "jūn",
    meaning: "武装部队",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0103",
    type: "character",
    title: "者",
    content: "者",
    pronunciation: "zhě",
    meaning: "代词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0104",
    type: "character",
    title: "意",
    content: "意",
    pronunciation: "yì",
    meaning: "心思心",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0105",
    type: "character",
    title: "无",
    content: "无",
    pronunciation: "wú",
    meaning: "没有，跟\"有\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0106",
    type: "character",
    title: "力",
    content: "力",
    pronunciation: "lì",
    meaning: "能量，效能",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0107",
    type: "character",
    title: "它",
    content: "它",
    pronunciation: "tā",
    meaning: "他，专指事物或牲口晒的衣服",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0108",
    type: "character",
    title: "与",
    content: "与",
    pronunciation: "yǔ",
    meaning: "跟，同，和",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0109",
    type: "character",
    title: "长",
    content: "长",
    pronunciation: "chánɡ",
    meaning: "同本义。与短相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0110",
    type: "character",
    title: "把",
    content: "把",
    pronunciation: "bǎ",
    meaning: "街亭有兵把守。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0111",
    type: "character",
    title: "机",
    content: "机",
    pronunciation: "jī",
    meaning: "〈古〉弓弩上发射箭的机关操弓关",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0112",
    type: "character",
    title: "十",
    content: "十",
    pronunciation: "shí",
    meaning: "数目字",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0113",
    type: "character",
    title: "民",
    content: "民",
    pronunciation: "mín",
    meaning: "〈古〉指奴隶或没做官的众百姓",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0114",
    type: "character",
    title: "第",
    content: "第",
    pronunciation: "dì",
    meaning: "同本义。有时也用于数字前表示次序",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0115",
    type: "character",
    title: "公",
    content: "公",
    pronunciation: "ɡōnɡ",
    meaning: "国家的或集体的，跟\"私\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0116",
    type: "character",
    title: "此",
    content: "此",
    pronunciation: "cǐ",
    meaning: "这;这个",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0117",
    type: "character",
    title: "已",
    content: "已",
    pronunciation: "yǐ",
    meaning: "止，完毕，罢了争论不",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0118",
    type: "character",
    title: "工",
    content: "工",
    pronunciation: "ɡōnɡ",
    meaning: "工人煤矿",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0119",
    type: "character",
    title: "使",
    content: "使",
    pronunciation: "shǐ",
    meaning: "命令，派遣，支配指",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0120",
    type: "character",
    title: "情",
    content: "情",
    pronunciation: "qínɡ",
    meaning: "喜、怒、哀、乐等心理状况",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0121",
    type: "character",
    title: "明",
    content: "明",
    pronunciation: "mínɡ",
    meaning: "亮，照亮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0122",
    type: "character",
    title: "性",
    content: "性",
    pronunciation: "xìnɡ",
    meaning: "人或事物固有的特质",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0123",
    type: "character",
    title: "知",
    content: "知",
    pronunciation: "zhī",
    meaning: "晓得，明了",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0124",
    type: "character",
    title: "全",
    content: "全",
    pronunciation: "quán",
    meaning: "完整，完备，不缺少齐",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0125",
    type: "character",
    title: "三",
    content: "三",
    pronunciation: "sān",
    meaning: "数目字",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0126",
    type: "character",
    title: "又",
    content: "又",
    pronunciation: "yòu",
    meaning: "再，更，〈表〉重复或继续她",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0127",
    type: "character",
    title: "关",
    content: "关",
    pronunciation: "ɡuān",
    meaning: "闭，合把门",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0128",
    type: "character",
    title: "点",
    content: "点",
    pronunciation: "diǎn",
    meaning: "细小的黑色斑痕",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0129",
    type: "character",
    title: "正",
    content: "正",
    pronunciation: "zhènɡ",
    meaning: "在中间，不偏不斜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0130",
    type: "character",
    title: "业",
    content: "业",
    pronunciation: "yè",
    meaning: "事情，所从事的工作事",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0131",
    type: "character",
    title: "外",
    content: "外",
    pronunciation: "wài",
    meaning: "跟\"内\"、\"里\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0132",
    type: "character",
    title: "将",
    content: "将",
    pronunciation: "jiānɡ",
    meaning: "快要",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0133",
    type: "character",
    title: "两",
    content: "两",
    pronunciation: "liǎnɡ",
    meaning: "数目字",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0134",
    type: "character",
    title: "高",
    content: "高",
    pronunciation: "ɡāo",
    meaning: "跟\"低\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0135",
    type: "character",
    title: "间",
    content: "间",
    pronunciation: "jiān",
    meaning: "夹缝门",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0136",
    type: "character",
    title: "由",
    content: "由",
    pronunciation: "yóu",
    meaning: "原因原",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0137",
    type: "character",
    title: "问",
    content: "问",
    pronunciation: "wèn",
    meaning: "不知的或不明白的请人解答请",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0138",
    type: "character",
    title: "很",
    content: "很",
    pronunciation: "hěn",
    meaning: "又如很子(忤逆的儿子);很忤;很触(违犯",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0139",
    type: "character",
    title: "最",
    content: "最",
    pronunciation: "zuì",
    meaning: "极，顶",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0140",
    type: "character",
    title: "重",
    content: "重",
    pronunciation: "zhònɡ",
    meaning: "双,成对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0141",
    type: "character",
    title: "并",
    content: "并",
    pronunciation: "bìnɡ",
    meaning: "又如并列;并肩作战;并介(不论穷富,都能耿介于守。兼利天下叫",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0142",
    type: "character",
    title: "物",
    content: "物",
    pronunciation: "wù",
    meaning: "东西",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0143",
    type: "character",
    title: "手",
    content: "手",
    pronunciation: "shǒu",
    meaning: "人体的上肢",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0144",
    type: "character",
    title: "应",
    content: "应",
    pronunciation: "yīnɡ",
    meaning: "该，当",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0145",
    type: "character",
    title: "战",
    content: "战",
    pronunciation: "zhàn",
    meaning: "打仗",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0146",
    type: "character",
    title: "向",
    content: "向",
    pronunciation: "xiànɡ",
    meaning: "朝着，对着",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0147",
    type: "character",
    title: "头",
    content: "头",
    pronunciation: "tóu",
    meaning: "脑袋，人体的最上部分或动物体的最前部分",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0148",
    type: "character",
    title: "文",
    content: "文",
    pronunciation: "wén",
    meaning: "事物的纹理或形象，线条交错的图形、花纹水",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0149",
    type: "character",
    title: "体",
    content: "体",
    pronunciation: "tǐ",
    meaning: "人或动物的全身人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0150",
    type: "character",
    title: "政",
    content: "政",
    pronunciation: "zhènɡ",
    meaning: "政治，它是经济的集中表现",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0151",
    type: "character",
    title: "美",
    content: "美",
    pronunciation: "měi",
    meaning: "好，善",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0152",
    type: "character",
    title: "相",
    content: "相",
    pronunciation: "xiānɡ",
    meaning: "交互，互往来",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0153",
    type: "character",
    title: "见",
    content: "见",
    pronunciation: "jiàn",
    meaning: "看到看",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0154",
    type: "character",
    title: "被",
    content: "被",
    pronunciation: "bèi",
    meaning: "又如棉被;夹被;毛巾被;被窝(覆以棉被,容人安睡的地方);被",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0155",
    type: "character",
    title: "利",
    content: "利",
    pronunciation: "lì",
    meaning: "好处，益处，跟\"害\"、\"弊\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0156",
    type: "character",
    title: "什",
    content: "什",
    pronunciation: "shí",
    meaning: "表示询问某人、某物或某事的本身或性质",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0157",
    type: "character",
    title: "二",
    content: "二",
    pronunciation: "èr",
    meaning: "一加一的和",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0158",
    type: "character",
    title: "等",
    content: "等",
    pronunciation: "děnɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0159",
    type: "character",
    title: "产",
    content: "产",
    pronunciation: "chǎn",
    meaning: "生，生育",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0160",
    type: "character",
    title: "或",
    content: "或",
    pronunciation: "huò",
    meaning: "也许",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0161",
    type: "character",
    title: "新",
    content: "新",
    pronunciation: "xīn",
    meaning: "初出现或初产生的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0162",
    type: "character",
    title: "己",
    content: "己",
    pronunciation: "jǐ",
    meaning: "自身自",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0163",
    type: "character",
    title: "制",
    content: "制",
    pronunciation: "zhì",
    meaning: "规定，拟定",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0164",
    type: "character",
    title: "身",
    content: "身",
    pronunciation: "shēn",
    meaning: "人或动物的躯体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0165",
    type: "character",
    title: "果",
    content: "果",
    pronunciation: "ɡuǒ",
    meaning: "果子，果实，某些植物花落后，含有种子的部分苹",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0166",
    type: "character",
    title: "加",
    content: "加",
    pronunciation: "jiā",
    meaning: "把两个以上的数目或东西合在一起三",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0167",
    type: "character",
    title: "西",
    content: "西",
    pronunciation: "xī",
    meaning: "方向，日落的一方，跟\"东\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0168",
    type: "character",
    title: "斯",
    content: "斯",
    pronunciation: "sī",
    meaning: "示代词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0170",
    type: "character",
    title: "话",
    content: "话",
    pronunciation: "huà",
    meaning: "语言讲",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0171",
    type: "character",
    title: "合",
    content: "合",
    pronunciation: "hé",
    meaning: "旧时量粮食的器具",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0172",
    type: "character",
    title: "回",
    content: "回",
    pronunciation: "huí",
    meaning: "返，还，归",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0173",
    type: "character",
    title: "特",
    content: "特",
    pronunciation: "tè",
    meaning: "不普通的，超出一般的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0174",
    type: "character",
    title: "代",
    content: "代",
    pronunciation: "dài",
    meaning: "孝成王使括(赵括)代廉颇为",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0175",
    type: "character",
    title: "内",
    content: "内",
    pronunciation: "nèi",
    meaning: "里面，跟\"外\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0176",
    type: "character",
    title: "信",
    content: "信",
    pronunciation: "xìn",
    meaning: "诚实，不欺骗",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0177",
    type: "character",
    title: "表",
    content: "表",
    pronunciation: "biǎo",
    meaning: "外面(与里相对)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0178",
    type: "character",
    title: "化",
    content: "化",
    pronunciation: "huà",
    meaning: "改变大变",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0179",
    type: "character",
    title: "老",
    content: "老",
    pronunciation: "lǎo",
    meaning: "年纪大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0180",
    type: "character",
    title: "给",
    content: "给",
    pronunciation: "ɡěi",
    meaning: "交，付，送与请",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0181",
    type: "character",
    title: "世",
    content: "世",
    pronunciation: "shì",
    meaning: "一生，一辈子人生一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0182",
    type: "character",
    title: "位",
    content: "位",
    pronunciation: "wèi",
    meaning: "所在的地方",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0183",
    type: "character",
    title: "次",
    content: "次",
    pronunciation: "cì",
    meaning: "指行军在一处停留三宿以上",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0184",
    type: "character",
    title: "度",
    content: "度",
    pronunciation: "dù",
    meaning: "又如尺度",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0185",
    type: "character",
    title: "门",
    content: "门",
    pronunciation: "mén",
    meaning: "建筑物的进出口，设在进出口能开关的装置，泛指进出口前",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0186",
    type: "character",
    title: "任",
    content: "任",
    pronunciation: "rèn",
    meaning: "任县，任丘县，均在河北省",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0187",
    type: "character",
    title: "常",
    content: "常",
    pronunciation: "chánɡ",
    meaning: "随时，时时时",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0188",
    type: "character",
    title: "先",
    content: "先",
    pronunciation: "xiān",
    meaning: "时间或次序在前的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0189",
    type: "character",
    title: "海",
    content: "海",
    pronunciation: "hǎi",
    meaning: "靠近大陆比洋小的水域东",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0190",
    type: "character",
    title: "通",
    content: "通",
    pronunciation: "tōnɡ",
    meaning: "可以穿过，没有阻碍",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0191",
    type: "character",
    title: "教",
    content: "教",
    pronunciation: "jiào",
    meaning: "导，培育，培养",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0192",
    type: "character",
    title: "儿",
    content: "儿",
    pronunciation: "ér",
    meaning: "①小孩子婴～。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0193",
    type: "character",
    title: "原",
    content: "原",
    pronunciation: "yuán",
    meaning: "水源，源泉水有",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0194",
    type: "character",
    title: "东",
    content: "东",
    pronunciation: "dōnɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0195",
    type: "character",
    title: "声",
    content: "声",
    pronunciation: "shēnɡ",
    meaning: "物体振动时所产生的能引起听觉的波",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0196",
    type: "character",
    title: "提",
    content: "提",
    pronunciation: "tí",
    meaning: "悬空拿着",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0197",
    type: "character",
    title: "立",
    content: "立",
    pronunciation: "lì",
    meaning: "耸立;树立;建立;竖起",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0198",
    type: "character",
    title: "及",
    content: "及",
    pronunciation: "jí",
    meaning: "到，至，达到自古",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0199",
    type: "character",
    title: "比",
    content: "比",
    pronunciation: "bǐ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0200",
    type: "character",
    title: "员",
    content: "员",
    pronunciation: "yuán",
    meaning: "在工作或学习的人公务",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0201",
    type: "character",
    title: "解",
    content: "解",
    pronunciation: "jiě",
    meaning: "剖开，分割病理尸体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0203",
    type: "character",
    title: "名",
    content: "名",
    pronunciation: "mínɡ",
    meaning: "人或事物的称谓",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0204",
    type: "character",
    title: "真",
    content: "真",
    pronunciation: "zhēn",
    meaning: "客观存在的，跟\"假\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0205",
    type: "character",
    title: "论",
    content: "论",
    pronunciation: "lùn",
    meaning: "商讨，判断，研究讨",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0206",
    type: "character",
    title: "处",
    content: "处",
    pronunciation: "chǔ",
    meaning: "居住久",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0207",
    type: "character",
    title: "走",
    content: "走",
    pronunciation: "zǒu",
    meaning: "行，步行",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0208",
    type: "character",
    title: "义",
    content: "义",
    pronunciation: "yì",
    meaning: "公正合宜的道德、道理或行为正",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0209",
    type: "character",
    title: "各",
    content: "各",
    pronunciation: "ɡè",
    meaning: "每个,各自",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0210",
    type: "character",
    title: "入",
    content: "入",
    pronunciation: "rù",
    meaning: "进，收进，从外面进到里面，跟\"出\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0211",
    type: "character",
    title: "几",
    content: "几",
    pronunciation: "jǐ",
    meaning: "疑问词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0212",
    type: "character",
    title: "口",
    content: "口",
    pronunciation: "kǒu",
    meaning: "嘴，人与动物进食的器官，也是某些动物或高等动物发声器官的一部",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0213",
    type: "character",
    title: "认",
    content: "认",
    pronunciation: "rèn",
    meaning: "识别，分辨",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0214",
    type: "character",
    title: "条",
    content: "条",
    pronunciation: "tiáo",
    meaning: "细长的枝枝",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0215",
    type: "character",
    title: "平",
    content: "平",
    pronunciation: "pínɡ",
    meaning: "不倾斜，无凹凸，无高低起伏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0216",
    type: "character",
    title: "系",
    content: "系",
    pronunciation: "xì",
    meaning: "结，缚，扣",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0217",
    type: "character",
    title: "气",
    content: "气",
    pronunciation: "qì",
    meaning: "无一定形状，能自由散布的物体",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0218",
    type: "character",
    title: "题",
    content: "题",
    pronunciation: "tí",
    meaning: "〈古〉指额圜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0219",
    type: "character",
    title: "活",
    content: "活",
    pronunciation: "huó",
    meaning: "生存，有生命，跟\"死\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0220",
    type: "character",
    title: "尔",
    content: "尔",
    pronunciation: "ěr",
    meaning: "后引作薾。华盛的样子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0221",
    type: "character",
    title: "更",
    content: "更",
    pronunciation: "ɡènɡ",
    meaning: "改变，改动，调换",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0222",
    type: "character",
    title: "别",
    content: "别",
    pronunciation: "bié",
    meaning: "又如别割(分割);别产(分割家产;分家);别国(从一国分化而",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0223",
    type: "character",
    title: "打",
    content: "打",
    pronunciation: "dǎ",
    meaning: "又如用棍打狗;打拍(敲击);打火刀(用来敲打火石的刀形铁片)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0224",
    type: "character",
    title: "女",
    content: "女",
    pronunciation: "nǚ",
    meaning: "女性，女人妇",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0225",
    type: "character",
    title: "变",
    content: "变",
    pronunciation: "biàn",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0226",
    type: "character",
    title: "四",
    content: "四",
    pronunciation: "sì",
    meaning: "闰月定四时成岁。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0227",
    type: "character",
    title: "神",
    content: "神",
    pronunciation: "shén",
    meaning: "迷信者所谓天地万物的\"创造者\"和\"主宰者\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0228",
    type: "character",
    title: "总",
    content: "总",
    pronunciation: "zǒnɡ",
    meaning: "全，全部，主要的，为首的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0229",
    type: "character",
    title: "何",
    content: "何",
    pronunciation: "hé",
    meaning: "疑问词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0230",
    type: "character",
    title: "电",
    content: "电",
    pronunciation: "diàn",
    meaning: ",其光曰电。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0231",
    type: "character",
    title: "数",
    content: "数",
    pronunciation: "shù",
    meaning: "屡次，经常频",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0232",
    type: "character",
    title: "安",
    content: "安",
    pronunciation: "ān",
    meaning: "平静，稳定平",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0233",
    type: "character",
    title: "少",
    content: "少",
    pronunciation: "shǎo",
    meaning: "缺，不足，数量小，不经常，跟\"多\"相对缺",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0234",
    type: "character",
    title: "报",
    content: "报",
    pronunciation: "bào",
    meaning: "闻死刑之报,君为流涕。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0235",
    type: "character",
    title: "才",
    content: "才",
    pronunciation: "cái",
    meaning: "有才能;有本领",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0236",
    type: "character",
    title: "结",
    content: "结",
    pronunciation: "jié",
    meaning: "系，编织，扎缚打",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0237",
    type: "character",
    title: "反",
    content: "反",
    pronunciation: "fǎn",
    meaning: "翻转，颠倒，与\"正\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0238",
    type: "character",
    title: "受",
    content: "受",
    pronunciation: "shòu",
    meaning: "接纳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0239",
    type: "character",
    title: "目",
    content: "目",
    pronunciation: "mù",
    meaning: "眼睛",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0240",
    type: "character",
    title: "太",
    content: "太",
    pronunciation: "tài",
    meaning: "过于，过分",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0241",
    type: "character",
    title: "量",
    content: "量",
    pronunciation: "liànɡ",
    meaning: "量具，计算东西体积多少的器具，如升、斗、量杯等",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0242",
    type: "character",
    title: "再",
    content: "再",
    pronunciation: "zài",
    meaning: "又一次，第二次",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0243",
    type: "character",
    title: "感",
    content: "感",
    pronunciation: "ɡǎn",
    meaning: "觉得",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0244",
    type: "character",
    title: "建",
    content: "建",
    pronunciation: "jiàn",
    meaning: "设立，创立",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0245",
    type: "character",
    title: "务",
    content: "务",
    pronunciation: "wù",
    meaning: "致力，从事",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0246",
    type: "character",
    title: "做",
    content: "做",
    pronunciation: "zuò",
    meaning: "干，工作或活动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0247",
    type: "character",
    title: "接",
    content: "接",
    pronunciation: "jiē",
    meaning: "连，连着",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0248",
    type: "character",
    title: "必",
    content: "必",
    pronunciation: "bì",
    meaning: "标杆;标准",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0249",
    type: "character",
    title: "场",
    content: "场",
    pronunciation: "chǎnɡ",
    meaning: "许多人聚集的、活动的或事情发生的地方",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0250",
    type: "character",
    title: "件",
    content: "件",
    pronunciation: "jiàn",
    meaning: "量词两",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0251",
    type: "character",
    title: "计",
    content: "计",
    pronunciation: "jì",
    meaning: "算，算帐，核算",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0252",
    type: "character",
    title: "管",
    content: "管",
    pronunciation: "ɡuǎn",
    meaning: "吹奏的乐器，有笙、箫、笛等，统称管乐器",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0253",
    type: "character",
    title: "期",
    content: "期",
    pronunciation: "qī",
    meaning: "〈古〉周年，一个月",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0254",
    type: "character",
    title: "市",
    content: "市",
    pronunciation: "shì",
    meaning: "做买卖的场所",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0255",
    type: "character",
    title: "直",
    content: "直",
    pronunciation: "zhí",
    meaning: "端正，不弯折，跟\"曲\"相对坐",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0256",
    type: "character",
    title: "德",
    content: "德",
    pronunciation: "dé",
    meaning: "通得。取得,获得",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0257",
    type: "character",
    title: "资",
    content: "资",
    pronunciation: "zī",
    meaning: "钱财，费用",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0258",
    type: "character",
    title: "命",
    content: "命",
    pronunciation: "mìnɡ",
    meaning: "生命，生物的生活能力活",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0260",
    type: "character",
    title: "金",
    content: "金",
    pronunciation: "jīn",
    meaning: "金属元素之一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0261",
    type: "character",
    title: "指",
    content: "指",
    pronunciation: "zhǐ",
    meaning: "手指拇",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0262",
    type: "character",
    title: "克",
    content: "克",
    pronunciation: "kè",
    meaning: "⒋尅）kè",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0263",
    type: "character",
    title: "许",
    content: "许",
    pronunciation: "xǔ",
    meaning: "应允，认可",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0264",
    type: "character",
    title: "统",
    content: "统",
    pronunciation: "tǒnɡ",
    meaning: "丝的头绪抽其",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0265",
    type: "character",
    title: "区",
    content: "区",
    pronunciation: "qū",
    meaning: "一种中国古代容器。又用为容量单位",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0266",
    type: "character",
    title: "保",
    content: "保",
    pronunciation: "bǎo",
    meaning: "护养;育",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0267",
    type: "character",
    title: "至",
    content: "至",
    pronunciation: "zhì",
    meaning: "到，到达",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0268",
    type: "character",
    title: "队",
    content: "队",
    pronunciation: "duì",
    meaning: "又如排队;纵队;横队",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0269",
    type: "character",
    title: "形",
    content: "形",
    pronunciation: "xínɡ",
    meaning: "样子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0270",
    type: "character",
    title: "社",
    content: "社",
    pronunciation: "shè",
    meaning: "〈古〉迷信指土地神",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0271",
    type: "character",
    title: "便",
    content: "便",
    pronunciation: "biàn",
    meaning: "腹大肥满的样子大腹",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0272",
    type: "character",
    title: "空",
    content: "空",
    pronunciation: "kōnɡ",
    meaning: "没有东西这里是",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0273",
    type: "character",
    title: "决",
    content: "决",
    pronunciation: "jué",
    meaning: "排除阻塞物，疏通水道",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0274",
    type: "character",
    title: "治",
    content: "治",
    pronunciation: "zhì",
    meaning: "管理",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0275",
    type: "character",
    title: "展",
    content: "展",
    pronunciation: "zhǎn",
    meaning: "伸开，舒张开",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0276",
    type: "character",
    title: "马",
    content: "马",
    pronunciation: "mǎ",
    meaning: "家畜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0277",
    type: "character",
    title: "科",
    content: "科",
    pronunciation: "kē",
    meaning: "类别",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0278",
    type: "character",
    title: "司",
    content: "司",
    pronunciation: "sī",
    meaning: "主管，掌管",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0279",
    type: "character",
    title: "五",
    content: "五",
    pronunciation: "wǔ",
    meaning: "数目字",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0280",
    type: "character",
    title: "基",
    content: "基",
    pronunciation: "jī",
    meaning: "建筑物的根脚屋",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0281",
    type: "character",
    title: "眼",
    content: "眼",
    pronunciation: "yǎn",
    meaning: "眼睛，视觉器官",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0282",
    type: "character",
    title: "书",
    content: "书",
    pronunciation: "shū",
    meaning: "写，记载",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0283",
    type: "character",
    title: "非",
    content: "非",
    pronunciation: "fēi",
    meaning: "不， 不是，不对，越出，不合理",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0284",
    type: "character",
    title: "则",
    content: "则",
    pronunciation: "zé",
    meaning: "规则，规律，制度准",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0285",
    type: "character",
    title: "听",
    content: "听",
    pronunciation: "tīnɡ",
    meaning: "用耳朵接受声音",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0286",
    type: "character",
    title: "白",
    content: "白",
    pronunciation: "bái",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0287",
    type: "character",
    title: "却",
    content: "却",
    pronunciation: "què",
    meaning: "退退",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0288",
    type: "character",
    title: "界",
    content: "界",
    pronunciation: "jiè",
    meaning: "地域的相交处县",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0289",
    type: "character",
    title: "达",
    content: "达",
    pronunciation: "dá",
    meaning: "同本义。泛指畅通",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0290",
    type: "character",
    title: "光",
    content: "光",
    pronunciation: "ɡuānɡ",
    meaning: "光线，照亮物体因而可用眼睛看到物体的那种东西",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0291",
    type: "character",
    title: "放",
    content: "放",
    pronunciation: "fànɡ",
    meaning: "解脱约束，获得自由解",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0292",
    type: "character",
    title: "强",
    content: "强",
    pronunciation: "qiánɡ",
    meaning: "硬要，迫使",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0293",
    type: "character",
    title: "即",
    content: "即",
    pronunciation: "jí",
    meaning: "便，立刻，马上立",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0294",
    type: "character",
    title: "像",
    content: "像",
    pronunciation: "xiànɡ",
    meaning: "相貌，绘画、雕塑等的图形肖",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0295",
    type: "character",
    title: "难",
    content: "难",
    pronunciation: "nán",
    meaning: "灾患灾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0296",
    type: "character",
    title: "且",
    content: "且",
    pronunciation: "qiě",
    meaning: "〈古〉文言语气词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0297",
    type: "character",
    title: "权",
    content: "权",
    pronunciation: "quán",
    meaning: "掌握、支配和指挥的力量",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0298",
    type: "character",
    title: "思",
    content: "思",
    pronunciation: "sī",
    meaning: "想，考虑",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0299",
    type: "character",
    title: "王",
    content: "王",
    pronunciation: "wánɡ",
    meaning: "国君国",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0300",
    type: "character",
    title: "象",
    content: "象",
    pronunciation: "xiànɡ",
    meaning: "现存的陆地上最大的哺乳动物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0301",
    type: "character",
    title: "完",
    content: "完",
    pronunciation: "wán",
    meaning: "齐全",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0302",
    type: "character",
    title: "设",
    content: "设",
    pronunciation: "shè",
    meaning: "布置，装置，安排",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0303",
    type: "character",
    title: "式",
    content: "式",
    pronunciation: "shì",
    meaning: "样子，外表中",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0304",
    type: "character",
    title: "色",
    content: "色",
    pronunciation: "sè",
    meaning: "颜色掉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0305",
    type: "character",
    title: "路",
    content: "路",
    pronunciation: "lù",
    meaning: "道，来往的通道",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0306",
    type: "character",
    title: "记",
    content: "记",
    pronunciation: "jì",
    meaning: "思念，把所见、所闻等事物保持在脑子里，跟\"忘\"相对惦",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0307",
    type: "character",
    title: "南",
    content: "南",
    pronunciation: "nán",
    meaning: "方位名⊥北相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0308",
    type: "character",
    title: "品",
    content: "品",
    pronunciation: "pǐn",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0309",
    type: "character",
    title: "住",
    content: "住",
    pronunciation: "zhù",
    meaning: "同本义(站住)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0310",
    type: "character",
    title: "告",
    content: "告",
    pronunciation: "ɡào",
    meaning: "用语言或文字让人知道",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0311",
    type: "character",
    title: "类",
    content: "类",
    pronunciation: "lèi",
    meaning: "种，具有共同特征事物的综合同",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0312",
    type: "character",
    title: "求",
    content: "求",
    pronunciation: "qiú",
    meaning: "寻找，想办法得到",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0313",
    type: "character",
    title: "据",
    content: "据",
    pronunciation: "jù",
    meaning: "占，占有占",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0314",
    type: "character",
    title: "程",
    content: "程",
    pronunciation: "chénɡ",
    meaning: "度量衡的总称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0315",
    type: "character",
    title: "北",
    content: "北",
    pronunciation: "běi",
    meaning: "方位名。与南相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0316",
    type: "character",
    title: "边",
    content: "边",
    pronunciation: "biān",
    meaning: "又如崖边;岸边;水池边;边侧(边沿,旁侧);边涯(边际;边缘",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0317",
    type: "character",
    title: "死",
    content: "死",
    pronunciation: "sǐ",
    meaning: "生物失去生命，跟\"活\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0318",
    type: "character",
    title: "张",
    content: "张",
    pronunciation: "zhānɡ",
    meaning: "将弦安在弓上",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0319",
    type: "character",
    title: "该",
    content: "该",
    pronunciation: "ɡāi",
    meaning: "应当应",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0320",
    type: "character",
    title: "交",
    content: "交",
    pronunciation: "jiāo",
    meaning: "付给，付托",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0321",
    type: "character",
    title: "规",
    content: "规",
    pronunciation: "ɡuī",
    meaning: "画圆形的工具圆",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0322",
    type: "character",
    title: "万",
    content: "万",
    pronunciation: "wàn",
    meaning: "虫名。蝎。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0323",
    type: "character",
    title: "取",
    content: "取",
    pronunciation: "qǔ",
    meaning: "拿，得到",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0324",
    type: "character",
    title: "拉",
    content: "拉",
    pronunciation: "lā",
    meaning: "牵，拽，扯",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0325",
    type: "character",
    title: "格",
    content: "格",
    pronunciation: "ɡé",
    meaning: "划分成空栏或框子方",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0326",
    type: "character",
    title: "望",
    content: "望",
    pronunciation: "wànɡ",
    meaning: "向远处看，看得见远",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0327",
    type: "character",
    title: "觉",
    content: "觉",
    pronunciation: "jué",
    meaning: "睡眠午",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0328",
    type: "character",
    title: "术",
    content: "术",
    pronunciation: "shù",
    meaning: "植物名",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0329",
    type: "character",
    title: "领",
    content: "领",
    pronunciation: "lǐnɡ",
    meaning: "脖子引",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0330",
    type: "character",
    title: "共",
    content: "共",
    pronunciation: "ɡònɡ",
    meaning: "同，一样，一道",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0331",
    type: "character",
    title: "确",
    content: "确",
    pronunciation: "què",
    meaning: "坚定;坚决",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0332",
    type: "character",
    title: "传",
    content: "传",
    pronunciation: "chuán",
    meaning: "又如传度(传授);传派(传授的流派);传旨(传授意旨);传书",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0333",
    type: "character",
    title: "师",
    content: "师",
    pronunciation: "shī",
    meaning: "老师，导师教",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0334",
    type: "character",
    title: "观",
    content: "观",
    pronunciation: "ɡuān",
    meaning: "又如观觑(",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0335",
    type: "character",
    title: "清",
    content: "清",
    pronunciation: "qīnɡ",
    meaning: "明晰，纯洁透明，跟\"浊\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0336",
    type: "character",
    title: "今",
    content: "今",
    pronunciation: "jīn",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0337",
    type: "character",
    title: "切",
    content: "切",
    pronunciation: "qiē",
    meaning: "割开，截断",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0338",
    type: "character",
    title: "院",
    content: "院",
    pronunciation: "yuàn",
    meaning: "房屋围墙里面的空地",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0339",
    type: "character",
    title: "让",
    content: "让",
    pronunciation: "rànɡ",
    meaning: "不争，尽给旁人谦",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0340",
    type: "character",
    title: "识",
    content: "识",
    pronunciation: "shí",
    meaning: "知道，认得，能辨别",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0341",
    type: "character",
    title: "候",
    content: "候",
    pronunciation: "hòu",
    meaning: "等待",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0342",
    type: "character",
    title: "带",
    content: "带",
    pronunciation: "dài",
    meaning: "①带子或带状物鞋～、车～。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0343",
    type: "character",
    title: "导",
    content: "导",
    pronunciation: "dǎo",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0344",
    type: "character",
    title: "争",
    content: "争",
    pronunciation: "zhēnɡ",
    meaning: "夺，力求得到，互不相让",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0345",
    type: "character",
    title: "运",
    content: "运",
    pronunciation: "yùn",
    meaning: "转动，移动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0346",
    type: "character",
    title: "笑",
    content: "笑",
    pronunciation: "xiào",
    meaning: "露出喜悦的表情，发出欢乐的声音微",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0347",
    type: "character",
    title: "飞",
    content: "飞",
    pronunciation: "fēi",
    meaning: "鸟类或虫类等利用翅膀在空中活动小鸟群",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0348",
    type: "character",
    title: "风",
    content: "风",
    pronunciation: "fēnɡ",
    meaning: "流动着的空气，多是大致与地面平行东",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0349",
    type: "character",
    title: "步",
    content: "步",
    pronunciation: "bù",
    meaning: "以脚步测量远近",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0350",
    type: "character",
    title: "改",
    content: "改",
    pronunciation: "ɡǎi",
    meaning: "变革，更换",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0351",
    type: "character",
    title: "收",
    content: "收",
    pronunciation: "shōu",
    meaning: "接到，接受，接纳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0352",
    type: "character",
    title: "根",
    content: "根",
    pronunciation: "ɡēn",
    meaning: "高等植物的营养器官之一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0353",
    type: "character",
    title: "干",
    content: "干",
    pronunciation: "ɡàn",
    meaning: "盾牌执",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0354",
    type: "character",
    title: "造",
    content: "造",
    pronunciation: "zào",
    meaning: "做，制作制",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0355",
    type: "character",
    title: "言",
    content: "言",
    pronunciation: "yán",
    meaning: "话语",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0356",
    type: "character",
    title: "联",
    content: "联",
    pronunciation: "lián",
    meaning: "连结，结合",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0357",
    type: "character",
    title: "持",
    content: "持",
    pronunciation: "chí",
    meaning: "拿着，撑住，支撑",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0358",
    type: "character",
    title: "组",
    content: "组",
    pronunciation: "zǔ",
    meaning: "〈古〉丝带，编织织",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0359",
    type: "character",
    title: "每",
    content: "每",
    pronunciation: "měi",
    meaning: "各，任何一个或一组",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0360",
    type: "character",
    title: "济",
    content: "济",
    pronunciation: "jì",
    meaning: "济水，〈古〉水名",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0361",
    type: "character",
    title: "车",
    content: "车",
    pronunciation: "chē",
    meaning: "象旗中的一种棋子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0362",
    type: "character",
    title: "亲",
    content: "亲",
    pronunciation: "qīn",
    meaning: "父母双",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0363",
    type: "character",
    title: "极",
    content: "极",
    pronunciation: "jí",
    meaning: "顶端，最高点，尽头处",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0364",
    type: "character",
    title: "林",
    content: "林",
    pronunciation: "lín",
    meaning: "成片的树木或竹子等树",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0365",
    type: "character",
    title: "服",
    content: "服",
    pronunciation: "fú",
    meaning: "衣裳，衣装",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0366",
    type: "character",
    title: "快",
    content: "快",
    pronunciation: "kuài",
    meaning: "迅速，跟\"慢\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0367",
    type: "character",
    title: "办",
    content: "办",
    pronunciation: "bàn",
    meaning: "又如办案;办事;办理",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0368",
    type: "character",
    title: "议",
    content: "议",
    pronunciation: "yì",
    meaning: "意见，言论，主张提",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0369",
    type: "character",
    title: "往",
    content: "往",
    pronunciation: "wǎnɡ",
    meaning: "去，到有来有",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0370",
    type: "character",
    title: "元",
    content: "元",
    pronunciation: "yuán",
    meaning: "头归其",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0371",
    type: "character",
    title: "英",
    content: "英",
    pronunciation: "yīnɡ",
    meaning: "花秋菊之落",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0372",
    type: "character",
    title: "士",
    content: "士",
    pronunciation: "shì",
    meaning: "〈古〉指男子，特指未婚男子以谷我",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0373",
    type: "character",
    title: "证",
    content: "证",
    pronunciation: "zhènɡ",
    meaning: "以人物、事实来表明或断定",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0374",
    type: "character",
    title: "近",
    content: "近",
    pronunciation: "jìn",
    meaning: "近，跟\"远\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0375",
    type: "character",
    title: "失",
    content: "失",
    pronunciation: "shī",
    meaning: "丢，掉丢",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0376",
    type: "character",
    title: "转",
    content: "转",
    pronunciation: "zhuǎn",
    meaning: "旋动，改变方向、位置或情势等",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0377",
    type: "character",
    title: "夫",
    content: "夫",
    pronunciation: "fū",
    meaning: "旧时对成年男子的通称农",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0378",
    type: "character",
    title: "令",
    content: "令",
    pronunciation: "lìnɡ",
    meaning: "上级的指示命",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0379",
    type: "character",
    title: "准",
    content: "准",
    pronunciation: "zhǔn",
    meaning: "允许，许可",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0380",
    type: "character",
    title: "布",
    content: "布",
    pronunciation: "bù",
    meaning: "同本义(古时无棉布)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0381",
    type: "character",
    title: "始",
    content: "始",
    pronunciation: "shǐ",
    meaning: "起头，最初，当初开",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0382",
    type: "character",
    title: "怎",
    content: "怎",
    pronunciation: "zěn",
    meaning: "如何",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0383",
    type: "character",
    title: "呢",
    content: "呢",
    pronunciation: "ne",
    meaning: "助词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0384",
    type: "character",
    title: "存",
    content: "存",
    pronunciation: "cún",
    meaning: "又如存济(存活;活命);存殁(活着的和死去的)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0385",
    type: "character",
    title: "未",
    content: "未",
    pronunciation: "wèi",
    meaning: "没有，不曾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0386",
    type: "character",
    title: "远",
    content: "远",
    pronunciation: "yuǎn",
    meaning: "空间或时间的距离长，跟\"近\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0387",
    type: "character",
    title: "叫",
    content: "叫",
    pronunciation: "jiào",
    meaning: "呼喊呼",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0388",
    type: "character",
    title: "台",
    content: "台",
    pronunciation: "tái",
    meaning: "高而平的建筑物戏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0389",
    type: "character",
    title: "单",
    content: "单",
    pronunciation: "dān",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0390",
    type: "character",
    title: "影",
    content: "影",
    pronunciation: "yǐnɡ",
    meaning: "人或物挡住光线所产生的阴暗形像，或因反射而显现的虚像人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0391",
    type: "character",
    title: "具",
    content: "具",
    pronunciation: "jù",
    meaning: "器物器",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0392",
    type: "character",
    title: "罗",
    content: "罗",
    pronunciation: "luó",
    meaning: "捕鸟的网",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0393",
    type: "character",
    title: "字",
    content: "字",
    pronunciation: "zì",
    meaning: "记录语言的符号",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0394",
    type: "character",
    title: "爱",
    content: "爱",
    pronunciation: "ài",
    meaning: "对人或事物有真诚、深厚的感情",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0395",
    type: "character",
    title: "击",
    content: "击",
    pronunciation: "jī",
    meaning: "打，敲打",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0396",
    type: "character",
    title: "流",
    content: "流",
    pronunciation: "liú",
    meaning: "水或其它液体移动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0397",
    type: "character",
    title: "备",
    content: "备",
    pronunciation: "bèi",
    meaning: "又如傥荡不备(行为无拘无束,不谨慎)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0398",
    type: "character",
    title: "兵",
    content: "兵",
    pronunciation: "bīnɡ",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0399",
    type: "character",
    title: "连",
    content: "连",
    pronunciation: "lián",
    meaning: "连接，相接",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0400",
    type: "character",
    title: "调",
    content: "调",
    pronunciation: "diào",
    meaning: "配合均匀适当",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0401",
    type: "character",
    title: "深",
    content: "深",
    pronunciation: "shēn",
    meaning: "从水面到水底的距离或距离大，跟\"浅\"相对水",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0402",
    type: "character",
    title: "商",
    content: "商",
    pronunciation: "shānɡ",
    meaning: "买卖，做生意，也指做生意的人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0403",
    type: "character",
    title: "算",
    content: "算",
    pronunciation: "suàn",
    meaning: "核计，计数核",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0404",
    type: "character",
    title: "质",
    content: "质",
    pronunciation: "zhì",
    meaning: "本体，本性物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0405",
    type: "character",
    title: "团",
    content: "团",
    pronunciation: "tuán",
    meaning: "糰）tuán",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0406",
    type: "character",
    title: "集",
    content: "集",
    pronunciation: "jí",
    meaning: "聚，合，会合，总合",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0407",
    type: "character",
    title: "百",
    content: "百",
    pronunciation: "bǎi",
    meaning: "十个十。一百,100",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0408",
    type: "character",
    title: "需",
    content: "需",
    pronunciation: "xū",
    meaning: "要求，应该有，必须有",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0409",
    type: "character",
    title: "价",
    content: "价",
    pronunciation: "jià",
    meaning: "商品所值的钱数",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0411",
    type: "character",
    title: "党",
    content: "党",
    pronunciation: "dǎnɡ",
    meaning: "与现代汉语不同)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0412",
    type: "character",
    title: "华",
    content: "华",
    pronunciation: "huá",
    meaning: "中华民族或中国的简称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0413",
    type: "character",
    title: "城",
    content: "城",
    pronunciation: "chénɡ",
    meaning: "〈古〉为了防卫而建筑的高墙万里长",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0414",
    type: "character",
    title: "石",
    content: "石",
    pronunciation: "shí",
    meaning: "构成地壳的矿物质硬块",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0415",
    type: "character",
    title: "级",
    content: "级",
    pronunciation: "jí",
    meaning: "等次等",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0416",
    type: "character",
    title: "整",
    content: "整",
    pronunciation: "zhěnɡ",
    meaning: "不乱，有秩序",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0417",
    type: "character",
    title: "府",
    content: "府",
    pronunciation: "fǔ",
    meaning: "官署的通称，现指国家政权机关官",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0418",
    type: "character",
    title: "离",
    content: "离",
    pronunciation: "lí",
    meaning: "分开，分别",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0419",
    type: "character",
    title: "况",
    content: "况",
    pronunciation: "kuànɡ",
    meaning: "情形，状态情",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0420",
    type: "character",
    title: "亚",
    content: "亚",
    pronunciation: "yà",
    meaning: "次，第二的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0421",
    type: "character",
    title: "请",
    content: "请",
    pronunciation: "qǐnɡ",
    meaning: "求，请求",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0422",
    type: "character",
    title: "技",
    content: "技",
    pronunciation: "jì",
    meaning: "手艺，才能，本领",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0423",
    type: "character",
    title: "际",
    content: "际",
    pronunciation: "jì",
    meaning: "交界处，边缘处海",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0424",
    type: "character",
    title: "约",
    content: "约",
    pronunciation: "yuē",
    meaning: "〈古〉套，捆缚",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0425",
    type: "character",
    title: "示",
    content: "示",
    pronunciation: "shì",
    meaning: "表明，给人看，使人知道表",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0426",
    type: "character",
    title: "复",
    content: "复",
    pronunciation: "fù",
    meaning: "返，回去往",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0427",
    type: "character",
    title: "病",
    content: "病",
    pronunciation: "bìnɡ",
    meaning: "又如病革(病势危急将死);病亟(病革)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0428",
    type: "character",
    title: "息",
    content: "息",
    pronunciation: "xī",
    meaning: "呼吸喘",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0429",
    type: "character",
    title: "究",
    content: "究",
    pronunciation: "jiū",
    meaning: "终极，到底终",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0430",
    type: "character",
    title: "线",
    content: "线",
    pronunciation: "xiàn",
    meaning: "棉、麻、丝、毛、锦纶或金属等制成的细长东西棉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0431",
    type: "character",
    title: "似",
    content: "似",
    pronunciation: "sì",
    meaning: "⒈像。相像类～。相～。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0432",
    type: "character",
    title: "官",
    content: "官",
    pronunciation: "ɡuān",
    meaning: "政府机关或军队里担任职务并有一定级别的人员，我国现多用于军队",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0434",
    type: "character",
    title: "断",
    content: "断",
    pronunciation: "duàn",
    meaning: "切肉肉断而发",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0435",
    type: "character",
    title: "精",
    content: "精",
    pronunciation: "jīnɡ",
    meaning: "细，细密，跟\"粗\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0436",
    type: "character",
    title: "满",
    content: "满",
    pronunciation: "mǎn",
    meaning: "又如满口胡柴(满口胡说);满坑满谷(形容积聚得特多);满面生",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0437",
    type: "character",
    title: "支",
    content: "支",
    pronunciation: "zhī",
    meaning: "撑持",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0438",
    type: "character",
    title: "视",
    content: "视",
    pronunciation: "shì",
    meaning: "又如视探(看望,探望);",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0439",
    type: "character",
    title: "消",
    content: "消",
    pronunciation: "xiāo",
    meaning: "溶解，散失",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0440",
    type: "character",
    title: "越",
    content: "越",
    pronunciation: "yuè",
    meaning: "经过",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0441",
    type: "character",
    title: "器",
    content: "器",
    pronunciation: "qì",
    meaning: "用具瓷",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0442",
    type: "character",
    title: "容",
    content: "容",
    pronunciation: "rónɡ",
    meaning: "盛，包含",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0443",
    type: "character",
    title: "照",
    content: "照",
    pronunciation: "zhào",
    meaning: "光线射着",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0444",
    type: "character",
    title: "须",
    content: "须",
    pronunciation: "xū",
    meaning: "野兽的魀。泛指动、",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0445",
    type: "character",
    title: "九",
    content: "九",
    pronunciation: "jiǔ",
    meaning: "数目字",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0446",
    type: "character",
    title: "增",
    content: "增",
    pronunciation: "zēnɡ",
    meaning: "又如增年(加寿;年龄增加);增增(众多的样子);增奉(增加俸",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0447",
    type: "character",
    title: "研",
    content: "研",
    pronunciation: "yán",
    meaning: "细磨，细碾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0448",
    type: "character",
    title: "写",
    content: "写",
    pronunciation: "xiě",
    meaning: "摹画，描述",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0449",
    type: "character",
    title: "称",
    content: "称",
    pronunciation: "chēnɡ",
    meaning: "衡量轻重",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0450",
    type: "character",
    title: "企",
    content: "企",
    pronunciation: "qǐ",
    meaning: "踮起脚后跟，盼望， 仰望",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0451",
    type: "character",
    title: "八",
    content: "八",
    pronunciation: "bā",
    meaning: "七加一的和",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0452",
    type: "character",
    title: "功",
    content: "功",
    pronunciation: "ɡōnɡ",
    meaning: "成绩突出，贡献大",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0453",
    type: "character",
    title: "吗",
    content: "吗",
    pronunciation: "ma",
    meaning: "助词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0454",
    type: "character",
    title: "包",
    content: "包",
    pronunciation: "bāo",
    meaning: "用纸、布等裹东西",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0455",
    type: "character",
    title: "片",
    content: "片",
    pronunciation: "piàn",
    meaning: "破开的木或草木",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0456",
    type: "character",
    title: "史",
    content: "史",
    pronunciation: "shǐ",
    meaning: "自然或社会以往发展的进程历",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0457",
    type: "character",
    title: "委",
    content: "委",
    pronunciation: "wěi",
    meaning: "任，派，托付",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0458",
    type: "character",
    title: "乎",
    content: "乎",
    pronunciation: "hū",
    meaning: "文言助词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0459",
    type: "character",
    title: "查",
    content: "查",
    pronunciation: "chá",
    meaning: "考察，审核",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0460",
    type: "character",
    title: "轻",
    content: "轻",
    pronunciation: "qīnɡ",
    meaning: "份量小，跟\"重\"相对这张桌子较",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0461",
    type: "character",
    title: "易",
    content: "易",
    pronunciation: "yì",
    meaning: "好办，不费力容",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0462",
    type: "character",
    title: "早",
    content: "早",
    pronunciation: "zǎo",
    meaning: "太阳升起的时候",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0463",
    type: "character",
    title: "曾",
    content: "曾",
    pronunciation: "cénɡ",
    meaning: "重，指中间隔着两代的亲属",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0464",
    type: "character",
    title: "除",
    content: "除",
    pronunciation: "chú",
    meaning: "去掉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0465",
    type: "character",
    title: "农",
    content: "农",
    pronunciation: "nónɡ",
    meaning: "种庄稼，种庄稼的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0466",
    type: "character",
    title: "找",
    content: "找",
    pronunciation: "zhǎo",
    meaning: "觅取，寻求，想要得到你",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0467",
    type: "character",
    title: "装",
    content: "装",
    pronunciation: "zhuānɡ",
    meaning: "行李行",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0468",
    type: "character",
    title: "广",
    content: "广",
    pronunciation: "ɡuǎnɡ",
    meaning: "小寺庙",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0469",
    type: "character",
    title: "显",
    content: "显",
    pronunciation: "xiǎn",
    meaning: "露在外面，易于看出",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0470",
    type: "character",
    title: "吧",
    content: "吧",
    pronunciation: "bā",
    meaning: "像东西爆烈或撞击的声音",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0471",
    type: "character",
    title: "阿",
    content: "阿",
    pronunciation: "ā",
    meaning: "助词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0472",
    type: "character",
    title: "李",
    content: "李",
    pronunciation: "lǐ",
    meaning: "同本义。落叶乔木,春天开白色花,果实叫李子,熟时黄色或紫红色",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0473",
    type: "character",
    title: "标",
    content: "标",
    pronunciation: "biāo",
    meaning: "又如标枝(树梢的枝条);标末(树梢)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0474",
    type: "character",
    title: "谈",
    content: "谈",
    pronunciation: "tán",
    meaning: "说，对话言",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0475",
    type: "character",
    title: "吃",
    content: "吃",
    pronunciation: "chī",
    meaning: "吃东西",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0476",
    type: "character",
    title: "图",
    content: "图",
    pronunciation: "tú",
    meaning: "画画影",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0477",
    type: "character",
    title: "念",
    content: "念",
    pronunciation: "niàn",
    meaning: "惦记，常思常想惦",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0478",
    type: "character",
    title: "六",
    content: "六",
    pronunciation: "liù",
    meaning: "数目字五",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0479",
    type: "character",
    title: "引",
    content: "引",
    pronunciation: "yǐn",
    meaning: "导，领，率领",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0480",
    type: "character",
    title: "历",
    content: "历",
    pronunciation: "lì",
    meaning: "曆、",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0481",
    type: "character",
    title: "首",
    content: "首",
    pronunciation: "shǒu",
    meaning: "亦指怀念故乡);首身",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0482",
    type: "character",
    title: "医",
    content: "医",
    pronunciation: "yī",
    meaning: "治病",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0483",
    type: "character",
    title: "局",
    content: "局",
    pronunciation: "jú",
    meaning: "促乡里(碌碌无为地呆在乡里)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0484",
    type: "character",
    title: "突",
    content: "突",
    pronunciation: "tū",
    meaning: "鼓起，凸出来",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0485",
    type: "character",
    title: "专",
    content: "专",
    pronunciation: "zhuān",
    meaning: "独，独有，独占",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0486",
    type: "character",
    title: "费",
    content: "费",
    pronunciation: "fèi",
    meaning: "消耗，花掉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0487",
    type: "character",
    title: "号",
    content: "号",
    pronunciation: "hào",
    meaning: "名称称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0488",
    type: "character",
    title: "尽",
    content: "尽",
    pronunciation: "jìn",
    meaning: "力所能及的限度",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0489",
    type: "character",
    title: "另",
    content: "另",
    pronunciation: "lìnɡ",
    meaning: "分居,分开居住而各自谋生",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0490",
    type: "character",
    title: "周",
    content: "周",
    pronunciation: "zhōu",
    meaning: "环绕，循环绕场一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0491",
    type: "character",
    title: "较",
    content: "较",
    pronunciation: "jiào",
    meaning: "比，比较",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0492",
    type: "character",
    title: "注",
    content: "注",
    pronunciation: "zhù",
    meaning: "记载，登记",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0493",
    type: "character",
    title: "语",
    content: "语",
    pronunciation: "yǔ",
    meaning: "说，谈寡言少",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0494",
    type: "character",
    title: "仅",
    content: "仅",
    pronunciation: "jǐn",
    meaning: "只，不过",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0495",
    type: "character",
    title: "考",
    content: "考",
    pronunciation: "kǎo",
    meaning: "又如考寿(长寿);考终(考终年);考终年(享尽天年)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0496",
    type: "character",
    title: "落",
    content: "落",
    pronunciation: "luò",
    meaning: "某些口头用语，如",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0497",
    type: "character",
    title: "青",
    content: "青",
    pronunciation: "qīnɡ",
    meaning: "颜色",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0498",
    type: "character",
    title: "随",
    content: "随",
    pronunciation: "suí",
    meaning: "跟着，沿着，顺着",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0499",
    type: "character",
    title: "选",
    content: "选",
    pronunciation: "xuǎn",
    meaning: "择，挑拣",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0500",
    type: "character",
    title: "列",
    content: "列",
    pronunciation: "liè",
    meaning: "排队，摆出，安排",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0501",
    type: "character",
    title: "武",
    content: "武",
    pronunciation: "wǔ",
    meaning: "关于军事或技击的，跟\"文\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0502",
    type: "character",
    title: "红",
    content: "红",
    pronunciation: "hónɡ",
    meaning: "又如红衣(荷花瓣儿);红香(花瓣);红脂(蟹黄)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0503",
    type: "character",
    title: "响",
    content: "响",
    pronunciation: "xiǎnɡ",
    meaning: "声音",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0504",
    type: "character",
    title: "虽",
    content: "虽",
    pronunciation: "suī",
    meaning: "连词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0505",
    type: "character",
    title: "推",
    content: "推",
    pronunciation: "tuī",
    meaning: "抵住物体并用力使它移动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0506",
    type: "character",
    title: "势",
    content: "势",
    pronunciation: "shì",
    meaning: "力量，权力，威力",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0507",
    type: "character",
    title: "参",
    content: "参",
    pronunciation: "cān",
    meaning: "又如参选(参加盐);参纂(参加编纂)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0508",
    type: "character",
    title: "希",
    content: "希",
    pronunciation: "xī",
    meaning: "盼望，期望",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0509",
    type: "character",
    title: "古",
    content: "古",
    pronunciation: "ɡǔ",
    meaning: "很久以前的，过去的，跟\"今\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0510",
    type: "character",
    title: "众",
    content: "众",
    pronunciation: "zhònɡ",
    meaning: "多，许多",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0511",
    type: "character",
    title: "构",
    content: "构",
    pronunciation: "ɡòu",
    meaning: "架，各部件的组合",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0512",
    type: "character",
    title: "房",
    content: "房",
    pronunciation: "fánɡ",
    meaning: "室，屋",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0513",
    type: "character",
    title: "半",
    content: "半",
    pronunciation: "bàn",
    meaning: "又如太半(三分之二);半日;半工;半升",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0514",
    type: "character",
    title: "节",
    content: "节",
    pronunciation: "jié",
    meaning: "榞枅祵溃樬蕩畧?",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0515",
    type: "character",
    title: "土",
    content: "土",
    pronunciation: "tǔ",
    meaning: "沙泥等的混合物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0516",
    type: "character",
    title: "投",
    content: "投",
    pronunciation: "tóu",
    meaning: "抛，掷，扔",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0517",
    type: "character",
    title: "某",
    content: "某",
    pronunciation: "mǒu",
    meaning: "代词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0518",
    type: "character",
    title: "案",
    content: "案",
    pronunciation: "àn",
    meaning: "长方形的桌子书",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0519",
    type: "character",
    title: "黑",
    content: "黑",
    pronunciation: "hēi",
    meaning: "像煤或墨的颜色，跟\"白\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0520",
    type: "character",
    title: "维",
    content: "维",
    pronunciation: "wéi",
    meaning: "系物的大绳地",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0521",
    type: "character",
    title: "革",
    content: "革",
    pronunciation: "ɡé",
    meaning: "去毛加工制成的兽皮制",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0522",
    type: "character",
    title: "划",
    content: "划",
    pronunciation: "huá",
    meaning: "用尖锐的东西把别的物体分割开",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0523",
    type: "character",
    title: "敌",
    content: "敌",
    pronunciation: "dí",
    meaning: "抵抗;抵挡",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0524",
    type: "character",
    title: "致",
    content: "致",
    pronunciation: "zhì",
    meaning: "给，送达",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0525",
    type: "character",
    title: "陈",
    content: "陈",
    pronunciation: "chén",
    meaning: "战阵;行列",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0526",
    type: "character",
    title: "律",
    content: "律",
    pronunciation: "lǜ",
    meaning: "规章，法则，法令规",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0527",
    type: "character",
    title: "足",
    content: "足",
    pronunciation: "zú",
    meaning: "⒈脚～迹。手舞～蹈。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0528",
    type: "character",
    title: "态",
    content: "态",
    pronunciation: "tài",
    meaning: "形状，样子形",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0529",
    type: "character",
    title: "护",
    content: "护",
    pronunciation: "hù",
    meaning: "保卫，照顾",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0530",
    type: "character",
    title: "七",
    content: "七",
    pronunciation: "qī",
    meaning: "国时秦、韩、魏",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0531",
    type: "character",
    title: "兴",
    content: "兴",
    pronunciation: "xīnɡ",
    meaning: "起，起来",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0532",
    type: "character",
    title: "派",
    content: "派",
    pronunciation: "pai",
    meaning: "水的支流，泛指支系流",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0533",
    type: "character",
    title: "孩",
    content: "孩",
    pronunciation: "hái",
    meaning: "同本义。同咳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0534",
    type: "character",
    title: "验",
    content: "验",
    pronunciation: "yàn",
    meaning: "检查，察看",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0535",
    type: "character",
    title: "责",
    content: "责",
    pronunciation: "zé",
    meaning: "分内应做的事",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0536",
    type: "character",
    title: "营",
    content: "营",
    pronunciation: "yínɡ",
    meaning: "经管，料理经",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0537",
    type: "character",
    title: "星",
    content: "星",
    pronunciation: "xīnɡ",
    meaning: "天空中能看见的有亮光的天体，通常是指夜间天空中有亮光的天体恒",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0538",
    type: "character",
    title: "够",
    content: "够",
    pronunciation: "ɡòu",
    meaning: "足，一定限度上的满足足",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0539",
    type: "character",
    title: "章",
    content: "章",
    pronunciation: "zhānɡ",
    meaning: "音乐的一曲，诗歌文词等的段落乐",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0540",
    type: "character",
    title: "音",
    content: "音",
    pronunciation: "yīn",
    meaning: "声声",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0541",
    type: "character",
    title: "跟",
    content: "跟",
    pronunciation: "ɡēn",
    meaning: "脚的后部脚",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0542",
    type: "character",
    title: "志",
    content: "志",
    pronunciation: "zhì",
    meaning: "心意，意向，决心诗言",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0543",
    type: "character",
    title: "底",
    content: "底",
    pronunciation: "dǐ",
    meaning: "又如底止(结局);底着(停滞;滞留);底遏(遏止);底滞(滞",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0544",
    type: "character",
    title: "站",
    content: "站",
    pronunciation: "zhàn",
    meaning: "立，定",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0545",
    type: "character",
    title: "严",
    content: "严",
    pronunciation: "yán",
    meaning: "紧密，没有缝隙",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0546",
    type: "character",
    title: "巴",
    content: "巴",
    pronunciation: "bā",
    meaning: "古代传说中的一种大蛇",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0547",
    type: "character",
    title: "例",
    content: "例",
    pronunciation: "lì",
    meaning: "可以作为仿照或依据的事物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0548",
    type: "character",
    title: "防",
    content: "防",
    pronunciation: "fánɡ",
    meaning: "戒备，预置",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0549",
    type: "character",
    title: "族",
    content: "族",
    pronunciation: "zú",
    meaning: "有一定血统关系的人群之总称家",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0550",
    type: "character",
    title: "供",
    content: "供",
    pronunciation: "ɡònɡ",
    meaning: "奉献，多指向佛或死者摆设祭品",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0551",
    type: "character",
    title: "效",
    content: "效",
    pronunciation: "xiào",
    meaning: "成果，功用",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0552",
    type: "character",
    title: "续",
    content: "续",
    pronunciation: "xù",
    meaning: "连接，接上一段",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0553",
    type: "character",
    title: "施",
    content: "施",
    pronunciation: "shī",
    meaning: "实行，展示，发挥",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0554",
    type: "character",
    title: "留",
    content: "留",
    pronunciation: "liú",
    meaning: "停止在某处停",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0555",
    type: "character",
    title: "讲",
    content: "讲",
    pronunciation: "jiǎnɡ",
    meaning: "谈，说",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0556",
    type: "character",
    title: "型",
    content: "型",
    pronunciation: "xínɡ",
    meaning: "铸造器物用的模子",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0557",
    type: "character",
    title: "料",
    content: "料",
    pronunciation: "liào",
    meaning: "估计，猜想",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0558",
    type: "character",
    title: "终",
    content: "终",
    pronunciation: "zhōnɡ",
    meaning: "末了，完了，结束，跟\"始\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0559",
    type: "character",
    title: "答",
    content: "答",
    pronunciation: "dá",
    meaning: "回话;应对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0560",
    type: "character",
    title: "紧",
    content: "紧",
    pronunciation: "jǐn",
    meaning: "紧，跟\"松\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0561",
    type: "character",
    title: "黄",
    content: "黄",
    pronunciation: "huánɡ",
    meaning: "像油菜花或向日葵花的颜色金",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0562",
    type: "character",
    title: "绝",
    content: "绝",
    pronunciation: "jué",
    meaning: "断，隔断",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0563",
    type: "character",
    title: "奇",
    content: "奇",
    pronunciation: "qí",
    meaning: "罕见的，特殊的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0564",
    type: "character",
    title: "察",
    content: "察",
    pronunciation: "chá",
    meaning: "又如观察(仔细察看客观事物或现象);觉察(发觉,看出来)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0565",
    type: "character",
    title: "母",
    content: "母",
    pronunciation: "mǔ",
    meaning: "娘，妈妈，母亲",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0566",
    type: "character",
    title: "京",
    content: "京",
    pronunciation: "jīnɡ",
    meaning: "国都，首都",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0567",
    type: "character",
    title: "段",
    content: "段",
    pronunciation: "duàn",
    meaning: "又如段氏(锻工。古代金工六种之一。主要从事农具制作)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0568",
    type: "character",
    title: "依",
    content: "依",
    pronunciation: "yī",
    meaning: "靠着，仗赖",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0569",
    type: "character",
    title: "批",
    content: "批",
    pronunciation: "pī",
    meaning: "〈古〉用手打",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0570",
    type: "character",
    title: "群",
    content: "群",
    pronunciation: "qún",
    meaning: "〈古〉指羊群",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0571",
    type: "character",
    title: "项",
    content: "项",
    pronunciation: "xiànɡ",
    meaning: "颈子的后部",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0572",
    type: "character",
    title: "故",
    content: "故",
    pronunciation: "ɡù",
    meaning: "旧，过去的，跟\"新\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0573",
    type: "character",
    title: "按",
    content: "按",
    pronunciation: "àn",
    meaning: "使用手指头压",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0574",
    type: "character",
    title: "河",
    content: "河",
    pronunciation: "hé",
    meaning: "水道的通称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0575",
    type: "character",
    title: "米",
    content: "米",
    pronunciation: "mǐ",
    meaning: "脱壳的谷类，特指脱壳的稻谷子实",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0576",
    type: "character",
    title: "围",
    content: "围",
    pronunciation: "wéi",
    meaning: "环绕，圈拦住",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0577",
    type: "character",
    title: "江",
    content: "江",
    pronunciation: "jiānɡ",
    meaning: "泛指大的河流珠",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0578",
    type: "character",
    title: "织",
    content: "织",
    pronunciation: "zhī",
    meaning: "又如织纸(纺织缝紝);织紝(泛指织布。织是织布帛,紝是用以",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0579",
    type: "character",
    title: "害",
    content: "害",
    pronunciation: "hài",
    meaning: "祸患，坏处，跟\"利\"相对祸",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0580",
    type: "character",
    title: "斗",
    content: "斗",
    pronunciation: "dòu",
    meaning: "搏斗;引申为战斗",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0581",
    type: "character",
    title: "双",
    content: "双",
    pronunciation: "shuānɡ",
    meaning: "一对，两个",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0582",
    type: "character",
    title: "境",
    content: "境",
    pronunciation: "jìnɡ",
    meaning: "边界，疆界边",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0583",
    type: "character",
    title: "客",
    content: "客",
    pronunciation: "kè",
    meaning: "外来的人，请来的人，跟\"主\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0584",
    type: "character",
    title: "纪",
    content: "纪",
    pronunciation: "jì",
    meaning: "丝的头绪丝缕有",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0585",
    type: "character",
    title: "采",
    content: "采",
    pronunciation: "cǎi",
    meaning: "又如采花;采果子;采及葑菲(对别人征求意见时的谦辞)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0586",
    type: "character",
    title: "举",
    content: "举",
    pronunciation: "jǔ",
    meaning: "抬起，向上托",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0587",
    type: "character",
    title: "杀",
    content: "杀",
    pronunciation: "shā",
    meaning: "弄死，使失去生命",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0588",
    type: "character",
    title: "攻",
    content: "攻",
    pronunciation: "ɡōnɡ",
    meaning: "进击，打击，跟\"守\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0589",
    type: "character",
    title: "父",
    content: "父",
    pronunciation: "fù",
    meaning: "对老年人的尊称农夫渔",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0590",
    type: "character",
    title: "苏",
    content: "苏",
    pronunciation: "sū",
    meaning: "假死或昏迷后醒过来死而复",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0591",
    type: "character",
    title: "密",
    content: "密",
    pronunciation: "mì",
    meaning: "距离短，空隙小，跟\"稀\"、\"疏\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0592",
    type: "character",
    title: "低",
    content: "低",
    pronunciation: "dī",
    meaning: "向上伸展的长度相对较小的",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0593",
    type: "character",
    title: "朝",
    content: "朝",
    pronunciation: "cháo",
    meaning: "早晨省亲,子、媳向父母、公婆请安",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0594",
    type: "character",
    title: "友",
    content: "友",
    pronunciation: "yǒu",
    meaning: "彼此相好的人朋",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0595",
    type: "character",
    title: "诉",
    content: "诉",
    pronunciation: "sù",
    meaning: "叙说叙",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0596",
    type: "character",
    title: "止",
    content: "止",
    pronunciation: "zhǐ",
    meaning: "停住",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0597",
    type: "character",
    title: "细",
    content: "细",
    pronunciation: "xì",
    meaning: "微，小，跟\"大\"、\"巨\"、\"粗\"等相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0598",
    type: "character",
    title: "愿",
    content: "愿",
    pronunciation: "yuàn",
    meaning: "乐意",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0599",
    type: "character",
    title: "千",
    content: "千",
    pronunciation: "qiān",
    meaning: "数目十个百为一",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0600",
    type: "character",
    title: "值",
    content: "值",
    pronunciation: "zhí",
    meaning: "遇到，碰到",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0601",
    type: "character",
    title: "仍",
    content: "仍",
    pronunciation: "rénɡ",
    meaning: "接续;连续",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0602",
    type: "character",
    title: "男",
    content: "男",
    pronunciation: "nán",
    meaning: "男性，男人",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0603",
    type: "character",
    title: "钱",
    content: "钱",
    pronunciation: "qián",
    meaning: "货币",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0604",
    type: "character",
    title: "破",
    content: "破",
    pronunciation: "pò",
    meaning: "碎，残缺，不完整",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0605",
    type: "character",
    title: "网",
    content: "网",
    pronunciation: "wǎnɡ",
    meaning: "用绳线结成的渔猎工具撒",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0606",
    type: "character",
    title: "热",
    content: "热",
    pronunciation: "rè",
    meaning: "物理学上指凡能使物体温度升高的那种\"能\"叫\"热\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0607",
    type: "character",
    title: "助",
    content: "助",
    pronunciation: "zhù",
    meaning: "同本义(在物质上或精神上给予协助)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0608",
    type: "character",
    title: "倒",
    content: "倒",
    pronunciation: "dǎo",
    meaning: "失败,败落",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0609",
    type: "character",
    title: "育",
    content: "育",
    pronunciation: "yù",
    meaning: "生，生养不",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0610",
    type: "character",
    title: "属",
    content: "属",
    pronunciation: "shǔ",
    meaning: "类，同一类型的种",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0611",
    type: "character",
    title: "坐",
    content: "坐",
    pronunciation: "zuò",
    meaning: "跟\"立\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0612",
    type: "character",
    title: "帝",
    content: "帝",
    pronunciation: "dì",
    meaning: "天帝,上帝。宗教或神话中称主宰万物的神。最高的天神。古人想像",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0613",
    type: "character",
    title: "限",
    content: "限",
    pronunciation: "xiàn",
    meaning: "定范围",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0614",
    type: "character",
    title: "船",
    content: "船",
    pronunciation: "chuán",
    meaning: "也作舩人);船头(船的前部;船老大)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0615",
    type: "character",
    title: "脸",
    content: "脸",
    pronunciation: "liǎn",
    meaning: "面孔，头前部由额到下巴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0616",
    type: "character",
    title: "职",
    content: "职",
    pronunciation: "zhí",
    meaning: "分内应做的或所担任的事情",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0617",
    type: "character",
    title: "速",
    content: "速",
    pronunciation: "sù",
    meaning: "快，很快快",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0618",
    type: "character",
    title: "刻",
    content: "刻",
    pronunciation: "kè",
    meaning: "雕，刀子挖，铁笔划雕",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0619",
    type: "character",
    title: "乐",
    content: "乐",
    pronunciation: "lè",
    meaning: "快活，高兴快",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0620",
    type: "character",
    title: "否",
    content: "否",
    pronunciation: "fǒu",
    meaning: "又如这是妥当的办法吗?否",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0621",
    type: "character",
    title: "刚",
    content: "刚",
    pronunciation: "ɡānɡ",
    meaning: "坚硬，坚定，坚强跟\"柔\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0622",
    type: "character",
    title: "威",
    content: "威",
    pronunciation: "wēi",
    meaning: "尊严，声誉，名望",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0623",
    type: "character",
    title: "毛",
    content: "毛",
    pronunciation: "máo",
    meaning: "动植物的皮上所生的丝状物羽",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0624",
    type: "character",
    title: "状",
    content: "状",
    pronunciation: "zhuànɡ",
    meaning: "样子，形态，情形",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0625",
    type: "character",
    title: "率",
    content: "率",
    pronunciation: "lǜ",
    meaning: "带领，统领，主将",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0626",
    type: "character",
    title: "独",
    content: "独",
    pronunciation: "dú",
    meaning: "不见秘书心若失,百年衰病独登台",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0627",
    type: "character",
    title: "球",
    content: "球",
    pronunciation: "qiú",
    meaning: "圆形的立体物",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0628",
    type: "character",
    title: "般",
    content: "般",
    pronunciation: "bān",
    meaning: "又如这般东西;百般劝解;般般(种种;样样;件件)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0629",
    type: "character",
    title: "普",
    content: "普",
    pronunciation: "pǔ",
    meaning: "全，全面，广泛",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0630",
    type: "character",
    title: "怕",
    content: "怕",
    pronunciation: "pà",
    meaning: "畏惧害",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0631",
    type: "character",
    title: "弹",
    content: "弹",
    pronunciation: "dàn",
    meaning: "利用弹性射出弹丸等",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0632",
    type: "character",
    title: "校",
    content: "校",
    pronunciation: "xiào",
    meaning: "查对，订正",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0633",
    type: "character",
    title: "苦",
    content: "苦",
    pronunciation: "kǔ",
    meaning: "跟\"甜\"、\"甘\"相对，像黄连或胆计那样的滋味",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0634",
    type: "character",
    title: "创",
    content: "创",
    pronunciation: "chuànɡ",
    meaning: "又如身受重创;创痕(伤痕);创病(伤病);创残(伤残);创瘢",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0635",
    type: "character",
    title: "假",
    content: "假",
    pronunciation: "jiǎ",
    meaning: "虚伪的，不真实的，跟\"真\"相对说",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0636",
    type: "character",
    title: "久",
    content: "久",
    pronunciation: "jiǔ",
    meaning: "时间长天长日",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0637",
    type: "character",
    title: "错",
    content: "错",
    pronunciation: "cuò",
    meaning: "又如错臂(用丹青画饰手臂)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0638",
    type: "character",
    title: "承",
    content: "承",
    pronunciation: "chénɡ",
    meaning: "托着，捧着",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0639",
    type: "character",
    title: "印",
    content: "印",
    pronunciation: "yìn",
    meaning: "图章，戳记",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0640",
    type: "character",
    title: "晚",
    content: "晚",
    pronunciation: "wǎn",
    meaning: "日落的时候傍",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0641",
    type: "character",
    title: "兰",
    content: "兰",
    pronunciation: "lán",
    meaning: "兰花，多年生常绿草本，丛生，叶细长，花清香",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0642",
    type: "character",
    title: "试",
    content: "试",
    pronunciation: "shì",
    meaning: "按预定想法非正式的做",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0643",
    type: "character",
    title: "股",
    content: "股",
    pronunciation: "ɡǔ",
    meaning: "大腿，从胯到膝盖的部分弹中其",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0644",
    type: "character",
    title: "拿",
    content: "拿",
    pronunciation: "ná",
    meaning: "握，用手取",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0645",
    type: "character",
    title: "脑",
    content: "脑",
    pronunciation: "nǎo",
    meaning: "通称\"脑髓\"",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0646",
    type: "character",
    title: "预",
    content: "预",
    pronunciation: "yù",
    meaning: "在先，事前",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0647",
    type: "character",
    title: "谁",
    content: "谁",
    pronunciation: "shuí",
    meaning: "疑问代词",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0648",
    type: "character",
    title: "益",
    content: "益",
    pronunciation: "yì",
    meaning: "好处，有好处的利",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0649",
    type: "character",
    title: "阳",
    content: "阳",
    pronunciation: "yánɡ",
    meaning: "跟\"阴\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0650",
    type: "character",
    title: "若",
    content: "若",
    pronunciation: "ruò",
    meaning: "如，像，似乎欣喜",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0651",
    type: "character",
    title: "哪",
    content: "哪",
    pronunciation: "nǎ",
    meaning: "何？谁？何处你要买",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0652",
    type: "character",
    title: "微",
    content: "微",
    pronunciation: "wēi",
    meaning: "细，小",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0653",
    type: "character",
    title: "尼",
    content: "尼",
    pronunciation: "ní",
    meaning: "同本义◇作昵",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0654",
    type: "character",
    title: "继",
    content: "继",
    pronunciation: "jì",
    meaning: "同本义(把断了的丝接续上)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0655",
    type: "character",
    title: "送",
    content: "送",
    pronunciation: "sònɡ",
    meaning: "运输，传递",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0656",
    type: "character",
    title: "急",
    content: "急",
    pronunciation: "jí",
    meaning: "迫切，紧要",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0657",
    type: "character",
    title: "血",
    content: "血",
    pronunciation: "xuè",
    meaning: "义同\"血\"，用于口语或口语常用词流了些",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0658",
    type: "character",
    title: "惊",
    content: "惊",
    pronunciation: "jīnɡ",
    meaning: "骡、马等因受吓而发狂乱奔控制",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0659",
    type: "character",
    title: "伤",
    content: "伤",
    pronunciation: "shānɡ",
    meaning: "受到损害、损坏受",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0660",
    type: "character",
    title: "素",
    content: "素",
    pronunciation: "sù",
    meaning: "没有染色的丝绸",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0661",
    type: "character",
    title: "药",
    content: "药",
    pronunciation: "yào",
    meaning: "治病的物品中",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0662",
    type: "character",
    title: "适",
    content: "适",
    pronunciation: "shì",
    meaning: "相合，妥当，切合",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0663",
    type: "character",
    title: "波",
    content: "波",
    pronunciation: "bō",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0664",
    type: "character",
    title: "夜",
    content: "夜",
    pronunciation: "yè",
    meaning: "由天黑到天明的一段时间，跟\"昼\"、\"日\"相对",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0665",
    type: "character",
    title: "省",
    content: "省",
    pronunciation: "shěnɡ",
    meaning: "检查，察看反",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0666",
    type: "character",
    title: "初",
    content: "初",
    pronunciation: "chū",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0667",
    type: "character",
    title: "喜",
    content: "喜",
    pronunciation: "xǐ",
    meaning: "高兴，快乐",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0668",
    type: "character",
    title: "卫",
    content: "卫",
    pronunciation: "wèi",
    meaning: "保护，防护",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0669",
    type: "character",
    title: "源",
    content: "源",
    pronunciation: "yuán",
    meaning: "水流开始流出的地方泉",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0670",
    type: "character",
    title: "食",
    content: "食",
    pronunciation: "shí",
    meaning: "供养，拿东西给人吃",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0671",
    type: "character",
    title: "险",
    content: "险",
    pronunciation: "xiǎn",
    meaning: "地势扼要，难于通过",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0672",
    type: "character",
    title: "待",
    content: "待",
    pronunciation: "dài",
    meaning: "①将；要～答不理。",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0673",
    type: "character",
    title: "述",
    content: "述",
    pronunciation: "shù",
    meaning: "记叙，陈说记",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0674",
    type: "character",
    title: "陆",
    content: "陆",
    pronunciation: "lù",
    meaning: "\"六\"的大写",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0675",
    type: "character",
    title: "习",
    content: "习",
    pronunciation: "xí",
    meaning: "鸟屡次拍着翅膀飞鹰乃学",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0676",
    type: "character",
    title: "置",
    content: "置",
    pronunciation: "zhì",
    meaning: "搁，摆，设，安放",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0677",
    type: "character",
    title: "居",
    content: "居",
    pronunciation: "jū",
    meaning: "同本义◇作踞",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0678",
    type: "character",
    title: "劳",
    content: "劳",
    pronunciation: "láo",
    meaning: "人类创造物质或精神财富的活动",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0679",
    type: "character",
    title: "财",
    content: "财",
    pronunciation: "cái",
    meaning: "同本义(多指日常生活必需品,包括米粟在内)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0680",
    type: "character",
    title: "环",
    content: "环",
    pronunciation: "huán",
    meaning: "玉圈她手上带有碧",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0681",
    type: "character",
    title: "排",
    content: "排",
    pronunciation: "pái",
    meaning: "摆成行",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0682",
    type: "character",
    title: "福",
    content: "福",
    pronunciation: "fú",
    meaning: "幸福，好，好处，跟\"祸\"相对祸兮",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0683",
    type: "character",
    title: "纳",
    content: "纳",
    pronunciation: "nà",
    meaning: "收进，接收",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0684",
    type: "character",
    title: "欢",
    content: "欢",
    pronunciation: "huān",
    meaning: "喜悦，高兴",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0685",
    type: "character",
    title: "雷",
    content: "雷",
    pronunciation: "léi",
    meaning: "云层放电时发出的巨响",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0686",
    type: "character",
    title: "警",
    content: "警",
    pronunciation: "jǐnɡ",
    meaning: "警备，戒备",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0687",
    type: "character",
    title: "获",
    content: "获",
    pronunciation: "huò",
    meaning: "穫）huò",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0688",
    type: "character",
    title: "模",
    content: "模",
    pronunciation: "mó",
    meaning: "法式，标准，规范",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0689",
    type: "character",
    title: "充",
    content: "充",
    pronunciation: "chōnɡ",
    meaning: "满，实，足",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0690",
    type: "character",
    title: "负",
    content: "负",
    pronunciation: "fù",
    meaning: "输，败，跟\"胜\"相对三胜二",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0692",
    type: "character",
    title: "停",
    content: "停",
    pronunciation: "tínɡ",
    meaning: "止住，止息",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0694",
    type: "character",
    title: "游",
    content: "游",
    pronunciation: "yóu",
    meaning: "在水里行动，在水上漂浮，泛指游泳",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0695",
    type: "character",
    title: "龙",
    content: "龙",
    pronunciation: "lónɡ",
    meaning: "〈古〉传说中的一种神异动物，有鳞、有角、有脚，能走、能飞、能",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0696",
    type: "character",
    title: "树",
    content: "树",
    pronunciation: "shù",
    meaning: "木本植物的总称",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0697",
    type: "character",
    title: "疑",
    content: "疑",
    pronunciation: "yí",
    meaning: "猜忌，不信",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-char-0698",
    type: "character",
    title: "层",
    content: "层",
    pronunciation: "cénɡ",
    meaning: "又如层楹(高楼大厦)",
    source: "常用汉字2000字",
    createdAt: "2026-09-21T00:00:00.000Z"
  }
];

export const builtinPoemKnowledge: KnowledgeItem[] = [
  {
    id: "builtin-poem-001",
    type: "poem",
    title: "行宫",
    content: "寥落古行宫，宫花寂寞红。\n白头宫女在，闲坐说玄宗。",
    dynasty: "唐",
    author: "元稹",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-003",
    type: "poem",
    title: "新嫁娘词",
    content: "三日入厨下，洗手作羹汤。\n未谙姑食性，先遣小姑尝。",
    dynasty: "唐",
    author: "王建",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-004",
    type: "poem",
    title: "相思",
    content: "红豆生南国，春来发几枝。\n愿君多采撷，此物最相思。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-005",
    type: "poem",
    title: "杂诗",
    content: "君自故乡来，应知故乡事。\n来日绮窗前，寒梅着花未？",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-006",
    type: "poem",
    title: "鹿柴",
    content: "空山不见人，但闻人语响。\n返景入深林，复照青苔上。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-007",
    type: "poem",
    title: "竹里馆",
    content: "独坐幽篁里，弹琴复长啸。\n深林人不知，明月来相照。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-008",
    type: "poem",
    title: "山中送别",
    content: "山中相送罢，日暮掩柴扉。\n春草明年绿，王孙归不归？",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-009",
    type: "poem",
    title: "问刘十九",
    content: "绿蚁新醅酒，红泥小火炉。\n晚来天欲雪，能饮一杯无？",
    dynasty: "唐",
    author: "白居易",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-010",
    type: "poem",
    title: "哥舒歌",
    content: "北斗七星高，哥舒夜带刀。\n至今窥牧马，不敢过临洮。",
    dynasty: "唐",
    author: "西鄙人",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-012",
    type: "poem",
    title: "怨情",
    content: "美人卷珠帘，深坐颦蛾眉。\n但见泪痕湿，不知心恨谁。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-013",
    type: "poem",
    title: "登乐游原",
    content: "向晚意不适，驱车登古原。\n夕阳无限好，只是近黄昏。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-014",
    type: "poem",
    title: "听筝",
    content: "鸣筝金粟柱，素手玉房前。\n欲得周郎顾，时时误拂弦。",
    dynasty: "唐",
    author: "李端",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-015",
    type: "poem",
    title: "渡汉江",
    content: "岭外音书断，经冬复历春。\n近乡情更怯，不敢问来人。",
    dynasty: "唐",
    author: "宋之问",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-016",
    type: "poem",
    title: "八阵图",
    content: "功盖三分国，名成八阵图。\n江流石不转，遗恨失吞吴。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-017",
    type: "poem",
    title: "宿建德江",
    content: "移舟泊烟渚，日暮客愁新。\n野旷天低树，江清月近人。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-019",
    type: "poem",
    title: "春怨",
    content: "打起黄莺儿，莫教枝上啼。\n啼时惊妾梦，不得到辽西。",
    dynasty: "唐",
    author: "金昌绪",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-020",
    type: "poem",
    title: "江雪",
    content: "千山鸟飞绝，万径人踪灭。\n孤舟蓑笠翁，独钓寒江雪。",
    dynasty: "唐",
    author: "柳宗元",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-021",
    type: "poem",
    title: "秋夜寄邱员外",
    content: "怀君属秋夜，散步咏凉天。\n空山松子落，幽人应未眠。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-022",
    type: "poem",
    title: "终南望余雪",
    content: "终南阴岭秀，积雪浮云端。\n林表明霁色，城中增暮寒。",
    dynasty: "唐",
    author: "祖咏",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-023",
    type: "poem",
    title: "宫词",
    content: "故国三千里，深宫二十年。\n一声何满子，双泪落君前。",
    dynasty: "唐",
    author: "张祜",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-024",
    type: "poem",
    title: "寻隐者不遇",
    content: "松下问童子，言师采药去。\n只在此山中，云深不知处。",
    dynasty: "唐",
    author: "贾岛",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-025",
    type: "poem",
    title: "送崔九",
    content: "归山深浅去，须尽丘壑美。\n莫学武陵人，暂游桃源里。",
    dynasty: "唐",
    author: "裴迪",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-026",
    type: "poem",
    title: "送灵澈上人",
    content: "苍苍竹林寺，杳杳钟声晚。\n荷笠带斜阳，青山独归远。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-027",
    type: "poem",
    title: "听弹琴",
    content: "泠泠七弦上，静听松风寒。\n古调虽自爱，今人多不弹。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-028",
    type: "poem",
    title: "送上人",
    content: "孤云将野鹤，岂向人间住。\n莫买沃洲山，时人已知处。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-029",
    type: "poem",
    title: "玉台体",
    content: "昨夜裙带解，今朝蟢子飞。\n铅华不可弃，莫是藁砧归。",
    dynasty: "唐",
    author: "权德舆",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-030",
    type: "poem",
    title: "芙蓉楼送辛渐",
    content: "寒雨连江夜入吴，平明送客楚山孤。\n洛阳亲友如相问，一片冰心在玉壶。",
    dynasty: "唐",
    author: "王昌龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-031",
    type: "poem",
    title: "闺怨",
    content: "闺中少妇不知愁，春日凝妆上翠楼。\n忽见陌头杨柳色，悔教夫婿觅封侯。",
    dynasty: "唐",
    author: "王昌龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-032",
    type: "poem",
    title: "春宫曲",
    content: "昨夜风开露井桃，未央前殿月轮高。\n平阳歌舞新承宠，帘外春寒赐锦袍。",
    dynasty: "唐",
    author: "王昌龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-033",
    type: "poem",
    title: "九月九日忆山东兄弟",
    content: "独在异乡为异客，每逢佳节倍思亲。\n遥知兄弟登高处，遍插茱萸少一人。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-034",
    type: "poem",
    title: "凉州词",
    content: "葡萄美酒夜光杯，欲饮琵琶马上催。\n醉卧沙场君莫笑，古来征战几人回？",
    dynasty: "唐",
    author: "王翰",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-035",
    type: "poem",
    title: "后宫词",
    content: "泪湿罗巾梦不成，夜深前殿按歌声。\n红颜未老恩先断，斜倚薰笼坐到明。",
    dynasty: "唐",
    author: "白居易",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-036",
    type: "poem",
    title: "宫中词",
    content: "寂寂花时闭院门，美人相并立琼轩。\n含情欲说宫中事，鹦鹉前头不敢言。",
    dynasty: "唐",
    author: "朱庆余",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-037",
    type: "poem",
    title: "近试上张水部",
    content: "洞房昨夜停红烛，待晓堂前拜舅姑。\n妆罢低声问夫婿，画眉深浅入时无。",
    dynasty: "唐",
    author: "朱庆余",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-038",
    type: "poem",
    title: "逢入京使",
    content: "故园东望路漫漫，双袖龙钟泪不干。\n马上相逢无纸笔，凭君传语报平安。",
    dynasty: "唐",
    author: "岑参",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-039",
    type: "poem",
    title: "黄鹤楼送孟浩然之广陵",
    content: "故人西辞黄鹤楼，烟花三月下扬州。\n孤帆远影碧空尽，唯见长江天际流。 (唯 通：惟)",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-040",
    type: "poem",
    title: "早发白帝城",
    content: "朝辞白帝彩云间，千里江陵一日还。\n两岸猿声啼不住，轻舟已过万重山。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-041",
    type: "poem",
    title: "夜上受降城闻笛",
    content: "回乐烽前沙似雪，受降城外月如霜。\n不知何处吹芦管，一夜征人尽望乡。",
    dynasty: "唐",
    author: "李益",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-042",
    type: "poem",
    title: "贾生",
    content: "宣室求贤访逐臣，贾生才调更无伦。\n可怜夜半虚前席，不问苍生问鬼神。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-043",
    type: "poem",
    title: "隋宫",
    content: "乘兴南游不戒严，九重谁省谏书函。\n春风举国裁宫锦，半作障泥半作帆。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-044",
    type: "poem",
    title: "瑶池",
    content: "瑶池阿母绮窗开，黄竹歌声动地哀。\n八骏日行三万里，穆王何事不重来。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-045",
    type: "poem",
    title: "嫦娥",
    content: "云母屏风烛影深，长河渐落晓星沉。\n嫦娥应悔偷灵药，碧海青天夜夜心。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-046",
    type: "poem",
    title: "夜雨寄北",
    content: "君问归期未有期，巴山夜雨涨秋池。\n何当共剪西窗烛，却话巴山夜雨时。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-047",
    type: "poem",
    title: "寄令狐郎中",
    content: "嵩云秦树久离居，双鲤迢迢一纸书。\n休问梁园旧宾客，茂陵秋雨病相如。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-048",
    type: "poem",
    title: "为有",
    content: "为有云屏无限娇，凤城寒尽怕春宵。\n无端嫁得金龟婿，辜负香衾事早朝。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-049",
    type: "poem",
    title: "江南逢李龟年",
    content: "岐王宅里寻常见，崔九堂前几度闻。\n正是江南好风景，落花时节又逢君。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-050",
    type: "poem",
    title: "赠别·其一",
    content: "娉娉袅袅十三余，豆蔻梢头二月初。\n春风十里扬州路，卷上珠帘总不如。",
    dynasty: "唐",
    author: "杜牧",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-051",
    type: "poem",
    title: "赠别·其二",
    content: "多情却似总无情，唯觉樽前笑不成。\n蜡烛有心还惜别，替人垂泪到天明。",
    dynasty: "唐",
    author: "杜牧",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-052",
    type: "poem",
    title: "金谷园",
    content: "繁华事散逐香尘，流水无情草自春。\n日暮东风怨啼鸟，落花犹似坠楼人。",
    dynasty: "唐",
    author: "杜牧",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-053",
    type: "poem",
    title: "寄扬州韩绰判官",
    content: "青山隐隐水迢迢，秋尽江南草未凋。\n二十四桥明月夜，玉人何处教吹箫？",
    dynasty: "唐",
    author: "杜牧",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-054",
    type: "poem",
    title: "遣怀",
    content: "落魄江南载酒行，楚腰纤细掌中轻。\n十年一觉扬州梦，赢得青楼薄幸名。",
    dynasty: "唐",
    author: "杜牧",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-055",
    type: "poem",
    title: "秋夕",
    content: "银烛秋光冷画屏，轻罗小扇扑流萤。\n天阶夜色凉如水，卧看牵牛织女星。",
    dynasty: "唐",
    author: "杜牧",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-056",
    type: "poem",
    title: "将赴吴兴登乐游原一绝",
    content: "清时有味是无能，闲爱孤云静爱僧。\n欲把一麾江海去，乐游原上望昭陵。",
    dynasty: "唐",
    author: "杜牧",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-057",
    type: "poem",
    title: "赤壁",
    content: "折戟沉沙铁未销，自将磨洗认前朝。\n东风不与周郎便，铜雀春深锁二乔。",
    dynasty: "唐",
    author: "杜牧",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-058",
    type: "poem",
    title: "泊秦淮",
    content: "烟笼寒水月笼沙，夜泊秦淮近酒家。\n商女不知亡国恨，隔江犹唱后庭花。",
    dynasty: "唐",
    author: "杜牧",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-059",
    type: "poem",
    title: "征人怨",
    content: "岁岁金河复玉关，朝朝马策与刀环。\n三春白雪归青冢，万里黄河绕黑山。",
    dynasty: "唐",
    author: "柳中庸",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-060",
    type: "poem",
    title: "金陵图",
    content: "谁谓伤心画不成，画人心逐世人情。\n君看六幅南朝事，老木寒云满故城。",
    dynasty: "唐",
    author: "韦庄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-061",
    type: "poem",
    title: "滁州西涧",
    content: "独怜幽草涧边生，上有黄鹂深树鸣。\n春潮带雨晚来急，野渡无人舟自横。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-062",
    type: "poem",
    title: "桃花溪",
    content: "隐隐飞桥隔野烟，石矶西畔问渔船。\n桃花尽日随流水，洞在清溪何处边。",
    dynasty: "唐",
    author: "张旭",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-063",
    type: "poem",
    title: "寄人",
    content: "别梦依依到谢家，小廊回合曲阑斜。\n多情只有春庭月，犹为离人照落花。",
    dynasty: "唐",
    author: "张泌",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-064",
    type: "poem",
    title: "题金陵渡",
    content: "金陵津渡小山楼，一宿行人自可愁。\n潮落夜江斜月里，两三星火是瓜州。",
    dynasty: "唐",
    author: "张祜",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-065",
    type: "poem",
    title: "赠内人",
    content: "禁门宫树月痕过，媚眼惟看宿鹭窠。\n斜拔玉钗灯影畔，剔开红焰救飞蛾。",
    dynasty: "唐",
    author: "张祜",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-066",
    type: "poem",
    title: "集灵台·其一",
    content: "日光斜照集灵台，红树花迎晓露开。\n昨夜上皇新授箓，太真含笑入帘来。",
    dynasty: "唐",
    author: "张祜",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-067",
    type: "poem",
    title: "集灵台·其二",
    content: "虢国夫人承主恩，平明骑马入宫门。\n却嫌脂粉污颜色，淡扫蛾眉朝至尊。",
    dynasty: "唐",
    author: "张祜",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-068",
    type: "poem",
    title: "枫桥夜泊",
    content: "月落乌啼霜满天，江枫渔火对愁眠。\n姑苏城外寒山寺，夜半钟声到客船。",
    dynasty: "唐",
    author: "张继",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-069",
    type: "poem",
    title: "陇西行",
    content: "誓扫匈奴不顾身，五千貂锦丧胡尘。\n可怜无定河边骨，犹是春闺梦里人！",
    dynasty: "唐",
    author: "陈陶",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-070",
    type: "poem",
    title: "杂诗",
    content: "近寒食雨草萋萋，着麦苗风柳映堤。\n等是有家归未得，杜鹃休向耳边啼。",
    dynasty: "唐",
    author: "佚名",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-071",
    type: "poem",
    title: "回乡偶书·其一",
    content: "少小离家老大回，乡音无改鬓毛衰。\n儿童相见不相识，笑问客从何处来。",
    dynasty: "唐",
    author: "贺知章",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-072",
    type: "poem",
    title: "瑶瑟怨",
    content: "冰簟银床梦不成，碧天如水夜云轻。\n雁声远过潇湘去，十二楼中月自明。",
    dynasty: "唐",
    author: "温庭筠",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-073",
    type: "poem",
    title: "月夜",
    content: "更深月色半人家，北斗阑干南斗斜。\n今夜偏知春气暖，虫声新透绿窗纱。",
    dynasty: "唐",
    author: "刘方平",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-074",
    type: "poem",
    title: "春怨",
    content: "纱窗日落渐黄昏，金屋无人见泪痕。\n寂寞空庭春欲晚，梨花满地不开门。",
    dynasty: "唐",
    author: "刘方平",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-075",
    type: "poem",
    title: "乌衣巷",
    content: "朱雀桥边野草花，乌衣巷口夕阳斜。\n旧时王谢堂前燕，飞入寻常百姓家。",
    dynasty: "唐",
    author: "刘禹锡",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-076",
    type: "poem",
    title: "春词",
    content: "新妆宜面下朱楼，深锁春光一院愁。\n行到中庭数花朵，蜻蜓飞上玉搔头。",
    dynasty: "唐",
    author: "刘禹锡",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-077",
    type: "poem",
    title: "马嵬坡",
    content: "玄宗回马杨妃死，云雨虽亡日月新。\n终是圣明天子事，景阳宫井又何人。",
    dynasty: "唐",
    author: "郑畋",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-078",
    type: "poem",
    title: "寒食",
    content: "春城无处不飞花，寒食东风御柳斜。\n日暮汉宫传蜡烛，轻烟散入五侯家。",
    dynasty: "唐",
    author: "韩翃",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-079",
    type: "poem",
    title: "已凉",
    content: "碧阑干外绣帘垂，猩血屏风画折枝。\n八尺龙须方锦褥，已凉天气未寒时。",
    dynasty: "唐",
    author: "韩偓",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-080",
    type: "poem",
    title: "宫词",
    content: "长乐宫连上苑春，玉楼金殿艳歌新。\n君门一入无由出，唯有宫莺得见人。",
    dynasty: "唐",
    author: "顾况",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-081",
    type: "poem",
    title: "送杜少府之任蜀州",
    content: "城阙辅三秦，风烟望五津。\n与君离别意，同是宦游人。\n海内存知己，天涯若比邻。\n无为在歧路，儿女共沾巾。",
    dynasty: "唐",
    author: "王勃",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-082",
    type: "poem",
    title: "送梓州李使君",
    content: "万壑树参天，千山响杜鹃。\n山中一夜雨，树杪百重泉。\n汉女输橦布，巴人讼芋田。\n文翁翻教授，不敢倚先贤。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-083",
    type: "poem",
    title: "汉江临眺",
    content: "楚塞三湘接，荆门九派通。\n江流天地外，山色有无中。\n郡邑浮前浦，波澜动远空。\n襄阳好风日，留醉与山翁。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-084",
    type: "poem",
    title: "终南别业",
    content: "中岁颇好道，晚家南山陲。\n兴来每独往，胜事空自知。\n行到水穷处，坐看云起时。\n偶然值林叟，谈笑无还期。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-085",
    type: "poem",
    title: "终南山",
    content: "太乙近天都，连山接海隅。\n白云回望合，青霭入看无。\n分野中峰变，阴晴众壑殊。\n欲投人处宿，隔水问樵夫。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-086",
    type: "poem",
    title: "酬张少府",
    content: "晚年唯好静，万事不关心。自顾无长策，空知返旧林。\n松风吹解带，山月照弹琴。君问穷通理，渔歌入浦深。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-087",
    type: "poem",
    title: "过香积寺",
    content: "不知香积寺，数里入云峰。\n古木无人径，深山何处钟。\n泉声咽危石，日色冷青松。\n薄暮空潭曲，安禅制毒龙。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-088",
    type: "poem",
    title: "辋川闲居赠裴秀才迪",
    content: "寒山转苍翠，秋水日潺湲。\n倚杖柴门外，临风听暮蝉。\n渡头余落日，墟里上孤烟。\n复值接舆醉，狂歌五柳前。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-089",
    type: "poem",
    title: "山居秋暝",
    content: "空山新雨后，天气晚来秋。\n明月松间照，清泉石上流。\n竹喧归浣女，莲动下渔舟。\n随意春芳歇，王孙自可留。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-090",
    type: "poem",
    title: "归嵩山作",
    content: "清川带长薄，车马去闲闲。\n流水如有意，暮禽相与还。\n荒城临古渡，落日满秋山。\n迢递嵩高下，归来且闭关。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-091",
    type: "poem",
    title: "次北固山下",
    content: "客路青山外，行舟绿水前。\n潮平两岸阔，风正一帆悬。\n海日生残夜，江春入旧年。\n乡书何处达？归雁洛阳边。",
    dynasty: "唐",
    author: "王湾",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-092",
    type: "poem",
    title: "云阳馆与韩绅宿别",
    content: "故人江海别，几度隔山川。\n乍见翻疑梦，相悲各问年。\n孤灯寒照雨，深竹暗浮烟。\n更有明朝恨，离杯惜共传。",
    dynasty: "唐",
    author: "司空曙",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-093",
    type: "poem",
    title: "喜外弟卢纶见宿",
    content: "静夜四无邻，荒居旧业贫。\n雨中黄叶树，灯下白头人。\n以我独沉久，愧君相见频。\n平生自有分，况是蔡家亲。",
    dynasty: "唐",
    author: "司空曙",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-094",
    type: "poem",
    title: "贼平后送人北归",
    content: "世乱同南去，时清独北还。\n他乡生白发，旧国见青山。\n晓月过残垒，繁星宿故关。\n寒禽与衰草，处处伴愁颜。",
    dynasty: "唐",
    author: "司空曙",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-095",
    type: "poem",
    title: "赋得古原草送别",
    content: "离离原上草，一岁一枯荣。\n野火烧不尽，春风吹又生。\n远芳侵古道，晴翠接荒城。\n又送王孙去，萋萋满别情。",
    dynasty: "唐",
    author: "白居易",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-096",
    type: "poem",
    title: "题大庾岭北驿",
    content: "阳月南飞雁，传闻至此回。\n我行殊未已，何日复归来。\n江静潮初落，林昏瘴不开。\n明朝望乡处，应见陇头梅。",
    dynasty: "唐",
    author: "宋之问",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-097",
    type: "poem",
    title: "寄左省杜拾遗",
    content: "联步趋丹陛，分曹限紫微。\n晓随天仗入，暮惹御香归。\n白发悲花落，青云羡鸟飞。\n圣朝无阙事，自觉谏书稀。",
    dynasty: "唐",
    author: "岑参",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-098",
    type: "poem",
    title: "听蜀僧浚弹琴",
    content: "蜀僧抱绿绮，西下峨眉峰。\n为我一挥手，如听万壑松。\n客心洗流水，余响入霜钟。\n不觉碧山暮，秋云暗几重。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-099",
    type: "poem",
    title: "夜泊牛渚怀古",
    content: "牛渚西江夜，青天无片云。\n登舟望秋月，空忆谢将军。\n余亦能高咏，斯人不可闻。\n明朝挂帆席，枫叶落纷纷。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-100",
    type: "poem",
    title: "赠孟浩然",
    content: "吾爱孟夫子，风流天下闻。\n红颜弃轩冕，白首卧松云。\n醉月频中圣，迷花不事君。\n高山安可仰，徒此揖清芬。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-101",
    type: "poem",
    title: "渡荆门送别",
    content: "渡远荆门外，来从楚国游。\n山随平野尽，江入大荒流。\n月下飞天镜，云生结海楼。\n仍怜故乡水，万里送行舟。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-102",
    type: "poem",
    title: "送友人",
    content: "青山横北郭，白水绕东城。\n此地一为别，孤蓬万里征。\n浮云游子意，落日故人情。\n挥手自兹去，萧萧班马鸣。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-103",
    type: "poem",
    title: "喜见外弟又言别",
    content: "十年离乱后，长大一相逢。\n问姓惊初见，称名忆旧容。\n别来沧海事，语罢暮天钟。\n明日巴陵道，秋山又几重。",
    dynasty: "唐",
    author: "李益",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-104",
    type: "poem",
    title: "凉思",
    content: "客去波平槛，蝉休露满枝。永怀当此节，倚立自移时。\n北斗兼春远，南陵寓使迟。天涯占梦数，疑误有新知。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-105",
    type: "poem",
    title: "北青萝",
    content: "残阳西入崦，茅屋访孤僧。落叶人何在，寒云路几层。\n独敲初夜磬，闲倚一枝藤。世界微尘里，吾宁爱与憎。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-106",
    type: "poem",
    title: "蝉",
    content: "本以高难饱，徒劳恨费声。\n五更疏欲断，一树碧无情。\n薄宦梗犹泛，故园芜已平。\n烦君最相警，我亦举家清。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-107",
    type: "poem",
    title: "风雨",
    content: "凄凉宝剑篇，羁泊欲穷年。\n黄叶仍风雨，青楼自管弦。\n新知遭薄俗，旧好隔良缘。\n心断新丰酒，销愁斗几千。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-108",
    type: "poem",
    title: "落花",
    content: "高阁客竟去，小园花乱飞。参差连曲陌，迢递送斜晖。\n肠断未忍扫，眼穿仍欲归。芳心向春尽，所得是沾衣。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-109",
    type: "poem",
    title: "登岳阳楼",
    content: "昔闻洞庭水，今上岳阳楼。\n吴楚东南坼，乾坤日夜浮。\n亲朋无一字，老病有孤舟。\n戎马关山北，凭轩涕泗流。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-110",
    type: "poem",
    title: "奉济驿重送严公四韵",
    content: "远送从此别，青山空复情。几时杯重把，昨夜月同行。\n列郡讴歌惜，三朝出入荣。江村独归处，寂寞养残生。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-111",
    type: "poem",
    title: "别房太尉墓",
    content: "他乡复行役，驻马别孤坟。\n近泪无干土，低空有断云。\n对棋陪谢傅，把剑觅徐君。\n唯见林花落，莺啼送客闻。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-112",
    type: "poem",
    title: "旅夜书怀",
    content: "细草微风岸，危樯独夜舟。\n星垂平野阔，月涌大江流。\n名岂文章着，官应老病休。\n飘飘何所似，天地一沙鸥。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-113",
    type: "poem",
    title: "至德二载甫自京金光门",
    content: "此道昔归顺，西郊胡正繁。\n至今残破胆，应有未招魂。\n近得归京邑，移官岂至尊。\n无才日衰老，驻马望千门。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-114",
    type: "poem",
    title: "月夜忆舍弟",
    content: "戍鼓断人行，边秋一雁声。\n露从今夜白，月是故乡明。\n有弟皆分散，无家问死生。\n寄书长不达，况乃未休兵。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-115",
    type: "poem",
    title: "天末怀李白",
    content: "凉风起天末，君子意如何。\n鸿雁几时到，江湖秋水多。\n文章憎命达，魑魅喜人过。\n应共冤魂语，投诗赠汨罗。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-116",
    type: "poem",
    title: "月夜",
    content: "今夜鄜州月，闺中只独看。遥怜小儿女，未解忆长安。\n香雾云鬟湿，清辉玉臂寒。何时倚虚幌，双照泪痕干。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-117",
    type: "poem",
    title: "春望",
    content: "国破山河在，城春草木深。\n感时花溅泪，恨别鸟惊心。\n烽火连三月，家书抵万金。\n白头搔更短，浑欲不胜簪。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-118",
    type: "poem",
    title: "春宿左省",
    content: "花隐掖垣暮，啾啾栖鸟过。\n星临万户动，月傍九霄多。\n不寝听金钥，因风想玉珂。\n明朝有封事，数问夜如何。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-119",
    type: "poem",
    title: "旅宿",
    content: "旅馆无良伴，凝情自悄然。\n寒灯思旧事，断雁警愁眠。\n远梦归侵晓，家书到隔年。\n沧江好烟月，门系钓鱼船。",
    dynasty: "唐",
    author: "杜牧",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-120",
    type: "poem",
    title: "春宫怨",
    content: "早被婵娟误，欲妆临镜慵。承恩不在貌，教妾若为容。\n风暖鸟声碎，日高花影重。年年越溪女，相忆采芙蓉。",
    dynasty: "唐",
    author: "杜荀鹤",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-121",
    type: "poem",
    title: "和晋陵陆丞早春游望",
    content: "独有宦游人，偏惊物候新。\n云霞出海曙，梅柳渡江春。\n淑气催黄鸟，晴光转绿苹。\n忽闻歌古调，归思欲沾巾。",
    dynasty: "唐",
    author: "杜审言",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-122",
    type: "poem",
    title: "杂诗三首·其三",
    content: "闻道黄龙戍，频年不解兵。\n可怜闺里月，长在汉家营。\n少妇今春意，良人昨夜情。\n谁能将旗鼓，一为取龙城。",
    dynasty: "唐",
    author: "沈佺期",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-123",
    type: "poem",
    title: "宿桐庐江寄广陵旧游",
    content: "山暝闻猿愁，沧江急夜流。\n风鸣两岸叶，月照一孤舟。\n建德非吾土，维扬忆旧游。\n还将两行泪，遥寄海西头。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-124",
    type: "poem",
    title: "留别王维",
    content: "寂寂竟何待，朝朝空自归。欲寻芳草去，惜与故人违。\n当路谁相假，知音世所稀。只应守寂寞，还掩故园扉。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-125",
    type: "poem",
    title: "早寒有怀",
    content: "木落雁南度，北风江上寒。\n我家襄水曲，遥隔楚云端。\n乡泪客中尽，孤帆天际看。\n迷津欲有问，平海夕漫漫。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-126",
    type: "poem",
    title: "岁暮归南山",
    content: "北阙休上书，南山归敝庐。不才明主弃，多病故人疏。\n白发催年老，青阳逼岁除。永怀愁不寐，松月夜窗虚。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-127",
    type: "poem",
    title: "过故人庄",
    content: "故人具鸡黍，邀我至田家。\n绿树村边合，青山郭外斜。\n开轩面场圃，把酒话桑麻。\n待到重阳日，还来就菊花。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-128",
    type: "poem",
    title: "秦中寄远上人",
    content: "一丘常欲卧，三径苦无资。\n北土非吾愿，东林怀我师。\n黄金燃桂尽，壮志逐年衰。\n日夕凉风至，闻蝉但益悲。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-129",
    type: "poem",
    title: "望洞庭湖赠张丞相",
    content: "八月湖水平，涵虚混太清。\n气蒸云梦泽，波撼岳阳城。\n欲济无舟楫，端居耻圣明。\n坐观垂钓者，徒有羡鱼情。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-130",
    type: "poem",
    title: "与诸子登岘山",
    content: "人事有代谢，往来成古今。\n江山留胜迹，我辈复登临。\n水落鱼梁浅，天寒梦泽深。\n羊公碑尚在，读罢泪沾襟。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-131",
    type: "poem",
    title: "宴梅道士山房",
    content: "林卧愁春尽，开轩览物华。\n忽逢青鸟使，邀入赤松家。\n金灶初开火，仙桃正发花。\n童颜若可驻，何惜醉流霞。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-132",
    type: "poem",
    title: "章台夜思",
    content: "清瑟怨遥夜，绕弦风雨哀。孤灯闻楚角，残月下章台。\n芳草已云暮，故人殊未来。乡书不可寄，秋雁又南回。",
    dynasty: "唐",
    author: "韦庄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-133",
    type: "poem",
    title: "淮上喜会梁州故人",
    content: "江汉曾为客，相逢每醉还。\n浮云一别后，流水十年间。\n欢笑情如旧，萧疏鬓已斑。\n何因不归去？淮上有秋山。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-134",
    type: "poem",
    title: "赋得暮雨送李曹",
    content: "楚江微雨里，建业暮钟时。\n漠漠帆来重，冥冥鸟去迟。\n海门深不见，浦树远含滋。\n相送情无限，沾襟比散丝。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-135",
    type: "poem",
    title: "经邹鲁祭孔子而叹之",
    content: "夫子何为者，栖栖一代中。\n地犹鄹氏邑，宅即鲁王宫。\n叹凤嗟身否，伤麟怨道穷。\n今看两楹奠，当与梦时同。",
    dynasty: "唐",
    author: "李隆基",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-136",
    type: "poem",
    title: "灞上秋居",
    content: "灞原风雨定，晚见雁行频。\n落叶他乡树，寒灯独夜人。\n空园白露滴，孤壁野僧邻。\n寄卧郊扉久，何年致此身。",
    dynasty: "唐",
    author: "马戴",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-137",
    type: "poem",
    title: "楚江怀古三首·其一",
    content: "露气寒光集，微阳下楚丘。猿啼洞庭树，人在木兰舟。\n广泽生明月，苍山夹乱流。云中君不见，竟夕自悲秋。",
    dynasty: "唐",
    author: "马戴",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-138",
    type: "poem",
    title: "除夜有怀",
    content: "迢递三巴路，羁危万里身。\n乱山残雪夜，孤烛异乡人。\n渐与骨肉远，转于僮仆亲。\n那堪正飘泊，明日岁华新。",
    dynasty: "唐",
    author: "崔涂",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-139",
    type: "poem",
    title: "孤雁",
    content: "几行归塞尽，念尔独何之。\n暮雨相呼失，寒塘欲下迟。\n渚云低暗度，关月冷相随。\n未必逢矰缴，孤飞自可疑。",
    dynasty: "唐",
    author: "崔涂",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-140",
    type: "poem",
    title: "题破山寺后禅院",
    content: "清晨入古寺，初日照高林。\n曲径通幽处，禅房花木深。\n山光悦鸟性，潭影空人心。\n万籁此俱寂，唯闻钟磬音。",
    dynasty: "唐",
    author: "常建",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-141",
    type: "poem",
    title: "望月怀远",
    content: "海上生明月，天涯共此时。\n情人怨遥夜，竟夕起相思。\n灭烛怜光满，披衣觉露滋。\n不堪盈手赠，还寝梦佳期。",
    dynasty: "唐",
    author: "张九龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-142",
    type: "poem",
    title: "书边事",
    content: "调角断清秋，征人倚戍楼。春风对青冢，白日落梁州。\n大汉无兵阻，穷边有客游。蕃情似此水，长愿向南流。",
    dynasty: "唐",
    author: "张乔",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-143",
    type: "poem",
    title: "没蕃故人",
    content: "前年伐月支，城下没全师。\n蕃汉断消息，死生长别离。\n无人收废帐，归马识残旗。\n欲祭疑君在，天涯哭此时。",
    dynasty: "唐",
    author: "张籍",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-144",
    type: "poem",
    title: "秋日赴阙题潼关驿楼",
    content: "红叶晚萧萧，长亭酒一瓢。\n残云归太华，疏雨过中条。\n树色随山迥，河声入海遥。\n帝乡明日到，犹自梦渔樵。",
    dynasty: "唐",
    author: "许浑",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-145",
    type: "poem",
    title: "早秋",
    content: "遥夜泛清瑟，西风生翠萝。\n残萤委玉露，早雁拂金河。\n高树晓还密，远山晴更多。\n淮南一叶下，自觉洞庭波。",
    dynasty: "唐",
    author: "许浑",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-146",
    type: "poem",
    title: "送人东游",
    content: "荒戍落黄叶，浩然离故关。\n高风汉阳渡，初日郢门山。\n江上几人在，天涯孤棹还。\n何当重相见，樽酒慰离颜。",
    dynasty: "唐",
    author: "温庭筠",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-147",
    type: "poem",
    title: "寻陆鸿渐不遇",
    content: "移家虽带郭，野径入桑麻。近种篱边菊，秋来未着花。\n扣门无犬吠，欲去问西家。报道山中去，归时每日斜。",
    dynasty: "唐",
    author: "皎然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-148",
    type: "poem",
    title: "寻南溪常道士",
    content: "一路经行处，莓苔见履痕。\n白云依静渚，春草闭闲门。\n过雨看松色，随山到水源。\n溪花与禅意，相对亦忘言。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-149",
    type: "poem",
    title: "新年作",
    content: "乡心新岁切，天畔独潸然。\n老至居人下，春归在客先。\n岭猿同旦暮，江柳共风烟。\n已似长沙傅，从今又几年。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-150",
    type: "poem",
    title: "秋日登吴公台上寺远眺",
    content: "古台摇落后，秋日望乡心。\n野寺来人少，云峰隔水深。\n夕阳依旧垒，寒磬满空林。\n惆怅南朝事，长江独至今。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-151",
    type: "poem",
    title: "送李中丞归汉阳别业",
    content: "流落征南将，曾驱十万师。\n罢归无旧业，老去恋明时。\n独立三边静，轻生一剑知。\n茫茫江汉上，日暮欲何之。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-152",
    type: "poem",
    title: "饯别王十一南游",
    content: "望君烟水阔，挥手泪沾巾。\n飞鸟没何处，青山空向人。\n长江一帆远，落日五湖春。\n谁见汀洲上，相思愁白苹。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-153",
    type: "poem",
    title: "蜀先主庙",
    content: "天地英雄气，千秋尚凛然。势分三足鼎，业复五铢钱。\n得相能开国，生儿不象贤。凄凉蜀故妓，来舞魏宫前。",
    dynasty: "唐",
    author: "刘禹锡",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-154",
    type: "poem",
    title: "阙题",
    content: "道由白云尽，春与青溪长。\n时有落花至，远随流水香。\n闲门向山路，深柳读书堂。\n幽映每白日，清辉照衣裳。",
    dynasty: "唐",
    author: "刘昚虚",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-155",
    type: "poem",
    title: "送李端",
    content: "故关衰草遍，离别自堪悲。\n路出寒云外，人归暮雪时。\n少孤为客早，多难识君迟。\n掩泪空相向，风尘何处期。",
    dynasty: "唐",
    author: "卢纶",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-156",
    type: "poem",
    title: "送僧归日本",
    content: "上国随缘住，来途若梦行。\n浮天沧海远，去世法舟轻。\n水月通禅寂，鱼龙听梵声。\n惟怜一灯影，万里眼中明。",
    dynasty: "唐",
    author: "钱起",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-157",
    type: "poem",
    title: "谷口书斋寄杨补阙",
    content: "泉壑带茅茨，云霞生薜帷。\n竹怜新雨后，山爱夕阳时。\n闲鹭栖常早，秋花落更迟。\n家僮扫萝径，昨与故人期。",
    dynasty: "唐",
    author: "钱起",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-158",
    type: "poem",
    title: "在狱咏蝉",
    content: "西陆蝉声唱，南冠客思深。\n不堪玄鬓影，来对白头吟。\n露重飞难进，风多响易沉。\n无人信高洁，谁为表予心？",
    dynasty: "唐",
    author: "骆宾王",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-159",
    type: "poem",
    title: "江乡故人偶集客舍",
    content: "天秋月又满，城阙夜千重。\n还作江南会，翻疑梦里逢。\n风枝惊暗鹊，露草覆寒蛩。\n羁旅长堪醉，相留畏晓钟。",
    dynasty: "唐",
    author: "戴叔伦",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-160",
    type: "poem",
    title: "酬程延秋夜即事见赠",
    content: "长簟迎风早，空城澹月华。\n星河秋一雁，砧杵夜千家。\n节候看应晚，心期卧亦赊。\n向来吟秀句，不觉已鸣鸦。",
    dynasty: "唐",
    author: "韩翃",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-161",
    type: "poem",
    title: "遣悲怀三首·其一",
    content: "谢公最小偏怜女，自嫁黔娄百事乖。\n顾我无衣搜荩箧，泥他沽酒拔金钗。\n野蔬充膳甘长藿，落叶添薪仰古槐。\n今日俸钱过十万，与君营奠复营斋。",
    dynasty: "唐",
    author: "元稹",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-162",
    type: "poem",
    title: "遣悲怀三首·其二",
    content: "昔日戏言身后事，今朝都到眼前来。\n衣裳已施行看尽，针线犹存未忍开。\n尚想旧情怜婢仆，也曾因梦送钱财。\n诚知此恨人人有，贫贱夫妻百事哀。",
    dynasty: "唐",
    author: "元稹",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-163",
    type: "poem",
    title: "遣悲怀三首·其三",
    content: "闲坐悲君亦自悲，百年都是几多时。\n邓攸无子寻知命，潘岳悼亡犹费词。\n同穴窅冥何所望，他生缘会更难期。\n惟将终夜常开眼，报答平生未展眉。",
    dynasty: "唐",
    author: "元稹",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-164",
    type: "poem",
    title: "赠郭给事",
    content: "洞门高阁霭余辉，桃李阴阴柳絮飞。\n禁里疏钟官舍晚，省中啼鸟吏人稀。\n晨摇玉佩趋金殿，夕奉天书拜琐闱。\n强欲从君无那老，将因卧病解朝衣。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-165",
    type: "poem",
    title: "和贾至舍人早朝大明宫",
    content: "绛帻鸡人送晓筹，尚衣方进翠云裘。\n九天阊阖开宫殿，万国衣冠拜冕旒。\n日色才临仙掌动，香烟欲傍衮龙浮。\n朝罢须裁五色诏，佩声归向凤池头。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-166",
    type: "poem",
    title: "奉和圣制从蓬莱向兴庆阁道",
    content: "渭水自萦秦塞曲，黄山旧绕汉宫斜。\n銮舆迥出千门柳，阁道回看上苑花。\n云里帝城双凤阙，雨中春树万人家。\n为乘阳气行时令，不是宸游玩物华。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-167",
    type: "poem",
    title: "积雨辋川庄作",
    content: "积雨空林烟火迟，蒸藜炊黍饷东菑。\n漠漠水田飞白鹭，阴阴夏木啭黄鹂。\n山中习静观朝槿，松下清斋折露葵。\n野老与人争席罢，海鸥何事更相疑。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-168",
    type: "poem",
    title: "望月有感",
    content: "时难年荒世业空，弟兄羁旅各西东。\n田园寥落干戈后，骨肉流离道路中。\n吊影分为千里雁，辞根散作九秋蓬。\n共看明月应垂泪，一夜乡心五处同。",
    dynasty: "唐",
    author: "白居易",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-169",
    type: "poem",
    title: "奉和中书舍人贾至早朝",
    content: "鸡鸣紫陌曙光寒，莺啭皇州春色阑。\n金阙晓钟开万户，玉阶仙仗拥千官。\n花迎剑珮星初落，柳拂旌旗露未干。\n独有凤凰池上客，阳春一曲和皆难。",
    dynasty: "唐",
    author: "岑参",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-170",
    type: "poem",
    title: "登金陵凤凰台",
    content: "凤凰台上凤凰游，凤去台空江自流。\n吴宫花草埋幽径，晋代衣冠成古丘。\n三山半落青天外，二水中分白鹭洲。\n总为浮云能蔽日，长安不见使人愁。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-171",
    type: "poem",
    title: "无题·重帏深下莫愁堂",
    content: "重帏深下莫愁堂，卧后清宵细细长。\n神女生涯原是梦，小姑居处本无郎。\n风波不信菱枝弱，月露谁教桂叶香。\n直道相思了无益，未妨惆怅是清狂。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-172",
    type: "poem",
    title: "无题·凤尾香罗薄几重",
    content: "凤尾香罗薄几重，碧文圆顶夜深缝。\n扇裁月魄羞难掩，车走雷声语未通。\n曾是寂寥金烬暗，断无消息石榴红。\n斑骓只系垂杨岸，何处西南任好风。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-173",
    type: "poem",
    title: "无题·相见时难别亦难",
    content: "相见时难别亦难，东风无力百花残。\n春蚕到死丝方尽，蜡炬成灰泪始干。\n晓镜但愁云鬓改，夜吟应觉月光寒。\n蓬山此去无多路，青鸟殷勤为探看。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-174",
    type: "poem",
    title: "无题·来是空言去绝踪",
    content: "来是空言去绝踪，月斜楼上五更钟。\n梦为远别啼难唤，书被催成墨未浓。\n蜡照半笼金翡翠，麝薰微度绣芙蓉。\n刘郎已恨蓬山远，更隔蓬山一万重！",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-175",
    type: "poem",
    title: "无题·飒飒东风细雨来",
    content: "飒飒东风细雨来，芙蓉塘外有轻雷。\n金蟾啮锁烧香入，玉虎牵丝汲井回。\n贾氏窥帘韩掾少，宓妃留枕魏王才。\n春心莫共花争发，一寸相思一寸灰！",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-176",
    type: "poem",
    title: "无题·昨夜星辰昨夜风",
    content: "昨夜星辰昨夜风，画楼西畔桂堂东。\n身无彩凤双飞翼，心有灵犀一点通。\n隔座送钩春酒暖，分曹射覆蜡灯红。\n嗟余听鼓应官去，走马兰台类转蓬。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-177",
    type: "poem",
    title: "春雨",
    content: "怅卧新春白夹衣，白门寥落意多违。\n红楼隔雨相望冷，珠箔飘灯独自归。\n远路应悲春晼晚，残霄犹得梦依稀。\n玉珰缄札何由达，万里云罗一雁飞。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-178",
    type: "poem",
    title: "筹笔驿",
    content: "猿鸟犹疑畏简书，风云常为护储胥。\n徒令上将挥神笔，终见降王走传车。\n管乐有才原不忝，关张无命欲何如？\n他年锦里经祠庙，梁父吟成恨有余。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-179",
    type: "poem",
    title: "锦瑟",
    content: "锦瑟无端五十弦，一弦一柱思华年。\n庄生晓梦迷蝴蝶，望帝春心托杜鹃。\n沧海月明珠有泪，蓝田日暖玉生烟。\n此情可待成追忆，只是当时已惘然。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-180",
    type: "poem",
    title: "隋宫",
    content: "紫泉宫殿锁烟霞，欲取芜城作帝家。\n玉玺不缘归日角，锦帆应是到天涯。\n于今腐草无萤火，终古垂杨有暮鸦。\n地下若逢陈后主，岂宜重问后庭花。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-181",
    type: "poem",
    title: "送魏万之京",
    content: "朝闻游子唱离歌，昨夜微霜初渡河。\n鸿雁不堪愁里听，云山况是客中过。\n关城树色催寒近，御苑砧声向晚多。\n莫见长安行乐处，空令岁月易蹉跎。",
    dynasty: "唐",
    author: "李颀",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-182",
    type: "poem",
    title: "咏怀古迹·其一",
    content: "支离东北风尘际，漂泊西南天地间。\n三峡楼台淹日月，五溪衣服共云山。\n羯胡事主终无赖，词客哀时且未还。\n庾信平生最萧瑟，暮年诗赋动江关。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-183",
    type: "poem",
    title: "咏怀古迹·其二",
    content: "摇落深知宋玉悲，风流儒雅亦吾师。\n怅望千秋一洒泪，萧条异代不同时。\n江山故宅空文藻，云雨荒台岂梦思。\n最是楚宫俱泯灭，舟人指点到今疑。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-184",
    type: "poem",
    title: "咏怀古迹·其三",
    content: "群山万壑赴荆门，生长明妃尚有村。\n一去紫台连朔漠，独留青冢向黄昏。\n画图省识春风面，环佩空归夜月魂。\n千载琵琶作胡语，分明怨恨曲中论。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-185",
    type: "poem",
    title: "咏怀古迹·其四",
    content: "蜀主窥吴幸三峡，崩年亦在永安宫。\n翠华想像空山里，玉殿虚无野寺中。\n古庙杉松巢水鹤，岁时伏腊走村翁。\n武侯祠堂常邻近，一体君臣祭祀同。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-186",
    type: "poem",
    title: "咏怀古迹·其五",
    content: "诸葛大名垂宇宙，宗臣遗像肃清高。\n三分割据纡筹策，万古云霄一羽毛。\n伯仲之间见伊吕，指挥若定失萧曹。\n运移汉祚终难复，志决身歼军务劳。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-187",
    type: "poem",
    title: "宿府",
    content: "清秋幕府井梧寒，独宿江城蜡炬残。\n永夜角声悲自语，中天月色好谁看。\n风尘荏苒音书绝，关塞萧条行路难。\n已忍伶俜十年事，强移栖息一枝安。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-188",
    type: "poem",
    title: "阁夜",
    content: "岁暮阴阳催短景，天涯霜雪霁寒宵。\n五更鼓角声悲壮，三峡星河影动摇。\n野哭几家闻战伐，夷歌数处起渔樵。\n卧龙跃马终黄土，人事依依漫寂寥。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-189",
    type: "poem",
    title: "闻官军收河南河北",
    content: "剑外忽传收蓟北，初闻涕泪满衣裳。\n却看妻子愁何在，漫卷诗书喜欲狂。\n白日放歌须纵酒，青春作伴好还乡。\n即从巴峡穿巫峡，便下襄阳向洛阳。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-190",
    type: "poem",
    title: "登高",
    content: "风急天高猿啸哀，渚清沙白鸟飞回。\n无边落木萧萧下，不尽长江滚滚来。\n万里悲秋常作客，百年多病独登台。\n艰难苦恨繁霜鬓，潦倒新停浊酒杯。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-191",
    type: "poem",
    title: "登楼",
    content: "花近高楼伤客心，万方多难此登临。\n锦江春色来天地，玉垒浮云变古今。\n北极朝廷终不改，西山寇盗莫相侵。\n可怜后主还祠庙，日暮聊为梁甫吟。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-192",
    type: "poem",
    title: "蜀相",
    content: "丞相祠堂何处寻，锦官城外柏森森。\n映阶碧草自春色，隔叶黄鹂空好音。\n三顾频烦天下计，两朝开济老臣心。\n出师未捷身先死，长使英雄泪满襟。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-193",
    type: "poem",
    title: "客至",
    content: "舍南舍北皆春水，但见群鸥日日来。\n花径不曾缘客扫，蓬门今始为君开。\n盘飧市远无兼味，樽酒家贫只旧醅。\n肯与邻翁相对饮，隔篱呼取尽余杯。(余 通：余)",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-194",
    type: "poem",
    title: "野望",
    content: "西山白雪三城戍，南浦清江万里桥。\n海内风尘诸弟隔，天涯涕泪一身遥。\n惟将迟暮供多病，未有涓埃答圣朝。(惟 通：唯)\n跨马出郊时极目，不堪人事日萧条。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-195",
    type: "poem",
    title: "登柳州城楼寄漳汀封连四州",
    content: "城上高楼接大荒，海天愁思正茫茫。\n惊风乱飐芙蓉水，密雨斜侵薜荔墙。\n岭树重遮千里目，江流曲似九回肠。\n共来百越文身地，犹自音书滞一乡。",
    dynasty: "唐",
    author: "柳宗元",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-196",
    type: "poem",
    title: "春思",
    content: "莺啼燕语报新年，马邑龙堆路几千。\n家住层城临汉苑，心随明月到胡天。\n机中锦字论长恨，楼上花枝笑独眠。\n为问元戎窦车骑，何时返旆勒燕然。",
    dynasty: "唐",
    author: "皇甫冉",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-197",
    type: "poem",
    title: "寄李儋元锡",
    content: "去年花里逢君别，今日花开又一年。\n世事茫茫难自料，春愁黯黯独成眠。\n身多疾病思田里，邑有流亡愧俸钱。\n闻道欲来相问讯，西楼望月几回圆。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-198",
    type: "poem",
    title: "望蓟门",
    content: "燕台一望客心惊，笳鼓喧喧汉将营。\n万里寒光生积雪，三边曙色动危旌。\n沙场烽火侵胡月，海畔云山拥蓟城。\n少小虽非投笔吏，论功还欲请长缨。",
    dynasty: "唐",
    author: "祖咏",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-199",
    type: "poem",
    title: "贫女",
    content: "蓬门未识绮罗香，拟托良媒益自伤。\n谁爱风流高格调，共怜时世俭梳妆。\n敢将十指夸针巧，不把双眉斗画长。\n苦恨年年压金线，为他人作嫁衣裳。",
    dynasty: "唐",
    author: "秦韬玉",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-200",
    type: "poem",
    title: "送李少府贬峡中王少府贬",
    content: "嗟君此别意何如，驻马衔杯问谪居。\n巫峡啼猿数行泪，衡阳归雁几封书。\n青枫江上秋帆远，白帝城边古木疏。\n圣代即今多雨露，暂时分手莫踌躇。",
    dynasty: "唐",
    author: "高适",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-201",
    type: "poem",
    title: "九日登望仙台呈刘明府",
    content: "汉文皇帝有高台，此日登临曙色开。\n三晋云山皆北向，二陵风雨自东来。\n关门令尹谁能识，河上仙翁去不回。\n且欲近寻彭泽宰，陶然共醉菊花杯。",
    dynasty: "唐",
    author: "崔曙",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-202",
    type: "poem",
    title: "登黄鹤楼",
    content: "昔人已乘黄鹤去，此地空余黄鹤楼。\n黄鹤一去不复返，白云千载空悠悠。\n晴川历历汉阳树，芳草萋萋鹦鹉洲。\n日暮乡关何处是？烟波江上使人愁。",
    dynasty: "唐",
    author: "崔颢",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-203",
    type: "poem",
    title: "行经华阴",
    content: "岧峣太华俯咸京，天外三峰削不成。\n武帝祠前云欲散，仙人掌上雨初晴。\n河山北枕秦关险，驿树西连汉畤平。\n借问路傍名利客，无如此处学长生。",
    dynasty: "唐",
    author: "崔颢",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-204",
    type: "poem",
    title: "利州南渡",
    content: "澹然空水对斜晖，曲岛苍茫接翠微。\n波上马嘶看棹去，柳边人歇待船归。\n数丛沙草群鸥散，万顷江田一鹭飞。\n谁解乘舟寻范蠡，五湖烟水独忘机。",
    dynasty: "唐",
    author: "温庭筠",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-205",
    type: "poem",
    title: "苏武庙",
    content: "苏武魂销汉使前，古祠高树两茫然。\n云边雁断胡天月，陇上羊归塞草烟。\n回日楼台非甲帐，去时冠剑是丁年。\n茂陵不见封侯印，空向秋波哭逝川。",
    dynasty: "唐",
    author: "温庭筠",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-206",
    type: "poem",
    title: "江州重别薛六柳",
    content: "生涯岂料承优诏，世事空知学醉歌。\n江上月明胡雁过，淮南木落楚山多。\n寄身且喜沧洲近，顾影无如白发何。\n今日龙钟人共弃，愧君犹遣慎风波。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-207",
    type: "poem",
    title: "长沙过贾谊宅",
    content: "三年谪宦此栖迟，万古惟留楚客悲。\n秋草独寻人去后，寒林空见日斜时。\n汉文有道恩犹薄，湘水无情吊岂知。\n寂寂江山摇落处，怜君何事到天涯。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-208",
    type: "poem",
    title: "自夏口至鹦鹉洲夕望岳阳",
    content: "汀洲无浪复无烟，楚客相思益渺然。\n汉口夕阳斜渡鸟，洞庭秋水远连天。\n孤城背岭寒吹角，独树临江夜泊船。\n贾谊上书忧汉室，长沙谪去古今怜。",
    dynasty: "唐",
    author: "刘长卿",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-209",
    type: "poem",
    title: "西塞山怀古",
    content: "王濬楼船下益州，金陵王气黯然收。\n千寻铁锁沉江底，一片降幡出石头。\n人世几回伤往事，山形依旧枕寒流。\n今逢四海为家日，故垒萧萧芦荻秋。",
    dynasty: "唐",
    author: "刘禹锡",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-210",
    type: "poem",
    title: "晚次鄂州",
    content: "云开远见汉阳城，犹是孤帆一日程。\n估客昼眠知浪静，舟人夜语觉潮生。\n三湘愁鬓逢秋色，万里归心对月明。\n旧业已随征战尽，更堪江上鼓鼙声。",
    dynasty: "唐",
    author: "卢纶",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-211",
    type: "poem",
    title: "赠阙下裴舍人",
    content: "二月黄莺飞上林，春城紫禁晓阴阴。\n长乐钟声花外尽，龙池柳色雨中深。\n阳和不散穷途恨，霄汉长怀捧日心。\n献赋十年犹未遇，羞将白发对华簪。",
    dynasty: "唐",
    author: "钱起",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-212",
    type: "poem",
    title: "宫词",
    content: "十二楼中尽晓妆，望仙楼上望君王。\n锁衔金兽连环冷，水滴铜龙昼漏长。\n云髻罢梳还对镜，罗衣欲换更添香。\n遥窥正殿帘开处，袍袴宫人扫御床。",
    dynasty: "唐",
    author: "薛逢",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-213",
    type: "poem",
    title: "同题仙游观",
    content: "仙台初见五城楼，风物凄凄宿雨收。\n山色遥连秦树晚，砧声近报汉宫秋。\n疏松影落空坛静，细草香闲小洞幽。\n何用别寻方外去，人间亦自有丹丘。",
    dynasty: "唐",
    author: "韩翃",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-214",
    type: "poem",
    title: "贼退示官吏",
    content: "昔岁逢太平，山林二十年。\n泉源在庭户，洞壑当门前。\n井税有常期，日晏犹得眠。\n忽然遭世变，数岁亲戎旃。\n今来典斯郡，山夷又纷然。\n城小贼不屠，人贫伤可怜。\n是以陷邻境，此州独见全。\n使臣将王命，岂不如贼焉？\n今彼征敛者，迫之如火煎。\n谁能绝人命，以作时世贤！\n思欲委符节，引竿自刺船。\n将家就鱼麦，归老江湖边。",
    dynasty: "唐",
    author: "元结",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-215",
    type: "poem",
    title: "同从弟销南斋玩月忆山阴",
    content: "高卧南斋时，开帷月初吐。\n清辉澹水木，演漾在窗户。\n冉冉几盈虚，澄澄变今古。\n美人清江畔，是夜越吟苦。\n千里共如何，微风吹兰杜。",
    dynasty: "唐",
    author: "王昌龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-216",
    type: "poem",
    title: "渭川田家",
    content: "斜阳照墟落，穷巷牛羊归。\n野老念牧童，倚杖候荆扉。\n雉雊麦苗秀，蚕眠桑叶稀。\n田夫荷锄至，相见语依依。\n即此羡闲逸，怅然吟式微。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-217",
    type: "poem",
    title: "西施咏",
    content: "艳色天下重，西施宁久微。\n朝为越溪女，暮作吴宫妃。\n贱日岂殊众，贵来方悟稀。\n邀人傅香粉，不自着罗衣。\n君宠益娇态，君怜无是非。\n当时浣纱伴，莫得同车归。\n持谢邻家子，效颦安可希。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-218",
    type: "poem",
    title: "送别",
    content: "下马饮君酒，问君何所之？\n君言不得意，归卧南山陲。\n但去莫复问，白云无尽时。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-219",
    type: "poem",
    title: "送綦毋潜落第还乡",
    content: "圣代无隐者，英灵尽来归。\n遂令东山客，不得顾采薇。\n既至金门远，孰云吾道非。\n江淮度寒食，京洛缝春衣。\n置酒长安道，同心与我违。\n行当浮桂棹，未几拂荆扉。\n远树带行客，孤城当落晖。\n吾谋适不用，勿谓知音稀。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-220",
    type: "poem",
    title: "青溪",
    content: "言入黄花川，每逐清溪水。\n随山将万转，趣途无百里。\n声喧乱石中，色静深松里。\n漾漾泛菱荇，澄澄映葭苇。\n我心素已闲，清川澹如此。\n请留磐石上，垂钓将已矣。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-221",
    type: "poem",
    title: "与高适薛据同登慈恩寺",
    content: "塔势如涌出，孤高耸天宫。\n登临出世界，磴道盘虚空。\n突兀压神州，峥嵘如鬼工。\n四角碍白日，七层摩苍穹。\n下窥指高鸟，俯听闻惊风。\n连山若波涛，奔凑似朝东。\n青槐夹驰道，宫馆何玲珑。\n秋色从西来，苍然满关中。\n五陵北原上，万古青蒙蒙。\n净理了可悟，胜因夙所宗。\n誓将挂冠去，觉道资无穷。",
    dynasty: "唐",
    author: "岑参",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-222",
    type: "poem",
    title: "下终南山过斛斯山人宿置酒",
    content: "暮从碧山下，山月随人归。\n却顾所来径，苍苍横翠微。\n相携及田家，童稚开荆扉。\n绿竹入幽径，青萝拂行衣。\n欢言得所憩，美酒聊共挥。\n长歌吟松风，曲尽河星稀。\n我醉君复乐，陶然共忘机。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-223",
    type: "poem",
    title: "月下独酌四首·其一",
    content: "花间一壶酒，独酌无相亲。\n举杯邀明月，对影成三人。\n月既不解饮，影徒随我身。\n暂伴月将影，行乐须及春。\n我歌月徘徊，我舞影零乱。\n醒时同交欢，醉后各分散。\n永结无情游，相期邈云汉。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-224",
    type: "poem",
    title: "春思",
    content: "燕草如碧丝，秦桑低绿枝。\n当君怀归日，是妾断肠时。\n春风不相识，何事入罗帏。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-225",
    type: "poem",
    title: "梦李白·其一",
    content: "死别已吞声，生别常恻恻。江南瘴疠地，逐客无消息。\n故人入我梦，明我长相忆。恐非平生魂，路远不可测。\n魂来枫叶青，魂返关塞黑。君今在罗网，何以有羽翼。\n落月满屋梁，犹疑照颜色。水深波浪阔，无使蛟龙得。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-226",
    type: "poem",
    title: "梦李白·其二",
    content: "浮云终日行，游子久不至。\n三夜频梦君，情亲见君意。\n告归常局促，苦道来不易。\n江湖多风波，舟楫恐失坠。\n出门搔白首，若负平生志。\n冠盖满京华，斯人独憔悴。\n孰云网恢恢，将老身反累。\n千秋万岁名，寂寞身后事。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-227",
    type: "poem",
    title: "望岳",
    content: "岱宗夫如何？齐鲁青未了。\n造化钟神秀，阴阳割昏晓。\n荡胸生曾云，决眦入归鸟。( 曾 通：层)\n会当凌绝顶，一览众山小。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-228",
    type: "poem",
    title: "赠卫八处士",
    content: "人生不相见，动如参与商。\n今夕复何夕，共此灯烛光！\n少壮能几时？鬓发各已苍！\n访旧半为鬼，惊呼热中肠。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-229",
    type: "poem",
    title: "佳人",
    content: "绝代有佳人，幽居在空谷。\n自云良家女，零落依草木。\n关中昔丧乱，兄弟遭杀戮。\n官高何足论，不得收骨肉。\n世情恶衰歇，万事随转烛。\n夫婿轻薄儿，新人美如玉。\n合昏尚知时，鸳鸯不独宿。\n但见新人笑，那闻旧人哭。\n在山泉水清，出山泉水浊。\n侍婢卖珠回，牵萝补茅屋。\n摘花不插发，采柏动盈掬。\n天寒翠袖薄，日暮倚修竹。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-230",
    type: "poem",
    title: "秋登兰山寄张五",
    content: "北山白云里，隐者自怡悦。\n相望试登高，心随雁飞灭。\n愁因薄暮起，兴是清秋发。\n时见归村人，沙行渡头歇。\n天边树若荠，江畔洲如月。\n何当载酒来，共醉重阳节。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-231",
    type: "poem",
    title: "夏日南亭怀辛大",
    content: "山光忽西落，池月渐东上。\n散发乘夕凉，开轩卧闲敞。\n荷风送香气，竹露滴清响。\n欲取鸣琴弹，恨无知音赏。\n感此怀故人，中宵劳梦想。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-232",
    type: "poem",
    title: "宿业师山房待丁大不至",
    content: "夕阳度西岭，群壑倏已暝。\n松月生夜凉，风泉满清听。\n樵人归欲尽，烟鸟栖初定。\n之子期宿来，孤琴候萝径。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-233",
    type: "poem",
    title: "寻西山隐者不遇",
    content: "绝顶一茅茨，直上三十里。\n扣关无僮仆，窥室唯案几。\n若非巾柴车，应是钓秋水。\n差池不相见，黾勉空仰止。\n草色新雨中，松声晚窗里。\n及兹契幽绝，自足荡心耳。\n虽无宾主意，颇得清净理。\n兴尽方下山，何必待之子。",
    dynasty: "唐",
    author: "丘为",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-234",
    type: "poem",
    title: "晨诣超师院读禅经",
    content: "汲井漱寒齿，清心拂尘服。\n闲持贝叶书，步出东斋读。\n真源了无取，妄迹世所逐。\n遗言冀可冥，缮性何由熟。\n道人庭宇静，苔色连深竹。\n日出雾露余，青松如膏沐。\n澹然离言说，悟悦心自足。",
    dynasty: "唐",
    author: "柳宗元",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-235",
    type: "poem",
    title: "溪居",
    content: "久为簪组累，幸此南夷谪。\n闲依农圃邻，偶似山林客。\n晓耕翻露草，夜榜响溪石。\n来往不逢人，长歌楚天碧。",
    dynasty: "唐",
    author: "柳宗元",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-236",
    type: "poem",
    title: "送杨氏女",
    content: "永日方戚戚，出行复悠悠。\n女子今有行，大江溯轻舟。\n尔辈苦无恃，抚念益慈柔。\n幼为长所育，两别泣不休。\n对此结中肠，义往难复留。\n自小阙内训，事姑贻我忧。\n赖兹托令门，任恤庶无尤。\n贫俭诚所尚，资从岂待周。\n孝恭遵妇道，容止顺其猷。\n别离在今晨，见尔当何秋。\n居闲始自遣，临感忽难收。\n归来视幼女，零泪缘缨流。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-237",
    type: "poem",
    title: "长安遇冯着",
    content: "客从东方来，衣上灞陵雨。\n问客何为来，采山因买斧。\n冥冥花正开，飏飏燕新乳。\n昨别今已春，鬓丝生几缕。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-238",
    type: "poem",
    title: "夕次盱眙县",
    content: "落帆逗淮镇，停舫临孤驿。浩浩风起波，冥冥日沉夕。\n人归山郭暗，雁下芦洲白。独夜忆秦关，听钟未眠客。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-239",
    type: "poem",
    title: "东郊",
    content: "吏舍跼终年，出郊旷清曙。\n杨柳散和风，青山澹吾虑。\n依丛适自憩，缘涧还复去。\n微雨霭芳原，春鸠鸣何处。\n乐幽心屡止，遵事迹犹遽。\n终罢斯结庐，慕陶直可庶。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-240",
    type: "poem",
    title: "郡斋雨中与诸文士燕集",
    content: "兵卫森画戟，宴寝凝清香。\n海上风雨至，逍遥池阁凉。\n烦疴近消散，嘉宾复满堂。\n自惭居处崇，未睹斯民康。\n理会是非遣，性达形迹忘。\n鲜肥属时禁，蔬果幸见尝。\n俯饮一杯酒，仰聆金玉章。\n神欢体自轻，意欲凌风翔。\n吴中盛文史，群彦今汪洋。\n方知大藩地，岂曰财赋强。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-241",
    type: "poem",
    title: "初发扬子寄元大校书",
    content: "凄凄去亲爱，泛泛入烟雾。\n归棹洛阳人，残钟广陵树。\n今朝此为别，何处还相遇。\n世事波上舟，沿洄安得住。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-242",
    type: "poem",
    title: "寄全椒山中道士",
    content: "今朝郡斋冷，忽念山中客。\n涧底束荆薪，归来煮白石。\n欲持一瓢酒，远慰风雨夕。\n落叶满空山，何处寻行迹。",
    dynasty: "唐",
    author: "韦应物",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-243",
    type: "poem",
    title: "宿王昌龄隐居",
    content: "清溪深不测，隐处唯孤云。\n松际露微月，清光犹为君。\n茅亭宿花影，药院滋苔纹。\n余亦谢时去，西山鸾鹤群。",
    dynasty: "唐",
    author: "常建",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-244",
    type: "poem",
    title: "感遇·孤鸿海上来",
    content: "孤鸿海上来，池潢不敢顾。\n侧见双翠鸟，巢在三珠树。\n矫矫珍木巅，得无金丸惧？\n美服患人指，高明逼神恶。\n今我游冥冥，弋者何所慕！",
    dynasty: "唐",
    author: "张九龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-245",
    type: "poem",
    title: "感遇·兰叶春葳蕤",
    content: "兰叶春葳蕤，桂华秋皎洁。\n欣欣此生意，自尔为佳节。\n谁知林栖者，闻风坐相悦。\n草木有本心，何求美人折！",
    dynasty: "唐",
    author: "张九龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-246",
    type: "poem",
    title: "感遇·幽人归独卧",
    content: "幽人归独卧，滞虑洗孤清。\n持此谢高鸟，因之传远情。\n日夕怀空意，人谁感至精？\n飞沈理自隔，何所慰吾诚?",
    dynasty: "唐",
    author: "张九龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-247",
    type: "poem",
    title: "感遇·江南有丹橘",
    content: "江南有丹橘，经冬犹绿林。\n岂伊地气暖？自有岁寒心。\n可以荐嘉客，奈何阻重深。\n运命惟所遇，循环不可寻。\n徒言树桃李，此木岂无阴？",
    dynasty: "唐",
    author: "张九龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-248",
    type: "poem",
    title: "春泛若耶溪",
    content: "幽意无断绝，此去随所偶。\n晚风吹行舟，花路入溪口。\n际夜转西壑，隔山望南斗。\n潭烟飞溶溶，林月低向后。\n生事且弥漫，愿为持竿叟。",
    dynasty: "唐",
    author: "綦毋潜",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-249",
    type: "poem",
    title: "石鱼湖上醉歌",
    content: "石鱼湖，似洞庭，夏水欲满君山青。\n山为樽，水为沼，酒徒历历坐洲岛。\n长风连日作大浪，不能废人运酒舫。\n我持长瓢坐巴丘，酌饮四坐以散愁。",
    dynasty: "唐",
    author: "元结",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-250",
    type: "poem",
    title: "长恨歌",
    content: "汉皇重色思倾国，御宇多年求不得。杨家有女初长成，养在深闺人未识。\n天生丽质难自弃，一朝选在君王侧。回眸一笑百媚生，六宫粉黛无颜色。\n春寒赐浴华清池，温泉水滑洗凝脂。侍儿扶起娇无力，始是新承恩泽时。\n云鬓花颜金步摇，芙蓉帐暖度春宵。春宵苦短日高起，从此君王不早朝。\n承欢侍宴无闲暇，春从春游夜专夜。后宫佳丽三千人，三千宠爱在一身。\n金屋妆成娇侍夜，玉楼宴罢醉和春。姊妹弟兄皆列土，可怜光彩生门户。\n遂令天下父母心，不重生男重生女。骊宫高处入青云，仙乐风飘处处闻。\n缓歌慢舞凝丝竹，尽日君王看不足。渔阳鼙鼓动地来，惊破霓裳羽衣曲。\n九重城阙烟尘生，千乘万骑西南行。翠华摇摇行复止，西出都门百余里。\n六军不发无奈何，宛转蛾眉马前死。花钿委地无人收，翠翘金雀玉搔头。\n君王掩面救不得，回看血泪相和流。黄埃散漫风萧索，云栈萦纡登剑阁。\n峨嵋山下少人行，旌旗无光日色薄。蜀江水碧蜀山青，圣主朝朝暮暮情。\n行宫见月伤心色，夜雨闻铃肠断声。天旋地转回龙驭，到此踌躇不能去。\n马嵬坡下泥土中，不见玉颜空死处。君臣相顾尽沾衣，东望都门信马归。\n归来池苑皆依旧，太液芙蓉未央柳。芙蓉如面柳如眉，对此如何不泪垂。\n春风桃李花开日，秋雨梧桐叶落时。西宫南内多秋草，落叶满阶红不扫。\n梨园弟子白发新，椒房阿监青娥老。夕殿萤飞思悄然，孤灯挑尽未成眠。\n迟迟钟鼓初长夜，耿耿星河欲曙天。鸳鸯瓦冷霜华重，翡翠衾寒谁与共。\n悠悠生死别经年，魂魄不曾来入梦。临邛道士鸿都客，能以精诚致魂魄。\n为感君王辗转思，遂教方士殷勤觅。排空驭气奔如电，升天入地求之遍。\n上穷碧落下黄泉，两处茫茫皆不见。忽闻海上有仙山，山在虚无缥渺间。\n楼阁玲珑五云起，其中绰约多仙子。中有一人字太真，雪肤花貌参差是。\n金阙西厢叩玉扃，转教小玉报双成。闻道汉家天子使，九华帐里梦魂惊。\n揽衣推枕起徘徊，珠箔银屏迤逦开。云鬓半偏新睡觉，花冠不整下堂来。\n风吹仙袂飘飘举，犹似霓裳羽衣舞。玉容寂寞泪阑干，梨花一枝春带雨。\n含情凝睇谢君王，一别音容两渺茫。昭阳殿里恩爱绝，蓬莱宫中日月长。\n回头下望人寰处，不见长安见尘雾。惟将旧物表深情，钿合金钗寄将去。\n钗留一股合一扇，钗擘黄金合分钿。但教心似金钿坚，天上人间会相见。\n临别殷勤重寄词，词中有誓两心知。七月七日长生殿，夜半无人私语时。\n在天愿作比翼鸟，在地愿为连理枝。天长地久有时尽，此恨绵绵无绝期。",
    dynasty: "唐",
    author: "白居易",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-251",
    type: "poem",
    title: "琵琶行",
    content: "浔阳江头夜送客，枫叶荻花秋瑟瑟。\n主人下马客在船，举酒欲饮无管弦。\n醉不成欢惨将别，别时茫茫江浸月。\n忽闻水上琵琶声，主人忘归客不发。\n寻声暗问弹者谁？琵琶声停欲语迟。\n移船相近邀相见，添酒回灯重开宴。\n千呼万唤始出来，犹抱琵琶半遮面。\n转轴拨弦三两声，未成曲调先有情。\n弦弦掩抑声声思，似诉平生不得志。\n低眉信手续续弹，说尽心中无限事。\n轻拢慢捻抹复挑，初为《霓裳》后《六幺》。\n大弦嘈嘈如急雨，小弦切切如私语。\n嘈嘈切切错杂弹，大珠小珠落玉盘。\n间关莺语花底滑，幽咽泉流冰下难。\n冰泉冷涩弦凝绝，凝绝不通声暂歇。\n别有幽愁暗恨生，此时无声胜有声。\n银瓶乍破水浆迸，铁骑突出刀枪鸣。\n曲终收拨当心画，四弦一声如裂帛。\n东船西舫悄无言，唯见江心秋月白。\n沉吟放拨插弦中，整顿衣裳起敛容。\n自言本是京城女，家在虾蟆陵下住。\n十三学得琵琶成，名属教坊第一部。\n曲罢曾教善才服，妆成每被秋娘妒。\n五陵年少争缠头，一曲红绡不知数。\n钿头银篦击节碎，血色罗裙翻酒污。\n今年欢笑复明年，秋月春风等闲度。\n弟走从军阿姨死，暮去朝来颜色故。\n门前冷落鞍马稀，老大嫁作商人妇。\n商人重利轻别离，前月浮梁买茶去。\n去来江口守空船，绕船月明江水寒。\n夜深忽梦少年事，梦啼妆泪红阑干。\n我闻琵琶已叹息，又闻此语重唧唧。\n同是天涯沦落人，相逢何必曾相识！\n我从去年辞帝京，谪居卧病浔阳城。\n浔阳地僻无音乐，终岁不闻丝竹声。\n住近湓江地低湿，黄芦苦竹绕宅生。\n其间旦暮闻何物？杜鹃啼血猿哀鸣。\n春江花朝秋月夜，往往取酒还独倾。\n岂无山歌与村笛？呕哑嘲哳难为听。\n今夜闻君琵琶语，如听仙乐耳暂明。\n莫辞更坐弹一曲，为君翻作《琵琶行》。\n感我此言良久立，却坐促弦弦转急。\n凄凄不似向前声，满座重闻皆掩泣。\n座中泣下谁最多？江州司马青衫湿。",
    dynasty: "唐",
    author: "白居易",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-252",
    type: "poem",
    title: "走马川行奉送封大夫出师",
    content: "君不见走马川行雪海边，平沙莽莽黄入天。\n轮台九月风夜吼，一川碎石大如斗，随风满地石乱走。\n匈奴草黄马正肥，金山西见烟尘飞，汉家大将西出师。\n将军金甲夜不脱，半夜军行戈相拨，风头如刀面如割。\n马毛带雪汗气蒸，五花连钱旋作冰，幕中草檄砚水凝。\n虏骑闻之应胆慑，料知短兵不敢接，车师西门伫献捷。",
    dynasty: "唐",
    author: "岑参",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-253",
    type: "poem",
    title: "轮台歌奉送封大夫出师",
    content: "轮台城头夜吹角，轮台城北旄头落。\n羽书昨夜过渠黎，单于已在金山西。\n戍楼西望烟尘黑，汉军屯在轮台北。\n上将拥旄西出征，平明吹笛大军行。\n四边伐鼓雪海涌，三军大呼阴山动。\n虏塞兵气连云屯，战场白骨缠草根。\n剑河风急雪片阔，沙口石冻马蹄脱。\n亚相勤王甘苦辛，誓将报主静边尘。\n古来青史谁不见，今见功名胜古人。",
    dynasty: "唐",
    author: "岑参",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-254",
    type: "poem",
    title: "白雪歌送武判官归京",
    content: "北风卷地白草折，胡天八月即飞雪。\n忽如一夜春风来，千树万树梨花开。\n散入珠帘湿罗幕，狐裘不暖锦衾薄。\n将军角弓不得控，都护铁衣冷难着。\n瀚海阑干百丈冰，愁云惨淡万里凝。\n中军置酒饮归客，胡琴琵琶与羌笛。\n纷纷暮雪下辕门，风掣红旗冻不翻。\n轮台东门送君去，去时雪满天山路。\n山回路转不见君，雪上空留马行处。",
    dynasty: "唐",
    author: "岑参",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-255",
    type: "poem",
    title: "宣州谢脁楼饯别校书叔云",
    content: "弃我去者，昨日之日不可留；\n乱我心者，今日之日多烦忧。\n长风万里送秋雁，对此可以酣高楼。\n蓬莱文章建安骨，中间小谢又清发。\n俱怀逸兴壮思飞，欲上青天揽明月。\n抽刀断水水更流，举杯消愁愁更愁。\n人生在世不称意，明朝散发弄扁舟。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-256",
    type: "poem",
    title: "庐山谣寄卢侍御虚舟",
    content: "我本楚狂人，凤歌笑孔丘。\n手持绿玉杖，朝别黄鹤楼。\n五岳寻仙不辞远，一生好入名山游。\n庐山秀出南斗傍，屏风九叠云锦张。\n影落明湖青黛光，金阙前开二峰长，银河倒挂三石梁。\n香炉瀑布遥相望，回崖沓嶂凌苍苍。\n翠影红霞映朝日，鸟飞不到吴天长。\n登高壮观天地间，大江茫茫去不还。\n黄云万里动风色，白波九道流雪山。\n好为庐山谣，兴因庐山发。\n闲窥石镜清我心，谢公行处苍苔没。\n早服还丹无世情，琴心三叠道初成。\n遥见仙人彩云里，手把芙蓉朝玉京。\n先期汗漫九垓上，愿接卢敖游太清。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-257",
    type: "poem",
    title: "梦游天姥吟留别",
    content: "海客谈瀛洲，烟涛微茫信难求；\n越人语天姥，云霞明灭或可睹。\n天姥连天向天横，势拔五岳掩赤城。\n天台四万八千丈，对此欲倒东南倾。\n我欲因之梦吴越，一夜飞度镜湖月。(度 通：渡)\n湖月照我影，送我至剡溪。\n谢公宿处今尚在，渌水荡漾清猿啼。\n脚着谢公屐，身登青云梯。\n半壁见海日，空中闻天鸡。\n千岩万转路不定，迷花倚石忽已暝。\n熊咆龙吟殷岩泉，栗深林兮惊层巅。\n云青青兮欲雨，水澹澹兮生烟。\n列缺霹雳，丘峦崩摧。\n洞天石扉，訇然中开。\n青冥浩荡不见底，日月照耀金银台。\n霓为衣兮风为马，云之君兮纷纷而来下。\n虎鼓瑟兮鸾回车，仙之人兮列如麻。\n忽魂悸以魄动，恍惊起而长嗟。\n惟觉时之枕席，失向来之烟霞。\n世间行乐亦如此，古来万事东流水。\n别君去兮何时还？且放白鹿青崖间，须行即骑访名山。\n安能摧眉折腰事权贵，使我不得开心颜!",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-258",
    type: "poem",
    title: "金陵酒肆留别",
    content: "风吹柳花满店香，吴姬压酒唤客尝。\n金陵子弟来相送，欲行不行各尽觞。\n请君试问东流水，别意与之谁短长。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-259",
    type: "poem",
    title: "韩碑",
    content: "元和天子神武姿，彼何人哉轩与羲。\n誓将上雪列圣耻，坐法宫中朝四夷。\n淮西有贼五十载，封狼生䝙䝙生罴。\n不据山河据平地，长戈利矛日可麾。\n帝得圣相相曰度，贼斫不死神扶持。\n腰悬相印作都统，阴风惨澹天王旗。\n愬武古通作牙爪，仪曹外郎载笔随。\n行军司马智且勇，十四万众犹虎貔。\n入蔡缚贼献太庙，功无与让恩不訾。\n帝曰汝度功第一，汝从事愈宜为辞。\n愈拜稽首蹈且舞，金石刻画臣能为。\n古者世称大手笔，此事不系于职司。\n当仁自古有不让，言讫屡颔天子颐。\n公退斋戒坐小阁，濡染大笔何淋漓。\n点窜尧典舜典字，涂改清庙生民诗。\n文成破体书在纸，清晨再拜铺丹墀。\n表曰臣愈昧死上，咏神圣功书之碑。\n碑高三丈字如斗，负以灵鳌蟠以螭。\n句奇语重喻者少，谗之天子言其私。\n长绳百尺拽碑倒，粗砂大石相磨治。\n公之斯文若元气，先时已入人肝脾。\n汤盘孔鼎有述作，今无其器存其辞。\n呜呼圣王及圣相，相与烜赫流淳熙。\n公之斯文不示后，曷与三五相攀追。\n愿书万本诵万遍，口角流沫右手胝。\n传之七十有二代，以为封禅玉检明堂基。",
    dynasty: "唐",
    author: "李商隐",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-260",
    type: "poem",
    title: "听董大弹胡笳声兼寄语",
    content: "蔡女昔造胡笳声，一弹一十有八拍。\n胡人落泪沾边草，汉使断肠对归客。\n古戍苍苍烽火寒，大荒沉沉飞雪白。\n先拂商弦后角羽，四郊秋叶惊摵摵。\n董夫子，通神明，深山窃听来妖精。\n言迟更速皆应手，将往复旋如有情。\n空山百鸟散还合，万里浮云阴且晴。\n嘶酸雏雁失群夜，断绝胡儿恋母声。\n川为静其波，鸟亦罢其鸣。\n乌孙部落家乡远，逻娑沙尘哀怨生。\n幽音变调忽飘洒，长风吹林雨堕瓦。\n迸泉飒飒飞木末，野鹿呦呦走堂下。\n长安城连东掖垣，凤凰池对青琐门。\n高才脱略名与利，日夕望君抱琴至。",
    dynasty: "唐",
    author: "李颀",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-261",
    type: "poem",
    title: "听安万善吹觱篥歌",
    content: "南山截竹为觱篥，此乐本自龟兹出。\n流传汉地曲转奇，凉州胡人为我吹。\n傍邻闻者多叹息，远客思乡皆泪垂。\n世人解听不解赏，长飙风中自来往。\n枯桑老柏寒飕飗，九雏鸣凤乱啾啾。\n龙吟虎啸一时发，万籁百泉相与秋。\n忽然更作渔阳掺，黄云萧条白日暗。\n变调如闻杨柳春，上林繁花照眼新。\n岁夜高堂列明烛，美酒一杯声一曲。",
    dynasty: "唐",
    author: "李颀",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-262",
    type: "poem",
    title: "古意",
    content: "男儿事长征，少小幽燕客。\n赌胜马蹄下，由来轻七尺。\n杀人莫敢前，须如猬毛磔。\n黄云陇底白云飞，未得报恩不能归。\n辽东小妇年十五，惯弹琵琶解歌舞。\n今为羌笛出塞声，使我三军泪如雨。",
    dynasty: "唐",
    author: "李颀",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-263",
    type: "poem",
    title: "送陈章甫",
    content: "四月南风大麦黄，枣花未落桐阴长。\n青山朝别暮还见，嘶马出门思旧乡。\n陈侯立身何坦荡，虬须虎眉仍大颡。\n腹中贮书一万卷，不肯低头在草莽。\n东门酤酒饮我曹，心轻万事如鸿毛。\n醉卧不知白日暮，有时空望孤云高。\n长河浪头连天黑，津口停舟渡不得。\n郑国游人未及家，洛阳行子空叹息。\n闻道故林相识多，罢官昨日今如何。",
    dynasty: "唐",
    author: "李颀",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-264",
    type: "poem",
    title: "琴歌",
    content: "主人有酒欢今夕，请奏鸣琴广陵客。\n月照城头乌半飞，霜凄万树风入衣。\n铜炉华烛烛增辉，初弹渌水后楚妃。\n一声已动物皆静，四座无言星欲稀。\n清淮奉使千余里，敢告云山从此始。",
    dynasty: "唐",
    author: "李颀",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-265",
    type: "poem",
    title: "古柏行",
    content: "孔明庙前有老柏，柯如青铜根如石。\n霜皮溜雨四十围，黛色参天二千尺。\n君臣已与时际会，树木犹为人爱惜。\n云来气接巫峡长，月出寒通雪山白。\n忆昨路绕锦亭东，先主武侯同閟宫。\n崔嵬枝干郊原古，窈窕丹青户牖空。\n落落盘踞虽得地，冥冥孤高多烈风。\n扶持自是神明力，正直原因造化工。\n大厦如倾要梁栋，万牛回首丘山重。\n不露文章世已惊，未辞翦伐谁能送？\n苦心岂免容蝼蚁，香叶终经宿鸾凤。\n志士幽人莫怨嗟：古来材大难为用。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-266",
    type: "poem",
    title: "观公孙大娘弟子舞剑器行",
    content: "昔有佳人公孙氏，一舞剑器动四方。\n观者如山色沮丧，天地为之久低昂。\n霍如羿射九日落，矫如群帝骖龙翔。\n来如雷霆收震怒，罢如江海凝清光。\n绛唇珠袖两寂寞，晚有弟子传芬芳。\n临颍美人在白帝，妙舞此曲神扬扬。\n与余问答既有以，感时抚事增惋伤。\n先帝侍女八千人，公孙剑器初第一。\n五十年间似反掌，风尘澒洞昏王室。\n梨园弟子散如烟，女乐余姿映寒日。\n金粟堆南木已拱，瞿唐石城草萧瑟。\n玳筵急管曲复终，乐极哀来月东出。\n老夫不知其所往，足茧荒山转愁疾。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-267",
    type: "poem",
    title: "韦讽录事宅观曹将军画马",
    content: "国初已来画鞍马，神妙独数江都王。\n将军得名三十载，人间又见真乘黄。\n曾貌先帝照夜白，龙池十日飞霹雳。\n内府殷红玛瑙盘，婕妤传诏才人索。\n盘赐将军拜舞归，轻纨细绮相追飞。\n贵戚权门得笔迹，始觉屏障生光辉。\n昔日太宗拳毛䯄，近时郭家狮子花。\n今之新图有二马，复令识者久叹嗟。\n此皆骑战一敌万，缟素漠漠开风沙。\n其余七匹亦殊绝，迥若寒空动烟雪。\n霜蹄蹴踏长楸间，马官厮养森成列。\n可怜九马争神骏，顾视清高气深稳。\n借问苦心爱者谁，后有韦讽前支遁。\n忆昔巡幸新丰宫，翠华拂天来向东。\n腾骧磊落三万匹，皆与此图筋骨同。\n自从献宝朝河宗，无复射蛟江水中。\n君不见金粟堆前松柏里，龙媒去尽鸟呼风。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-268",
    type: "poem",
    title: "丹青引赠曹霸将军",
    content: "将军魏武之子孙，于今为庶为清门。\n英雄割据虽已矣，文采风流今尚存。\n学书初学卫夫人，但恨无过王右军。\n丹青不知老将至，富贵于我如浮云。\n开元之中常引见，承恩数上南薰殿。\n凌烟功臣少颜色，将军下笔开生面。\n良相头上进贤冠，猛将腰间大羽箭。\n褒公鄂公毛发动，英姿飒爽来酣战。\n先帝御马五花骢，画工如山貌不同。\n是日牵来赤墀下，迥立阊阖生长风。\n诏谓将军拂绢素，意匠惨澹经营中。\n斯须九重真龙出，一洗万古凡马空。\n玉花却在御榻上，榻上庭前屹相向。\n至尊含笑催赐金，圉人太仆皆惆怅。\n弟子韩干早入室，亦能画马穷殊相。\n干惟画肉不画骨，忍使骅骝气凋丧。\n将军画善盖有神，必逢佳士亦写真。\n即今漂泊干戈际，屡貌寻常行路人。\n途穷反遭俗眼白，世上未有如公贫。\n但看古来盛名下，终日坎壈缠其身。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-269",
    type: "poem",
    title: "寄韩谏议",
    content: "今我不乐思岳阳，身欲奋飞病在床。\n美人娟娟隔秋水，濯足洞庭望八荒。\n鸿飞冥冥日月白，青枫叶赤天雨霜。\n玉京群帝集北斗，或骑麒麟翳凤凰。\n芙蓉旌旗烟雾落，影动倒景摇潇湘。\n星宫之君醉琼浆，羽人稀少不在旁。\n似闻昨者赤松子，恐是汉代韩张良。\n昔随刘氏定长安，帷幄未改神惨伤。\n国家成败吾岂敢，色难腥腐餐枫香。\n周南留滞古所惜，南极老人应寿昌。\n美人胡为隔秋水，焉得置之贡玉堂。",
    dynasty: "唐",
    author: "杜甫",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-270",
    type: "poem",
    title: "夜归鹿门山歌",
    content: "山寺钟鸣昼已昏，渔梁渡头争渡喧。\n人随沙岸向江村，余亦乘舟归鹿门。\n鹿门月照开烟树，忽到庞公栖隐处。\n岩扉松径长寂寥，惟有幽人自来去。",
    dynasty: "唐",
    author: "孟浩然",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-271",
    type: "poem",
    title: "渔翁",
    content: "渔翁夜傍西岩宿，晓汲清湘燃楚竹。\n烟销日出不见人，欸乃一声山水绿。\n回看天际下中流，岩上无心云相逐。",
    dynasty: "唐",
    author: "柳宗元",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-272",
    type: "poem",
    title: "登幽州台歌",
    content: "前不见古人，后不见来者。\n念天地之悠悠，独怆然而涕下。",
    dynasty: "唐",
    author: "陈子昂",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-273",
    type: "poem",
    title: "石鼓歌",
    content: "张生手持石鼓文，劝我试作石鼓歌。\n少陵无人谪仙死，才薄将奈石鼓何。\n周纲凌迟四海沸，宣王愤起挥天戈。\n大开明堂受朝贺，诸侯剑佩鸣相磨。\n搜于岐阳骋雄俊，万里禽兽皆遮罗。\n镌功勒成告万世，凿石作鼓隳嵯峨。\n从臣才艺咸第一，拣选撰刻留山阿。\n雨淋日灸野火燎，鬼物守护烦㧑呵。\n公从何处得纸本，毫发尽备无差讹。\n辞严义密读难晓，字体不类隶与蝌。\n年深岂免有缺画，快剑斫断生蛟鼍。\n鸾翔凤翥众仙下，珊瑚碧树交枝柯。\n金绳铁索锁钮壮，古鼎跃水龙腾梭。\n陋儒编诗不收入，二雅褊迫无委蛇。\n孔子西行不到秦，掎摭星宿遗羲娥。\n嗟余好古生苦晚，对此涕泪双滂沱。\n忆昔初蒙博士征，其年始改称元和。\n故人从军在右辅，为我度量掘臼科。\n濯冠沐浴告祭酒，如此至宝存岂多。\n毡包席裹可立致，十鼓只载数骆驼。\n荐诸太庙比郜鼎，光价岂止百倍过。\n圣恩若许留太学，诸生讲解得切磋。\n观经鸿都尚填咽，坐见举国来奔波。\n剜苔剔藓露节角，安置妥帖平不颇。\n大厦深檐与盖覆，经历久远期无佗。\n中朝大官老于事，讵肯感激徒媕婀。\n牧童敲火牛砺角，谁复着手为摩挲。\n日销月铄就埋没，六年西顾空吟哦。\n羲之俗书趁姿媚，数纸尚可博白鹅。\n继周八代争战罢，无人收拾理则那。\n方今太平日无事，柄任儒术崇丘轲。\n安能以此尚论列，愿借辩口如悬河。\n石鼓之歌止于此，呜呼吾意其蹉跎。",
    dynasty: "唐",
    author: "韩愈",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-274",
    type: "poem",
    title: "山石",
    content: "山石荦确行径微，黄昏到寺蝙蝠飞。\n升堂坐阶新雨足，芭蕉叶大栀子肥。\n僧言古壁佛画好，以火来照所见稀。\n铺床拂席置羹饭，疏粝亦足饱我饥。\n夜深静卧百虫绝，清月出岭光入扉。\n天明独去无道路，出入高下穷烟霏。\n山红涧碧纷烂漫，时见松枥皆十围。\n当流赤足踏涧石，水声激激风吹衣。\n人生如此自可乐，岂必局束为人鞿？\n嗟哉吾党二三子，安得至老不更归。",
    dynasty: "唐",
    author: "韩愈",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-275",
    type: "poem",
    title: "八月十五夜赠张功曹",
    content: "纤云四卷天无河，清风吹空月舒波。\n沙平水息声影绝，一杯相属君当歌。\n君歌声酸辞且苦，不能听终泪如雨。\n洞庭连天九疑高，蛟龙出没猩鼯号。\n十生九死到官所，幽居默默如藏逃。\n下床畏蛇食畏药，海气湿蛰薰腥臊。\n昨者州前捶大鼓，嗣皇继圣登夔皋。\n赦书一日行万里，罪从大辟皆除死。\n迁者追回流者还，涤瑕荡垢清朝班。\n州家申名使家抑，坎轲只得移荆蛮。\n判司卑官不堪说，未免捶楚尘埃间。\n同时辈流多上道，天路幽险难追攀。\n君歌且休听我歌，我歌今与君殊科。\n一年明月今宵多，人生由命非由他。\n有酒不饮奈明何。",
    dynasty: "唐",
    author: "韩愈",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-276",
    type: "poem",
    title: "谒衡岳庙遂宿岳寺题门楼",
    content: "五岳祭秩皆三公，四方环镇嵩当中。\n火维地荒足妖怪，天假神柄专其雄。\n喷云泄雾藏半腹，虽有绝顶谁能穷？\n我来正逢秋雨节，阴气晦昧无清风。\n潜心默祷若有应，岂非正直能感通！\n须臾静扫众峰出，仰见突兀撑青空。\n紫盖连延接天柱，石廪腾掷堆祝融。\n森然魄动下马拜，松柏一径趋灵宫。\n粉墙丹柱动光彩，鬼物图画填青红。\n升阶伛偻荐脯酒，欲以菲薄明其衷。\n庙令老人识神意，睢盱侦伺能鞠躬。\n手持杯珓导我掷，云此最吉余难同。\n窜逐蛮荒幸不死，衣食才足甘长终。\n侯王将相望久绝，神纵欲福难为功。\n夜投佛寺上高阁，星月掩映云曈昽。\n猿鸣钟动不知曙，杲杲寒日生于东。",
    dynasty: "唐",
    author: "韩愈",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-277",
    type: "poem",
    title: "凉州词",
    content: "黄河远上白云间，一片孤城万仞山。\n羌笛何须怨杨柳，春风不度玉门关。",
    dynasty: "唐",
    author: "王之涣",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-278",
    type: "poem",
    title: "出塞·秦时明月汉时关",
    content: "秦时明月汉时关，万里长征人未还。\n但使龙城飞将在，不教胡马度阴山。",
    dynasty: "唐",
    author: "王昌龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-279",
    type: "poem",
    title: "塞上曲·蝉鸣空桑林",
    content: "蝉鸣空桑林，八月萧关道。\n出塞入塞寒，处处黄芦草。\n从来幽并客，皆共尘沙老。\n莫学游侠儿，矜夸紫骝好。",
    dynasty: "唐",
    author: "王昌龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-280",
    type: "poem",
    title: "塞下曲·饮马渡秋水",
    content: "饮马渡秋水，水寒风似刀。\n平沙日未没，黯黯见临洮。\n昔日长城战，咸言意气高。\n黄尘足今古，白骨乱蓬蒿。",
    dynasty: "唐",
    author: "王昌龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-281",
    type: "poem",
    title: "长信怨",
    content: "金井梧桐秋叶黄，珠帘不卷夜来霜。\n熏笼玉枕无颜色，卧听南宫清漏长。\n高殿秋砧响夜阑，霜深犹忆御衣寒。\n银灯青琐裁缝歇，还向金城明主看。\n奉帚平明金殿开，暂将团扇共徘徊。\n玉颜不及寒鸦色，犹带昭阳日影来。\n真成薄命久寻思，梦见君王觉后疑。\n火照西宫知夜饮，分明复道奉恩时。\n长信宫中秋月明，昭阳殿下捣衣声。\n白露堂中细草迹，红罗帐里不胜情。",
    dynasty: "唐",
    author: "王昌龄",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-282",
    type: "poem",
    title: "渭城曲",
    content: "渭城朝雨浥轻尘，客舍青青柳色新。\n劝君更尽一杯酒，西出阳关无故人。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-283",
    type: "poem",
    title: "秋夜曲",
    content: "桂魄初生秋露微，轻罗已薄未更衣。\n银筝夜久殷勤弄，心怯空房不忍归。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-284",
    type: "poem",
    title: "洛阳女儿行",
    content: "洛阳女儿对门居，才可颜容十五余。\n良人玉勒乘骢马，侍女金盘脍鲤鱼。\n画阁朱楼尽相望，红桃绿柳垂檐向。\n罗帷送上七香车，宝扇迎归九华帐。\n狂夫富贵在青春，意气骄奢剧季伦。\n自怜碧玉亲教舞，不惜珊瑚持与人。\n春窗曙灭九微火，九微片片飞花琐。\n戏罢曾无理曲时，妆成祗是薰香坐。\n城中相识尽繁华，日夜经过赵李家。\n谁怜越女颜如玉，贫贱江头自浣纱。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-285",
    type: "poem",
    title: "老将行",
    content: "少年十五二十时，步行夺得胡马骑。\n射杀山中白额虎，肯数邺下黄须儿！\n一身转战三千里，一剑曾当百万师。\n汉兵奋迅如霹雳，虏骑崩腾畏蒺藜。\n卫青不败由天幸，李广无功缘数奇。\n自从弃置便衰朽，世事蹉跎成白首。\n昔时飞箭无全目，今日垂杨生左肘。\n路旁时卖故侯瓜，门前学种先生柳。\n苍茫古木连穷巷，寥落寒山对虚牖。\n誓令疏勒出飞泉，不似颍川空使酒。\n贺兰山下阵如云，羽檄交驰日夕闻。\n节使三河募年少，诏书五道出将军。\n试拂铁衣如雪色，聊持宝剑动星文。\n愿得燕弓射大将，耻令越甲鸣吾君。\n莫嫌旧日云中守，犹堪一战取功勋。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-286",
    type: "poem",
    title: "桃源行",
    content: "渔舟逐水爱山春，两岸桃花夹古津。\n坐看红树不知远，行尽青溪不见人。\n山口潜行始隈隩，山开旷望旋平陆。\n遥看一处攒云树，近入千家散花竹。\n樵客初传汉姓名，居人未改秦衣服。\n居人共住武陵源，还从物外起田园。\n月明松下房栊静，日出云中鸡犬喧。\n惊闻俗客争来集，竞引还家问都邑。\n平明闾巷扫花开，薄暮渔樵乘水入。\n初因避地去人间，及至成仙遂不还。\n峡里谁知有人事，世中遥望空云山。\n不疑灵境难闻见，尘心未尽思乡县。\n出洞无论隔山水，辞家终拟长游衍。\n自谓经过旧不迷，安知峰壑今来变。\n当时只记入山深，青溪几度到云林。\n春来遍是桃花水，不辨仙源何处寻。",
    dynasty: "唐",
    author: "王维",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-287",
    type: "poem",
    title: "清平调·云想衣裳花想容",
    content: "云想衣裳花想容，春风拂槛露华浓。\n若非群玉山头见，会向瑶台月下逢。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-288",
    type: "poem",
    title: "清平调·一枝红艳露凝香",
    content: "一枝红艳露凝香，云雨巫山枉断肠。\n借问汉宫谁得似，可怜飞燕倚新妆。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-289",
    type: "poem",
    title: "清平调·名花倾国两相欢",
    content: "名花倾国两相欢，常得君王带笑看。\n解释春风无限恨，沉香亭北倚栏杆。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-290",
    type: "poem",
    title: "行路难·金樽清酒斗十千",
    content: "金樽清酒斗十千，玉盘珍羞直万钱。(羞 通：馐；直 通 值)\n停杯投箸不能食，拔剑四顾心茫然。\n欲渡黄河冰塞川，将登太行雪满山。\n闲来垂钓碧溪上，忽复乘舟梦日边。\n行路难！行路难！多歧路，今安在？\n长风破浪会有时，直挂云帆济沧海。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-291",
    type: "poem",
    title: "行路难·大道如青天",
    content: "大道如青天，我独不得出。\n羞逐长安社中儿，赤鸡白雉赌梨栗。\n弹剑作歌奏苦声，曳裾王门不称情。\n淮阴市井笑韩信，汉朝公卿忌贾生。\n君不见昔时燕家重郭隗，拥篲折节无嫌猜。\n剧辛乐毅感恩分，输肝剖胆效英才。\n昭王白骨萦蔓草，谁人更扫黄金台？\n行路难，归去来！",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-292",
    type: "poem",
    title: "行路难·有耳莫洗颍川水",
    content: "有耳莫洗颍川水，有口莫食首阳蕨。\n含光混世贵无名，何用孤高比云月？\n吾观自古贤达人，功成不退皆殒身。\n子胥既弃吴江上，屈原终投湘水滨。\n陆机雄才岂自保？李斯税驾苦不早。\n华亭鹤唳讵可闻？上蔡苍鹰何足道？\n君不见吴中张翰称达生，秋风忽忆江东行。\n且乐生前一杯酒，何须身后千载名？",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-293",
    type: "poem",
    title: "将进酒",
    content: "君不见，黄河之水天上来，奔流到海不复回。\n君不见，高堂明镜悲白发，朝如青丝暮成雪。\n人生得意须尽欢，莫使金樽空对月。\n天生我材必有用，千金散尽还复来。\n烹羊宰牛且为乐，会须一饮三百杯。\n岑夫子，丹丘生，将进酒，杯莫停。\n与君歌一曲，请君为我倾耳听。\n钟鼓馔玉不足贵，但愿长醉不复醒。\n古来圣贤皆寂寞，惟有饮者留其名。\n陈王昔时宴平乐，斗酒十千恣欢谑。\n主人何为言少钱，径须沽取对君酌。\n五花马，千金裘，呼儿将出换美酒，与尔同销万古愁。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-294",
    type: "poem",
    title: "玉阶怨",
    content: "玉阶生白露，夜久侵罗袜。\n却下水晶帘，玲珑望秋月。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-295",
    type: "poem",
    title: "长相思·其一",
    content: "长相思，在长安。\n络纬秋啼金井阑，微霜凄凄簟色寒。\n孤灯不明思欲绝，卷帷望月空长叹。\n美人如花隔云端！\n上有青冥之长天，下有渌水之波澜。\n天长路远魂飞苦，梦魂不到关山难。\n长相思，摧心肝！",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-296",
    type: "poem",
    title: "长相思·其二",
    content: "日色欲尽花含烟，月明欲素愁不眠。\n赵瑟初停凤凰柱，蜀琴欲奏鸳鸯弦。\n此曲有意无人传，愿随春风寄燕然。\n忆君迢迢隔青天，昔日横波目，今作流泪泉。\n不信妾断肠，归来看取明镜前。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-297",
    type: "poem",
    title: "长干行·其一",
    content: "妾发初覆额，折花门前剧。\n郎骑竹马来，绕床弄青梅。\n同居长干里，两小无嫌猜，\n十四为君妇，羞颜未尝开。\n低头向暗壁，千唤不一回。\n十五始展眉，愿同尘与灰。\n常存抱柱信，岂上望夫台。\n十六君远行，瞿塘滟滪堆。\n五月不可触，猿声天上哀。\n门前迟行迹，一一生绿苔。\n苔深不能扫，落叶秋风早。\n八月蝴蝶来，双飞西园草。\n感此伤妾心，坐愁红颜老。\n早晚下三巴，预将书报家。\n相迎不道远，直至长风沙。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-298",
    type: "poem",
    title: "蜀道难",
    content: "噫吁嚱，危乎高哉！\n蜀道之难，难于上青天！\n蚕丛及鱼凫，开国何茫然！\n尔来四万八千岁，不与秦塞通人烟。\n西当太白有鸟道，可以横绝峨眉巅。\n地崩山摧壮士死，然后天梯石栈相钩连。\n上有六龙回日之高标，下有冲波逆折之回川。\n黄鹤之飞尚不得过，猿猱欲度愁攀援。\n青泥何盘盘，百步九折萦岩峦。\n扪参历井仰胁息，以手抚膺坐长叹。\n问君西游何时还？畏途巉岩不可攀。\n但见悲鸟号古木，雄飞雌从绕林间。\n又闻子规啼夜月，愁空山。\n蜀道之难,难于上青天，使人听此凋朱颜！\n连峰去天不盈尺，枯松倒挂倚绝壁。\n飞湍瀑流争喧豗，砯崖转石万壑雷。\n其险也如此，嗟尔远道之人胡为乎来哉！\n剑阁峥嵘而崔嵬，一夫当关，万夫莫开。\n所守或匪亲，化为狼与豺。\n朝避猛虎，夕避长蛇；磨牙吮血，杀人如麻。\n锦城虽云乐，不如早还家。\n蜀道之难,难于上青天，侧身西望长咨嗟！",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-poem-299",
    type: "poem",
    title: "子夜吴歌·春歌",
    content: "秦地罗敷女，采桑绿水边。\n素手青条上，红妆白日鲜。\n蚕饥妾欲去，五马莫留连。",
    dynasty: "唐",
    author: "李白",
    source: "唐诗三百首",
    createdAt: "2026-09-21T00:00:00.000Z"
  }
];

export const builtinWordKnowledge: KnowledgeItem[] = [
  {
    id: "builtin-word-mother",
    type: "word",
    title: "mother",
    content: "母亲\n/'mʌðә/",
    pronunciation: "/'mʌðә/",
    meaning: "母亲",
    emoji: "👩",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-father",
    type: "word",
    title: "father",
    content: "父亲\n/'fɑ:ðә/",
    pronunciation: "/'fɑ:ðә/",
    meaning: "父亲",
    emoji: "👨",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sister",
    type: "word",
    title: "sister",
    content: "姐妹\n/'sistә/",
    pronunciation: "/'sistә/",
    meaning: "姐妹",
    emoji: "👧",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-brother",
    type: "word",
    title: "brother",
    content: "兄弟\n/'brʌðә/",
    pronunciation: "/'brʌðә/",
    meaning: "兄弟",
    emoji: "👦",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-baby",
    type: "word",
    title: "baby",
    content: "婴孩\n/'beibi/",
    pronunciation: "/'beibi/",
    meaning: "婴孩",
    emoji: "👶",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-family",
    type: "word",
    title: "family",
    content: "家庭\n/'fæmәli/",
    pronunciation: "/'fæmәli/",
    meaning: "家庭",
    emoji: "👨‍👩‍👧",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-friend",
    type: "word",
    title: "friend",
    content: "朋友\n/frend/",
    pronunciation: "/frend/",
    meaning: "朋友",
    emoji: "🧑‍🤝‍🧑",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-teacher",
    type: "word",
    title: "teacher",
    content: "教师\n/'ti:tʃә/",
    pronunciation: "/'ti:tʃә/",
    meaning: "教师",
    emoji: "👩‍🏫",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-student",
    type: "word",
    title: "student",
    content: "学生\n/'stju:dnt/",
    pronunciation: "/'stju:dnt/",
    meaning: "学生",
    emoji: "🧑‍🎓",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-school",
    type: "word",
    title: "school",
    content: "学校\n/sku:l/",
    pronunciation: "/sku:l/",
    meaning: "学校",
    emoji: "🏫",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-classroom",
    type: "word",
    title: "classroom",
    content: "教室\n/'klɑ:sru:m/",
    pronunciation: "/'klɑ:sru:m/",
    meaning: "教室",
    emoji: "🏫",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-desk",
    type: "word",
    title: "desk",
    content: "书桌\n/desk/",
    pronunciation: "/desk/",
    meaning: "书桌",
    emoji: "🪑",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-chair",
    type: "word",
    title: "chair",
    content: "椅子\n/tʃєә/",
    pronunciation: "/tʃєә/",
    meaning: "椅子",
    emoji: "🪑",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pen",
    type: "word",
    title: "pen",
    content: "钢笔\n/pen/",
    pronunciation: "/pen/",
    meaning: "钢笔",
    emoji: "🖊️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pencil",
    type: "word",
    title: "pencil",
    content: "铅笔\n/'pensl/",
    pronunciation: "/'pensl/",
    meaning: "铅笔",
    emoji: "✏️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-ruler",
    type: "word",
    title: "ruler",
    content: "统治者\n/'ru:lә/",
    pronunciation: "/'ru:lә/",
    meaning: "统治者",
    emoji: "📏",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bag",
    type: "word",
    title: "bag",
    content: "袋子\n/bæg/",
    pronunciation: "/bæg/",
    meaning: "袋子",
    emoji: "🎒",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bird",
    type: "word",
    title: "bird",
    content: "鸟\n/bә:d/",
    pronunciation: "/bә:d/",
    meaning: "鸟",
    emoji: "🐦",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-fish",
    type: "word",
    title: "fish",
    content: "鱼\n/fiʃ/",
    pronunciation: "/fiʃ/",
    meaning: "鱼",
    emoji: "🐟",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-tiger",
    type: "word",
    title: "tiger",
    content: "老虎\n/'taigә/",
    pronunciation: "/'taigә/",
    meaning: "老虎",
    emoji: "🐯",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-lion",
    type: "word",
    title: "lion",
    content: "狮子\n/'laiәn/",
    pronunciation: "/'laiәn/",
    meaning: "狮子",
    emoji: "🦁",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-elephant",
    type: "word",
    title: "elephant",
    content: "象\n/'elifәnt/",
    pronunciation: "/'elifәnt/",
    meaning: "象",
    emoji: "🐘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-monkey",
    type: "word",
    title: "monkey",
    content: "猴子\n/'mʌŋki/",
    pronunciation: "/'mʌŋki/",
    meaning: "猴子",
    emoji: "🐵",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-panda",
    type: "word",
    title: "panda",
    content: "大熊猫\n/'pændә/",
    pronunciation: "/'pændә/",
    meaning: "大熊猫",
    emoji: "🐼",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-rabbit",
    type: "word",
    title: "rabbit",
    content: "兔子\n/'ræbit/",
    pronunciation: "/'ræbit/",
    meaning: "兔子",
    emoji: "🐰",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bear",
    type: "word",
    title: "bear",
    content: "熊\n/bєә/",
    pronunciation: "/bєә/",
    meaning: "熊",
    emoji: "🐻",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-horse",
    type: "word",
    title: "horse",
    content: "马\n/hɒ:s/",
    pronunciation: "/hɒ:s/",
    meaning: "马",
    emoji: "🐴",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-cow",
    type: "word",
    title: "cow",
    content: "母牛\n/kau/",
    pronunciation: "/kau/",
    meaning: "母牛",
    emoji: "🐮",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sheep",
    type: "word",
    title: "sheep",
    content: "羊\n/ʃi:p/",
    pronunciation: "/ʃi:p/",
    meaning: "羊",
    emoji: "🐑",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pig",
    type: "word",
    title: "pig",
    content: "猪\n/pig/",
    pronunciation: "/pig/",
    meaning: "猪",
    emoji: "🐷",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-duck",
    type: "word",
    title: "duck",
    content: "鸭子\n/dʌk/",
    pronunciation: "/dʌk/",
    meaning: "鸭子",
    emoji: "🦆",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-chicken",
    type: "word",
    title: "chicken",
    content: "小鸡\n/'tʃikin/",
    pronunciation: "/'tʃikin/",
    meaning: "小鸡",
    emoji: "🐔",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-mouse",
    type: "word",
    title: "mouse",
    content: "老鼠\n/maus/",
    pronunciation: "/maus/",
    meaning: "老鼠",
    emoji: "🐭",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-frog",
    type: "word",
    title: "frog",
    content: "青蛙\n/frɒg/",
    pronunciation: "/frɒg/",
    meaning: "青蛙",
    emoji: "🐸",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-turtle",
    type: "word",
    title: "turtle",
    content: "海龟\n/'tә:tl/",
    pronunciation: "/'tә:tl/",
    meaning: "海龟",
    emoji: "🐢",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-orange",
    type: "word",
    title: "orange",
    content: "柑橘\n/'ɒ:rindʒ/",
    pronunciation: "/'ɒ:rindʒ/",
    meaning: "柑橘",
    emoji: "🍊",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-grape",
    type: "word",
    title: "grape",
    content: "葡萄\n/greip/",
    pronunciation: "/greip/",
    meaning: "葡萄",
    emoji: "🍇",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-strawberry",
    type: "word",
    title: "strawberry",
    content: "草莓\n/'strɒ:bәri/",
    pronunciation: "/'strɒ:bәri/",
    meaning: "草莓",
    emoji: "🍓",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pear",
    type: "word",
    title: "pear",
    content: "梨子\n/pєә/",
    pronunciation: "/pєә/",
    meaning: "梨子",
    emoji: "🍐",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-peach",
    type: "word",
    title: "peach",
    content: "桃子\n/pi:tʃ/",
    pronunciation: "/pi:tʃ/",
    meaning: "桃子",
    emoji: "🍑",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-watermelon",
    type: "word",
    title: "watermelon",
    content: "西瓜\n/'wɒtә.melәn/",
    pronunciation: "/'wɒtә.melәn/",
    meaning: "西瓜",
    emoji: "🍉",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-lemon",
    type: "word",
    title: "lemon",
    content: "柠檬\n/'lemәn/",
    pronunciation: "/'lemәn/",
    meaning: "柠檬",
    emoji: "🍋",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-mango",
    type: "word",
    title: "mango",
    content: "芒果\n/'mæŋgәu/",
    pronunciation: "/'mæŋgәu/",
    meaning: "芒果",
    emoji: "🥭",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-cherry",
    type: "word",
    title: "cherry",
    content: "樱桃\n/'tʃeri/",
    pronunciation: "/'tʃeri/",
    meaning: "樱桃",
    emoji: "🍒",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-carrot",
    type: "word",
    title: "carrot",
    content: "胡萝卜\n/'kærәt/",
    pronunciation: "/'kærәt/",
    meaning: "胡萝卜",
    emoji: "🥕",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-tomato",
    type: "word",
    title: "tomato",
    content: "番茄\n/tә'mɑ:tәu/",
    pronunciation: "/tә'mɑ:tәu/",
    meaning: "番茄",
    emoji: "🍅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-potato",
    type: "word",
    title: "potato",
    content: "马铃薯\n/pә'teitәu/",
    pronunciation: "/pә'teitәu/",
    meaning: "马铃薯",
    emoji: "🥔",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-onion",
    type: "word",
    title: "onion",
    content: "洋葱\n/'ʌnjәn/",
    pronunciation: "/'ʌnjәn/",
    meaning: "洋葱",
    emoji: "🧅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pumpkin",
    type: "word",
    title: "pumpkin",
    content: "南瓜\n/'pʌmpkin/",
    pronunciation: "/'pʌmpkin/",
    meaning: "南瓜",
    emoji: "🎃",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-corn",
    type: "word",
    title: "corn",
    content: "玉蜀黍\n/kɒ:n/",
    pronunciation: "/kɒ:n/",
    meaning: "玉蜀黍",
    emoji: "🌽",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bread",
    type: "word",
    title: "bread",
    content: "面包\n/bred/",
    pronunciation: "/bred/",
    meaning: "面包",
    emoji: "🍞",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-milk",
    type: "word",
    title: "milk",
    content: "奶\n/milk/",
    pronunciation: "/milk/",
    meaning: "奶",
    emoji: "🥛",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-water",
    type: "word",
    title: "water",
    content: "水\n/'wɒ:tә/",
    pronunciation: "/'wɒ:tә/",
    meaning: "水",
    emoji: "💧",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-juice",
    type: "word",
    title: "juice",
    content: "汁\n/dʒu:s/",
    pronunciation: "/dʒu:s/",
    meaning: "汁",
    emoji: "🧃",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-rice",
    type: "word",
    title: "rice",
    content: "米\n/rais/",
    pronunciation: "/rais/",
    meaning: "米",
    emoji: "🍚",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-noodle",
    type: "word",
    title: "noodle",
    content: "面条\n/'nu:dl/",
    pronunciation: "/'nu:dl/",
    meaning: "面条",
    emoji: "🍜",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-egg",
    type: "word",
    title: "egg",
    content: "蛋\n/eg/",
    pronunciation: "/eg/",
    meaning: "蛋",
    emoji: "🥚",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-cake",
    type: "word",
    title: "cake",
    content: "蛋糕\n/keik/",
    pronunciation: "/keik/",
    meaning: "蛋糕",
    emoji: "🍰",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-candy",
    type: "word",
    title: "candy",
    content: "糖果\n/'kændi/",
    pronunciation: "/'kændi/",
    meaning: "糖果",
    emoji: "🍬",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-cookie",
    type: "word",
    title: "cookie",
    content: "饼干\n/'kuki/",
    pronunciation: "/'kuki/",
    meaning: "饼干",
    emoji: "🍪",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-chocolate",
    type: "word",
    title: "chocolate",
    content: "巧克力\n/'tʃɒkәlit/",
    pronunciation: "/'tʃɒkәlit/",
    meaning: "巧克力",
    emoji: "🍫",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-cheese",
    type: "word",
    title: "cheese",
    content: "乳酪\n/tʃi:z/",
    pronunciation: "/tʃi:z/",
    meaning: "乳酪",
    emoji: "🧀",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-soup",
    type: "word",
    title: "soup",
    content: "汤\n/su:p/",
    pronunciation: "/su:p/",
    meaning: "汤",
    emoji: "🥣",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-meat",
    type: "word",
    title: "meat",
    content: "肉\n/mi:t/",
    pronunciation: "/mi:t/",
    meaning: "肉",
    emoji: "🥩",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-beef",
    type: "word",
    title: "beef",
    content: "牛肉\n/bi:f/",
    pronunciation: "/bi:f/",
    meaning: "牛肉",
    emoji: "🥩",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pork",
    type: "word",
    title: "pork",
    content: "猪肉\n/pɒ:k/",
    pronunciation: "/pɒ:k/",
    meaning: "猪肉",
    emoji: "🥩",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-salad",
    type: "word",
    title: "salad",
    content: "色拉\n/'sælәd/",
    pronunciation: "/'sælәd/",
    meaning: "色拉",
    emoji: "🥗",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sandwich",
    type: "word",
    title: "sandwich",
    content: "三明治\n/'sændwitʃ/",
    pronunciation: "/'sændwitʃ/",
    meaning: "三明治",
    emoji: "🥪",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pizza",
    type: "word",
    title: "pizza",
    content: "比萨饼\n/'pi:tsә/",
    pronunciation: "/'pi:tsә/",
    meaning: "比萨饼",
    emoji: "🍕",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-head",
    type: "word",
    title: "head",
    content: "头\n/hed/",
    pronunciation: "/hed/",
    meaning: "头",
    emoji: "🙂",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-eye",
    type: "word",
    title: "eye",
    content: "眼睛\n/ai/",
    pronunciation: "/ai/",
    meaning: "眼睛",
    emoji: "👁️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-ear",
    type: "word",
    title: "ear",
    content: "耳朵\n/iә/",
    pronunciation: "/iә/",
    meaning: "耳朵",
    emoji: "👂",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-nose",
    type: "word",
    title: "nose",
    content: "鼻子\n/nәuz/",
    pronunciation: "/nәuz/",
    meaning: "鼻子",
    emoji: "👃",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-mouth",
    type: "word",
    title: "mouth",
    content: "嘴\n/mauθ/",
    pronunciation: "/mauθ/",
    meaning: "嘴",
    emoji: "👄",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-hand",
    type: "word",
    title: "hand",
    content: "手\n/hænd/",
    pronunciation: "/hænd/",
    meaning: "手",
    emoji: "✋",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-foot",
    type: "word",
    title: "foot",
    content: "脚\n/fut/",
    pronunciation: "/fut/",
    meaning: "脚",
    emoji: "🦶",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-arm",
    type: "word",
    title: "arm",
    content: "手臂\n/ɑ:m/",
    pronunciation: "/ɑ:m/",
    meaning: "手臂",
    emoji: "💪",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-leg",
    type: "word",
    title: "leg",
    content: "腿\n/leg/",
    pronunciation: "/leg/",
    meaning: "腿",
    emoji: "🦵",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-face",
    type: "word",
    title: "face",
    content: "脸\n/feis/",
    pronunciation: "/feis/",
    meaning: "脸",
    emoji: "🙂",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-hair",
    type: "word",
    title: "hair",
    content: "头发\n/hєә/",
    pronunciation: "/hєә/",
    meaning: "头发",
    emoji: "💇",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-tooth",
    type: "word",
    title: "tooth",
    content: "牙齿\n/tu:θ/",
    pronunciation: "/tu:θ/",
    meaning: "牙齿",
    emoji: "🦷",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-tongue",
    type: "word",
    title: "tongue",
    content: "舌\n/tʌŋ/",
    pronunciation: "/tʌŋ/",
    meaning: "舌",
    emoji: "👅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-finger",
    type: "word",
    title: "finger",
    content: "手指\n/'fiŋgә/",
    pronunciation: "/'fiŋgә/",
    meaning: "手指",
    emoji: "☝️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-knee",
    type: "word",
    title: "knee",
    content: "膝\n/ni:/",
    pronunciation: "/ni:/",
    meaning: "膝",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-shoulder",
    type: "word",
    title: "shoulder",
    content: "肩\n/'ʃәuldә/",
    pronunciation: "/'ʃәuldә/",
    meaning: "肩",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-back",
    type: "word",
    title: "back",
    content: "后面的\n/bæk/",
    pronunciation: "/bæk/",
    meaning: "后面的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-heart",
    type: "word",
    title: "heart",
    content: "心\n/hɑ:t/",
    pronunciation: "/hɑ:t/",
    meaning: "心",
    emoji: "❤️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-red",
    type: "word",
    title: "red",
    content: "红的\n/red/",
    pronunciation: "/red/",
    meaning: "红的",
    emoji: "🔴",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-yellow",
    type: "word",
    title: "yellow",
    content: "黄色\n/'jelәu/",
    pronunciation: "/'jelәu/",
    meaning: "黄色",
    emoji: "🟡",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-green",
    type: "word",
    title: "green",
    content: "绿色\n/gri:n/",
    pronunciation: "/gri:n/",
    meaning: "绿色",
    emoji: "🟢",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-blue",
    type: "word",
    title: "blue",
    content: "蓝色\n/blu:/",
    pronunciation: "/blu:/",
    meaning: "蓝色",
    emoji: "🔵",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-purple",
    type: "word",
    title: "purple",
    content: "紫色\n/'pә:pl/",
    pronunciation: "/'pә:pl/",
    meaning: "紫色",
    emoji: "🟣",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pink",
    type: "word",
    title: "pink",
    content: "粉红色\n/piŋk/",
    pronunciation: "/piŋk/",
    meaning: "粉红色",
    emoji: "🩷",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-black",
    type: "word",
    title: "black",
    content: "黑色\n/blæk/",
    pronunciation: "/blæk/",
    meaning: "黑色",
    emoji: "⚫",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-white",
    type: "word",
    title: "white",
    content: "白色\n/hwait/",
    pronunciation: "/hwait/",
    meaning: "白色",
    emoji: "⚪",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-brown",
    type: "word",
    title: "brown",
    content: "褐色\n/braun/",
    pronunciation: "/braun/",
    meaning: "褐色",
    emoji: "🟤",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-gray",
    type: "word",
    title: "gray",
    content: "灰色\n/grei/",
    pronunciation: "/grei/",
    meaning: "灰色",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-grey",
    type: "word",
    title: "grey",
    content: "灰色\n/grei/",
    pronunciation: "/grei/",
    meaning: "灰色",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-gold",
    type: "word",
    title: "gold",
    content: "黄金\n/gәuld/",
    pronunciation: "/gәuld/",
    meaning: "黄金",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-silver",
    type: "word",
    title: "silver",
    content: "银\n/'silvә/",
    pronunciation: "/'silvә/",
    meaning: "银",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-one",
    type: "word",
    title: "one",
    content: "一(个)\n/wʌn/",
    pronunciation: "/wʌn/",
    meaning: "一(个)",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-two",
    type: "word",
    title: "two",
    content: "二\n/tu:/",
    pronunciation: "/tu:/",
    meaning: "二",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-three",
    type: "word",
    title: "three",
    content: "三\n/θri:/",
    pronunciation: "/θri:/",
    meaning: "三",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-four",
    type: "word",
    title: "four",
    content: "四\n/fɒ:/",
    pronunciation: "/fɒ:/",
    meaning: "四",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-five",
    type: "word",
    title: "five",
    content: "五\n/faiv/",
    pronunciation: "/faiv/",
    meaning: "五",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-six",
    type: "word",
    title: "six",
    content: "六\n/siks/",
    pronunciation: "/siks/",
    meaning: "六",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-seven",
    type: "word",
    title: "seven",
    content: "七\n/'sevn/",
    pronunciation: "/'sevn/",
    meaning: "七",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-eight",
    type: "word",
    title: "eight",
    content: "八\n/eit/",
    pronunciation: "/eit/",
    meaning: "八",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-nine",
    type: "word",
    title: "nine",
    content: "九\n/nain/",
    pronunciation: "/nain/",
    meaning: "九",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-ten",
    type: "word",
    title: "ten",
    content: "十\n/ten/",
    pronunciation: "/ten/",
    meaning: "十",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-eleven",
    type: "word",
    title: "eleven",
    content: "十一\n/i'levn/",
    pronunciation: "/i'levn/",
    meaning: "十一",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-twelve",
    type: "word",
    title: "twelve",
    content: "十二\n/twelv/",
    pronunciation: "/twelv/",
    meaning: "十二",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-thirteen",
    type: "word",
    title: "thirteen",
    content: "十三\n/'θә:'ti:n/",
    pronunciation: "/'θә:'ti:n/",
    meaning: "十三",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-fourteen",
    type: "word",
    title: "fourteen",
    content: "十四\n/'fɒ:'ti:n/",
    pronunciation: "/'fɒ:'ti:n/",
    meaning: "十四",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-fifteen",
    type: "word",
    title: "fifteen",
    content: "十五\n/'fif'ti:n/",
    pronunciation: "/'fif'ti:n/",
    meaning: "十五",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sixteen",
    type: "word",
    title: "sixteen",
    content: "十六\n/'siks'ti:n/",
    pronunciation: "/'siks'ti:n/",
    meaning: "十六",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-seventeen",
    type: "word",
    title: "seventeen",
    content: "十七\n/sevn'ti:n/",
    pronunciation: "/sevn'ti:n/",
    meaning: "十七",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-eighteen",
    type: "word",
    title: "eighteen",
    content: "十八\n/'ei'ti:n/",
    pronunciation: "/'ei'ti:n/",
    meaning: "十八",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-nineteen",
    type: "word",
    title: "nineteen",
    content: "十九\n/.nain'ti:n/",
    pronunciation: "/.nain'ti:n/",
    meaning: "十九",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-twenty",
    type: "word",
    title: "twenty",
    content: "二十\n/'twenti/",
    pronunciation: "/'twenti/",
    meaning: "二十",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-star",
    type: "word",
    title: "star",
    content: "星\n/stɑ:/",
    pronunciation: "/stɑ:/",
    meaning: "星",
    emoji: "⭐",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sky",
    type: "word",
    title: "sky",
    content: "天空\n/skai/",
    pronunciation: "/skai/",
    meaning: "天空",
    emoji: "☁️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-cloud",
    type: "word",
    title: "cloud",
    content: "云\n/klaud/",
    pronunciation: "/klaud/",
    meaning: "云",
    emoji: "☁️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-rain",
    type: "word",
    title: "rain",
    content: "雨\n/rein/",
    pronunciation: "/rein/",
    meaning: "雨",
    emoji: "🌧️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-snow",
    type: "word",
    title: "snow",
    content: "雪\n/snәu/",
    pronunciation: "/snәu/",
    meaning: "雪",
    emoji: "❄️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-wind",
    type: "word",
    title: "wind",
    content: "风\n/wind/",
    pronunciation: "/wind/",
    meaning: "风",
    emoji: "🌬️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-storm",
    type: "word",
    title: "storm",
    content: "暴风雨\n/stɒ:m/",
    pronunciation: "/stɒ:m/",
    meaning: "暴风雨",
    emoji: "⛈️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-rainbow",
    type: "word",
    title: "rainbow",
    content: "彩虹\n/'reinbәu/",
    pronunciation: "/'reinbәu/",
    meaning: "彩虹",
    emoji: "🌈",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-flower",
    type: "word",
    title: "flower",
    content: "花\n/'flauә/",
    pronunciation: "/'flauә/",
    meaning: "花",
    emoji: "🌸",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-grass",
    type: "word",
    title: "grass",
    content: "草\n/græs/",
    pronunciation: "/græs/",
    meaning: "草",
    emoji: "🌿",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-leaf",
    type: "word",
    title: "leaf",
    content: "叶\n/li:f/",
    pronunciation: "/li:f/",
    meaning: "叶",
    emoji: "🍃",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-river",
    type: "word",
    title: "river",
    content: "河\n/'rivә/",
    pronunciation: "/'rivә/",
    meaning: "河",
    emoji: "🏞️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-lake",
    type: "word",
    title: "lake",
    content: "湖\n/leik/",
    pronunciation: "/leik/",
    meaning: "湖",
    emoji: "🏞️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-mountain",
    type: "word",
    title: "mountain",
    content: "山\n/'mauntin/",
    pronunciation: "/'mauntin/",
    meaning: "山",
    emoji: "⛰️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-hill",
    type: "word",
    title: "hill",
    content: "小山\n/hil/",
    pronunciation: "/hil/",
    meaning: "小山",
    emoji: "⛰️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sea",
    type: "word",
    title: "sea",
    content: "海\n/si:/",
    pronunciation: "/si:/",
    meaning: "海",
    emoji: "🌊",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-ocean",
    type: "word",
    title: "ocean",
    content: "海洋\n/'әuʃәn/",
    pronunciation: "/'әuʃәn/",
    meaning: "海洋",
    emoji: "🌊",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-beach",
    type: "word",
    title: "beach",
    content: "海滩\n/bi:tʃ/",
    pronunciation: "/bi:tʃ/",
    meaning: "海滩",
    emoji: "🏖️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-spring",
    type: "word",
    title: "spring",
    content: "春天\n/spriŋ/",
    pronunciation: "/spriŋ/",
    meaning: "春天",
    emoji: "🌷",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-summer",
    type: "word",
    title: "summer",
    content: "夏季\n/'sʌmә/",
    pronunciation: "/'sʌmә/",
    meaning: "夏季",
    emoji: "🌞",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-autumn",
    type: "word",
    title: "autumn",
    content: "秋天\n/'ɒ:tәm/",
    pronunciation: "/'ɒ:tәm/",
    meaning: "秋天",
    emoji: "🍂",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-winter",
    type: "word",
    title: "winter",
    content: "冬季\n/'wintә/",
    pronunciation: "/'wintә/",
    meaning: "冬季",
    emoji: "⛄",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-morning",
    type: "word",
    title: "morning",
    content: "早晨\n/'mɒ:niŋ/",
    pronunciation: "/'mɒ:niŋ/",
    meaning: "早晨",
    emoji: "🌅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-afternoon",
    type: "word",
    title: "afternoon",
    content: "午后\n/'ɑ:ftә'nu:n/",
    pronunciation: "/'ɑ:ftә'nu:n/",
    meaning: "午后",
    emoji: "🌤️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-evening",
    type: "word",
    title: "evening",
    content: "傍晚\n/'i:vniŋ/",
    pronunciation: "/'i:vniŋ/",
    meaning: "傍晚",
    emoji: "🌆",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-night",
    type: "word",
    title: "night",
    content: "夜\n/nait/",
    pronunciation: "/nait/",
    meaning: "夜",
    emoji: "🌃",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-today",
    type: "word",
    title: "today",
    content: "今天\n/tә'dei/",
    pronunciation: "/tә'dei/",
    meaning: "今天",
    emoji: "📅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-tomorrow",
    type: "word",
    title: "tomorrow",
    content: "明天\n/tә'mɒ:rәu/",
    pronunciation: "/tә'mɒ:rәu/",
    meaning: "明天",
    emoji: "📅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-yesterday",
    type: "word",
    title: "yesterday",
    content: "昨天\n/'jestәdi/",
    pronunciation: "/'jestәdi/",
    meaning: "昨天",
    emoji: "📅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-week",
    type: "word",
    title: "week",
    content: "星期\n/wi:k/",
    pronunciation: "/wi:k/",
    meaning: "星期",
    emoji: "📅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-month",
    type: "word",
    title: "month",
    content: "月\n/mʌnθ/",
    pronunciation: "/mʌnθ/",
    meaning: "月",
    emoji: "📅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-year",
    type: "word",
    title: "year",
    content: "年\n/jiә/",
    pronunciation: "/jiә/",
    meaning: "年",
    emoji: "📅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-birthday",
    type: "word",
    title: "birthday",
    content: "生日\n/'bә:θdei/",
    pronunciation: "/'bә:θdei/",
    meaning: "生日",
    emoji: "🎂",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-holiday",
    type: "word",
    title: "holiday",
    content: "假日\n/'hɒlәdi/",
    pronunciation: "/'hɒlәdi/",
    meaning: "假日",
    emoji: "🎉",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-happy",
    type: "word",
    title: "happy",
    content: "快乐的\n/'hæpi/",
    pronunciation: "/'hæpi/",
    meaning: "快乐的",
    emoji: "😊",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sad",
    type: "word",
    title: "sad",
    content: "忧愁的\n/sæd/",
    pronunciation: "/sæd/",
    meaning: "忧愁的",
    emoji: "😢",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-angry",
    type: "word",
    title: "angry",
    content: "生气的\n/'æŋgri/",
    pronunciation: "/'æŋgri/",
    meaning: "生气的",
    emoji: "😠",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-scared",
    type: "word",
    title: "scared",
    content: "害怕的\n/skeәd/",
    pronunciation: "/skeәd/",
    meaning: "害怕的",
    emoji: "😨",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-tired",
    type: "word",
    title: "tired",
    content: "疲累的\n/taiәd/",
    pronunciation: "/taiәd/",
    meaning: "疲累的",
    emoji: "😴",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-excited",
    type: "word",
    title: "excited",
    content: "兴奋的\n/ik'saitid/",
    pronunciation: "/ik'saitid/",
    meaning: "兴奋的",
    emoji: "🤩",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-surprised",
    type: "word",
    title: "surprised",
    content: "感到惊讶的\n/sә'praizd/",
    pronunciation: "/sә'praizd/",
    meaning: "感到惊讶的",
    emoji: "😲",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bored",
    type: "word",
    title: "bored",
    content: "无聊的",
    meaning: "无聊的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-calm",
    type: "word",
    title: "calm",
    content: "平稳\n/kɑ:m/",
    pronunciation: "/kɑ:m/",
    meaning: "平稳",
    emoji: "😌",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sleepy",
    type: "word",
    title: "sleepy",
    content: "困乏的\n/'sli:pi/",
    pronunciation: "/'sli:pi/",
    meaning: "困乏的",
    emoji: "😴",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-hungry",
    type: "word",
    title: "hungry",
    content: "饥饿的\n/'hʌŋgi/",
    pronunciation: "/'hʌŋgi/",
    meaning: "饥饿的",
    emoji: "🍽️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-thirsty",
    type: "word",
    title: "thirsty",
    content: "口渴的\n/'θә:sti/",
    pronunciation: "/'θә:sti/",
    meaning: "口渴的",
    emoji: "🥤",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-big",
    type: "word",
    title: "big",
    content: "大的\n/big/",
    pronunciation: "/big/",
    meaning: "大的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-small",
    type: "word",
    title: "small",
    content: "小的\n/smɒ:l/",
    pronunciation: "/smɒ:l/",
    meaning: "小的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-tall",
    type: "word",
    title: "tall",
    content: "高的\n/tɒ:l/",
    pronunciation: "/tɒ:l/",
    meaning: "高的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-short",
    type: "word",
    title: "short",
    content: "短的\n/ʃɒ:t/",
    pronunciation: "/ʃɒ:t/",
    meaning: "短的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-long",
    type: "word",
    title: "long",
    content: "长的\n/lɒŋ/",
    pronunciation: "/lɒŋ/",
    meaning: "长的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-fast",
    type: "word",
    title: "fast",
    content: "快速的\n/fɑ:st/",
    pronunciation: "/fɑ:st/",
    meaning: "快速的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-slow",
    type: "word",
    title: "slow",
    content: "慢的\n/slәu/",
    pronunciation: "/slәu/",
    meaning: "慢的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-hot",
    type: "word",
    title: "hot",
    content: "热的\n/hɒt/",
    pronunciation: "/hɒt/",
    meaning: "热的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-cold",
    type: "word",
    title: "cold",
    content: "感冒\n/kәuld/",
    pronunciation: "/kәuld/",
    meaning: "感冒",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-warm",
    type: "word",
    title: "warm",
    content: "暖和的\n/wɒ:m/",
    pronunciation: "/wɒ:m/",
    meaning: "暖和的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-cool",
    type: "word",
    title: "cool",
    content: "凉爽\n/ku:l/",
    pronunciation: "/ku:l/",
    meaning: "凉爽",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-clean",
    type: "word",
    title: "clean",
    content: "干净的\n/kli:n/",
    pronunciation: "/kli:n/",
    meaning: "干净的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-dirty",
    type: "word",
    title: "dirty",
    content: "肮脏的\n/'dә:ti/",
    pronunciation: "/'dә:ti/",
    meaning: "肮脏的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-new",
    type: "word",
    title: "new",
    content: "新的\n/nju:/",
    pronunciation: "/nju:/",
    meaning: "新的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-old",
    type: "word",
    title: "old",
    content: "以前\n/әuld/",
    pronunciation: "/әuld/",
    meaning: "以前",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-young",
    type: "word",
    title: "young",
    content: "年轻的\n/jʌŋ/",
    pronunciation: "/jʌŋ/",
    meaning: "年轻的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-beautiful",
    type: "word",
    title: "beautiful",
    content: "美丽的\n/'bju:tiful/",
    pronunciation: "/'bju:tiful/",
    meaning: "美丽的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-cute",
    type: "word",
    title: "cute",
    content: "可爱的\n/kju:t/",
    pronunciation: "/kju:t/",
    meaning: "可爱的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-funny",
    type: "word",
    title: "funny",
    content: "好笑的\n/'fʌni/",
    pronunciation: "/'fʌni/",
    meaning: "好笑的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-kind",
    type: "word",
    title: "kind",
    content: "种类\n/kaind/",
    pronunciation: "/kaind/",
    meaning: "种类",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-brave",
    type: "word",
    title: "brave",
    content: "勇敢的\n/breiv/",
    pronunciation: "/breiv/",
    meaning: "勇敢的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-eat",
    type: "word",
    title: "eat",
    content: "吃\n/i:t/",
    pronunciation: "/i:t/",
    meaning: "吃",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-drink",
    type: "word",
    title: "drink",
    content: "饮料\n/driŋk/",
    pronunciation: "/driŋk/",
    meaning: "饮料",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-run",
    type: "word",
    title: "run",
    content: "跑\n/rʌn/",
    pronunciation: "/rʌn/",
    meaning: "跑",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-walk",
    type: "word",
    title: "walk",
    content: "走\n/wɒ:k/",
    pronunciation: "/wɒ:k/",
    meaning: "走",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-jump",
    type: "word",
    title: "jump",
    content: "跳跃\n/dʒʌmp/",
    pronunciation: "/dʒʌmp/",
    meaning: "跳跃",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-swim",
    type: "word",
    title: "swim",
    content: "游泳\n/swim/",
    pronunciation: "/swim/",
    meaning: "游泳",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sing",
    type: "word",
    title: "sing",
    content: "唱\n/siŋ/",
    pronunciation: "/siŋ/",
    meaning: "唱",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-dance",
    type: "word",
    title: "dance",
    content: "跳舞\n/dæns. dɑ:ns/",
    pronunciation: "/dæns. dɑ:ns/",
    meaning: "跳舞",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-read",
    type: "word",
    title: "read",
    content: "读\n/ri:d/",
    pronunciation: "/ri:d/",
    meaning: "读",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-write",
    type: "word",
    title: "write",
    content: "书写\n/rait/",
    pronunciation: "/rait/",
    meaning: "书写",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-draw",
    type: "word",
    title: "draw",
    content: "拉\n/drɒ:/",
    pronunciation: "/drɒ:/",
    meaning: "拉",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-paint",
    type: "word",
    title: "paint",
    content: "油漆\n/peint/",
    pronunciation: "/peint/",
    meaning: "油漆",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-play",
    type: "word",
    title: "play",
    content: "游戏\n/plei/",
    pronunciation: "/plei/",
    meaning: "游戏",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sleep",
    type: "word",
    title: "sleep",
    content: "睡眠\n/sli:p/",
    pronunciation: "/sli:p/",
    meaning: "睡眠",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-wake",
    type: "word",
    title: "wake",
    content: "叫醒\n/weik/",
    pronunciation: "/weik/",
    meaning: "叫醒",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sit",
    type: "word",
    title: "sit",
    content: "坐\n/sit/",
    pronunciation: "/sit/",
    meaning: "坐",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-stand",
    type: "word",
    title: "stand",
    content: "站立\n/stænd/",
    pronunciation: "/stænd/",
    meaning: "站立",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-open",
    type: "word",
    title: "open",
    content: "公开\n/'әupәn/",
    pronunciation: "/'әupәn/",
    meaning: "公开",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-close",
    type: "word",
    title: "close",
    content: "结束\n/klәuz/",
    pronunciation: "/klәuz/",
    meaning: "结束",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-look",
    type: "word",
    title: "look",
    content: "一看\n/luk/",
    pronunciation: "/luk/",
    meaning: "一看",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-listen",
    type: "word",
    title: "listen",
    content: "听\n/'lisn/",
    pronunciation: "/'lisn/",
    meaning: "听",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-speak",
    type: "word",
    title: "speak",
    content: "说\n/spi:k/",
    pronunciation: "/spi:k/",
    meaning: "说",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-love",
    type: "word",
    title: "love",
    content: "爱\n/lʌv/",
    pronunciation: "/lʌv/",
    meaning: "爱",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-like",
    type: "word",
    title: "like",
    content: "相似的\n/laik/",
    pronunciation: "/laik/",
    meaning: "相似的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-want",
    type: "word",
    title: "want",
    content: "需要的东西\n/wɒnt/",
    pronunciation: "/wɒnt/",
    meaning: "需要的东西",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-need",
    type: "word",
    title: "need",
    content: "需要\n/ni:d/",
    pronunciation: "/ni:d/",
    meaning: "需要",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-help",
    type: "word",
    title: "help",
    content: "帮忙\n/help/",
    pronunciation: "/help/",
    meaning: "帮忙",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-give",
    type: "word",
    title: "give",
    content: "弹性\n/giv/",
    pronunciation: "/giv/",
    meaning: "弹性",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-take",
    type: "word",
    title: "take",
    content: "拿\n/teik/",
    pronunciation: "/teik/",
    meaning: "拿",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-make",
    type: "word",
    title: "make",
    content: "制造\n/meik/",
    pronunciation: "/meik/",
    meaning: "制造",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-build",
    type: "word",
    title: "build",
    content: "建立\n/bild/",
    pronunciation: "/bild/",
    meaning: "建立",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-find",
    type: "word",
    title: "find",
    content: "发现\n/faind/",
    pronunciation: "/faind/",
    meaning: "发现",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-start",
    type: "word",
    title: "start",
    content: "惊起\n/stɑ:t/",
    pronunciation: "/stɑ:t/",
    meaning: "惊起",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-stop",
    type: "word",
    title: "stop",
    content: "停止\n/stɒp/",
    pronunciation: "/stɒp/",
    meaning: "停止",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-turn",
    type: "word",
    title: "turn",
    content: "转弯\n/tә:n/",
    pronunciation: "/tә:n/",
    meaning: "转弯",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-push",
    type: "word",
    title: "push",
    content: "推\n/puʃ/",
    pronunciation: "/puʃ/",
    meaning: "推",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pull",
    type: "word",
    title: "pull",
    content: "拉\n/pul/",
    pronunciation: "/pul/",
    meaning: "拉",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-carry",
    type: "word",
    title: "carry",
    content: "进位\n/'kæri/",
    pronunciation: "/'kæri/",
    meaning: "进位",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-climb",
    type: "word",
    title: "climb",
    content: "攀登\n/klaim/",
    pronunciation: "/klaim/",
    meaning: "攀登",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-ride",
    type: "word",
    title: "ride",
    content: "骑马\n/raid/",
    pronunciation: "/raid/",
    meaning: "骑马",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-fly",
    type: "word",
    title: "fly",
    content: "苍蝇\n/flai/",
    pronunciation: "/flai/",
    meaning: "苍蝇",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-car",
    type: "word",
    title: "car",
    content: "汽车\n/kɑ:/",
    pronunciation: "/kɑ:/",
    meaning: "汽车",
    emoji: "🚗",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bus",
    type: "word",
    title: "bus",
    content: "公共汽车\n/bʌs/",
    pronunciation: "/bʌs/",
    meaning: "公共汽车",
    emoji: "🚌",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-train",
    type: "word",
    title: "train",
    content: "火车\n/trein/",
    pronunciation: "/trein/",
    meaning: "火车",
    emoji: "🚆",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bike",
    type: "word",
    title: "bike",
    content: "自行车\n/baik/",
    pronunciation: "/baik/",
    meaning: "自行车",
    emoji: "🚲",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bicycle",
    type: "word",
    title: "bicycle",
    content: "自行车\n/'baisikl/",
    pronunciation: "/'baisikl/",
    meaning: "自行车",
    emoji: "🚲",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-plane",
    type: "word",
    title: "plane",
    content: "平面\n/plein/",
    pronunciation: "/plein/",
    meaning: "平面",
    emoji: "✈️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-boat",
    type: "word",
    title: "boat",
    content: "船\n/bәut/",
    pronunciation: "/bәut/",
    meaning: "船",
    emoji: "⛵",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-ship",
    type: "word",
    title: "ship",
    content: "船\n/ʃip/",
    pronunciation: "/ʃip/",
    meaning: "船",
    emoji: "🚢",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-taxi",
    type: "word",
    title: "taxi",
    content: "出租车\n/'tæksi/",
    pronunciation: "/'tæksi/",
    meaning: "出租车",
    emoji: "🚕",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-truck",
    type: "word",
    title: "truck",
    content: "卡车\n/trʌk/",
    pronunciation: "/trʌk/",
    meaning: "卡车",
    emoji: "🚚",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-road",
    type: "word",
    title: "road",
    content: "路\n/rәud/",
    pronunciation: "/rәud/",
    meaning: "路",
    emoji: "🛣️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-street",
    type: "word",
    title: "street",
    content: "街道\n/stri:t/",
    pronunciation: "/stri:t/",
    meaning: "街道",
    emoji: "🛣️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bridge",
    type: "word",
    title: "bridge",
    content: "桥\n/bridʒ/",
    pronunciation: "/bridʒ/",
    meaning: "桥",
    emoji: "🌉",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-city",
    type: "word",
    title: "city",
    content: "城市\n/'siti/",
    pronunciation: "/'siti/",
    meaning: "城市",
    emoji: "🏙️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-village",
    type: "word",
    title: "village",
    content: "村庄\n/'vilidʒ/",
    pronunciation: "/'vilidʒ/",
    meaning: "村庄",
    emoji: "🏘️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-house",
    type: "word",
    title: "house",
    content: "房子\n/haus/",
    pronunciation: "/haus/",
    meaning: "房子",
    emoji: "🏠",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-home",
    type: "word",
    title: "home",
    content: "家\n/hәum/",
    pronunciation: "/hәum/",
    meaning: "家",
    emoji: "🏠",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-room",
    type: "word",
    title: "room",
    content: "房间\n/ru:m/",
    pronunciation: "/ru:m/",
    meaning: "房间",
    emoji: "🛏️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-kitchen",
    type: "word",
    title: "kitchen",
    content: "厨房\n/'kitʃin/",
    pronunciation: "/'kitʃin/",
    meaning: "厨房",
    emoji: "🍳",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bedroom",
    type: "word",
    title: "bedroom",
    content: "卧室\n/'bedrum/",
    pronunciation: "/'bedrum/",
    meaning: "卧室",
    emoji: "🛏️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bathroom",
    type: "word",
    title: "bathroom",
    content: "浴室\n/'bɑ:θru:m/",
    pronunciation: "/'bɑ:θru:m/",
    meaning: "浴室",
    emoji: "🚿",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-door",
    type: "word",
    title: "door",
    content: "门\n/dɒ:/",
    pronunciation: "/dɒ:/",
    meaning: "门",
    emoji: "🚪",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-window",
    type: "word",
    title: "window",
    content: "窗户\n/'windәu/",
    pronunciation: "/'windәu/",
    meaning: "窗户",
    emoji: "🪟",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-table",
    type: "word",
    title: "table",
    content: "桌子\n/'teibl/",
    pronunciation: "/'teibl/",
    meaning: "桌子",
    emoji: "🪑",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bed",
    type: "word",
    title: "bed",
    content: "床\n/bed/",
    pronunciation: "/bed/",
    meaning: "床",
    emoji: "🛏️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sofa",
    type: "word",
    title: "sofa",
    content: "沙发\n/'sәufә/",
    pronunciation: "/'sәufә/",
    meaning: "沙发",
    emoji: "🛋️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-lamp",
    type: "word",
    title: "lamp",
    content: "灯\n/læmp/",
    pronunciation: "/læmp/",
    meaning: "灯",
    emoji: "💡",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-clock",
    type: "word",
    title: "clock",
    content: "时钟\n/klɒk/",
    pronunciation: "/klɒk/",
    meaning: "时钟",
    emoji: "⏰",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-phone",
    type: "word",
    title: "phone",
    content: "电话\n/fәun/",
    pronunciation: "/fәun/",
    meaning: "电话",
    emoji: "📱",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-computer",
    type: "word",
    title: "computer",
    content: "电脑\n/kәm'pju:tә/",
    pronunciation: "/kәm'pju:tә/",
    meaning: "电脑",
    emoji: "💻",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-television",
    type: "word",
    title: "television",
    content: "电视\n/'teli.viʒәn/",
    pronunciation: "/'teli.viʒәn/",
    meaning: "电视",
    emoji: "📺",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-camera",
    type: "word",
    title: "camera",
    content: "照相机\n/'kæmәrә/",
    pronunciation: "/'kæmәrә/",
    meaning: "照相机",
    emoji: "📷",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-ball",
    type: "word",
    title: "ball",
    content: "球\n/bɒ:l/",
    pronunciation: "/bɒ:l/",
    meaning: "球",
    emoji: "⚽",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-toy",
    type: "word",
    title: "toy",
    content: "玩具\n/tɒi/",
    pronunciation: "/tɒi/",
    meaning: "玩具",
    emoji: "🧸",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-kite",
    type: "word",
    title: "kite",
    content: "风筝\n/kait/",
    pronunciation: "/kait/",
    meaning: "风筝",
    emoji: "🪁",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-balloon",
    type: "word",
    title: "balloon",
    content: "气球\n/bә'lu:n/",
    pronunciation: "/bә'lu:n/",
    meaning: "气球",
    emoji: "🎈",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-drum",
    type: "word",
    title: "drum",
    content: "鼓\n/drʌm/",
    pronunciation: "/drʌm/",
    meaning: "鼓",
    emoji: "🥁",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-guitar",
    type: "word",
    title: "guitar",
    content: "吉他\n/gi'tɑ:/",
    pronunciation: "/gi'tɑ:/",
    meaning: "吉他",
    emoji: "🎸",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-dolphin",
    type: "word",
    title: "dolphin",
    content: "海豚\n/'dɒlfin/",
    pronunciation: "/'dɒlfin/",
    meaning: "海豚",
    emoji: "🐬",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-whale",
    type: "word",
    title: "whale",
    content: "鲸\n/hweil/",
    pronunciation: "/hweil/",
    meaning: "鲸",
    emoji: "🐳",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-butterfly",
    type: "word",
    title: "butterfly",
    content: "蝴蝶\n/'bʌtәflai/",
    pronunciation: "/'bʌtәflai/",
    meaning: "蝴蝶",
    emoji: "🦋",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-bee",
    type: "word",
    title: "bee",
    content: "蜜蜂\n/bi:/",
    pronunciation: "/bi:/",
    meaning: "蜜蜂",
    emoji: "🐝",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-ant",
    type: "word",
    title: "ant",
    content: "蚂蚁\n/ænt/",
    pronunciation: "/ænt/",
    meaning: "蚂蚁",
    emoji: "🐜",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-spider",
    type: "word",
    title: "spider",
    content: "蜘蛛\n/'spaidә/",
    pronunciation: "/'spaidә/",
    meaning: "蜘蛛",
    emoji: "🕷️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-doctor",
    type: "word",
    title: "doctor",
    content: "医生\n/'dɒktә/",
    pronunciation: "/'dɒktә/",
    meaning: "医生",
    emoji: "👩‍⚕️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-nurse",
    type: "word",
    title: "nurse",
    content: "护士\n/nә:s/",
    pronunciation: "/nә:s/",
    meaning: "护士",
    emoji: "👩‍⚕️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-police",
    type: "word",
    title: "police",
    content: "警察\n/pә'li:s/",
    pronunciation: "/pә'li:s/",
    meaning: "警察",
    emoji: "👮",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-officer",
    type: "word",
    title: "officer",
    content: "军官\n/'ɒfisә/",
    pronunciation: "/'ɒfisә/",
    meaning: "军官",
    emoji: "👮",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-farmer",
    type: "word",
    title: "farmer",
    content: "农夫\n/'fɑ:mә/",
    pronunciation: "/'fɑ:mә/",
    meaning: "农夫",
    emoji: "👩‍🌾",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-driver",
    type: "word",
    title: "driver",
    content: "驾驶员\n/'draivә/",
    pronunciation: "/'draivә/",
    meaning: "驾驶员",
    emoji: "🚗",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-cook",
    type: "word",
    title: "cook",
    content: "厨子\n/kuk/",
    pronunciation: "/kuk/",
    meaning: "厨子",
    emoji: "👩‍🍳",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-singer",
    type: "word",
    title: "singer",
    content: "歌手\n/'siŋә/",
    pronunciation: "/'siŋә/",
    meaning: "歌手",
    emoji: "🎤",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-painter",
    type: "word",
    title: "painter",
    content: "画家\n/'peintә/",
    pronunciation: "/'peintә/",
    meaning: "画家",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pilot",
    type: "word",
    title: "pilot",
    content: "飞行员\n/'pailәt/",
    pronunciation: "/'pailәt/",
    meaning: "飞行员",
    emoji: "👩‍✈️",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-color",
    type: "word",
    title: "color",
    content: "颜色\n/'kʌlә/",
    pronunciation: "/'kʌlә/",
    meaning: "颜色",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-number",
    type: "word",
    title: "number",
    content: "数\n/'nʌmbә/",
    pronunciation: "/'nʌmbә/",
    meaning: "数",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-shape",
    type: "word",
    title: "shape",
    content: "形状\n/ʃeip/",
    pronunciation: "/ʃeip/",
    meaning: "形状",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-circle",
    type: "word",
    title: "circle",
    content: "圆周\n/'sә:kl/",
    pronunciation: "/'sә:kl/",
    meaning: "圆周",
    emoji: "⭕",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-square",
    type: "word",
    title: "square",
    content: "正方形\n/skwєә/",
    pronunciation: "/skwєә/",
    meaning: "正方形",
    emoji: "⬜",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-triangle",
    type: "word",
    title: "triangle",
    content: "三角形\n/'traiæŋgl/",
    pronunciation: "/'traiæŋgl/",
    meaning: "三角形",
    emoji: "🔺",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-rectangle",
    type: "word",
    title: "rectangle",
    content: "长方形\n/'rektæŋgl/",
    pronunciation: "/'rektæŋgl/",
    meaning: "长方形",
    emoji: "▭",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-line",
    type: "word",
    title: "line",
    content: "列\n/lain/",
    pronunciation: "/lain/",
    meaning: "列",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-up",
    type: "word",
    title: "up",
    content: "向上的\n/ʌp/",
    pronunciation: "/ʌp/",
    meaning: "向上的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-down",
    type: "word",
    title: "down",
    content: "向下的\n/daun/",
    pronunciation: "/daun/",
    meaning: "向下的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-left",
    type: "word",
    title: "left",
    content: "左边的\n/left/",
    pronunciation: "/left/",
    meaning: "左边的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-right",
    type: "word",
    title: "right",
    content: "权利\n/rait/",
    pronunciation: "/rait/",
    meaning: "权利",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-in",
    type: "word",
    title: "in",
    content: "在...期间\n/in/",
    pronunciation: "/in/",
    meaning: "在...期间",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-out",
    type: "word",
    title: "out",
    content: "外面的\n/aut/",
    pronunciation: "/aut/",
    meaning: "外面的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-on",
    type: "word",
    title: "on",
    content: "在...之上\n/ɒn/",
    pronunciation: "/ɒn/",
    meaning: "在...之上",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-under",
    type: "word",
    title: "under",
    content: "在...之下\n/'ʌndә/",
    pronunciation: "/'ʌndә/",
    meaning: "在...之下",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-over",
    type: "word",
    title: "over",
    content: "结束\n/'әuvә/",
    pronunciation: "/'әuvә/",
    meaning: "结束",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-near",
    type: "word",
    title: "near",
    content: "近的\n/niә/",
    pronunciation: "/niә/",
    meaning: "近的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-far",
    type: "word",
    title: "far",
    content: "远的\n/fɑ:/",
    pronunciation: "/fɑ:/",
    meaning: "远的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-here",
    type: "word",
    title: "here",
    content: "在这里\n/hiә/",
    pronunciation: "/hiә/",
    meaning: "在这里",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-there",
    type: "word",
    title: "there",
    content: "在那里\n/ðєә/",
    pronunciation: "/ðєә/",
    meaning: "在那里",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-hello",
    type: "word",
    title: "hello",
    content: "interj. 喂\n/hә'lәu/",
    pronunciation: "/hә'lәu/",
    meaning: "interj. 喂",
    emoji: "👋",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-goodbye",
    type: "word",
    title: "goodbye",
    content: "interj. 再见\n/gud'bai/",
    pronunciation: "/gud'bai/",
    meaning: "interj. 再见",
    emoji: "👋",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-please",
    type: "word",
    title: "please",
    content: "请\n/pli:z/",
    pronunciation: "/pli:z/",
    meaning: "请",
    emoji: "🙏",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sorry",
    type: "word",
    title: "sorry",
    content: "难过的\n/'sɒri/",
    pronunciation: "/'sɒri/",
    meaning: "难过的",
    emoji: "🙇",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-thank",
    type: "word",
    title: "thank",
    content: "谢意\n/θæŋk/",
    pronunciation: "/θæŋk/",
    meaning: "谢意",
    emoji: "🙏",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-thanks",
    type: "word",
    title: "thanks",
    content: "感谢",
    meaning: "感谢",
    emoji: "🙏",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-yes",
    type: "word",
    title: "yes",
    content: "是\n/jes/",
    pronunciation: "/jes/",
    meaning: "是",
    emoji: "✅",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-no",
    type: "word",
    title: "no",
    content: "不\n/nәu/",
    pronunciation: "/nәu/",
    meaning: "不",
    emoji: "❌",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-okay",
    type: "word",
    title: "okay",
    content: "好\n/әj'kei/",
    pronunciation: "/әj'kei/",
    meaning: "好",
    emoji: "👌",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-us",
    type: "word",
    title: "us",
    content: "我们\n/ʌs/",
    pronunciation: "/ʌs/",
    meaning: "我们",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-page",
    type: "word",
    title: "page",
    content: "页\n/peidʒ/",
    pronunciation: "/peidʒ/",
    meaning: "页",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-search",
    type: "word",
    title: "search",
    content: "搜寻\n/sә:tʃ/",
    pronunciation: "/sә:tʃ/",
    meaning: "搜寻",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-free",
    type: "word",
    title: "free",
    content: "自由的\n/fri:/",
    pronunciation: "/fri:/",
    meaning: "自由的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-information",
    type: "word",
    title: "information",
    content: "消息\n/.infә'meiʃәn/",
    pronunciation: "/.infә'meiʃәn/",
    meaning: "消息",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-time",
    type: "word",
    title: "time",
    content: "时间\n/taim/",
    pronunciation: "/taim/",
    meaning: "时间",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-site",
    type: "word",
    title: "site",
    content: "位置\n/sait/",
    pronunciation: "/sait/",
    meaning: "位置",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-may",
    type: "word",
    title: "may",
    content: "五月\n/mei/",
    pronunciation: "/mei/",
    meaning: "五月",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-news",
    type: "word",
    title: "news",
    content: "新闻\n/nju:z/",
    pronunciation: "/nju:z/",
    meaning: "新闻",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-use",
    type: "word",
    title: "use",
    content: "使用\n/ju:s/",
    pronunciation: "/ju:s/",
    meaning: "使用",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-see",
    type: "word",
    title: "see",
    content: "看见\n/si:/",
    pronunciation: "/si:/",
    meaning: "看见",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-contact",
    type: "word",
    title: "contact",
    content: "联系\n/'kɒntækt/",
    pronunciation: "/'kɒntækt/",
    meaning: "联系",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-business",
    type: "word",
    title: "business",
    content: "生意\n/'biznis/",
    pronunciation: "/'biznis/",
    meaning: "生意",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-web",
    type: "word",
    title: "web",
    content: "网\n/web/",
    pronunciation: "/web/",
    meaning: "网",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-also",
    type: "word",
    title: "also",
    content: "也\n/'ɒ:lsәu/",
    pronunciation: "/'ɒ:lsәu/",
    meaning: "也",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-get",
    type: "word",
    title: "get",
    content: "得到\n/get/",
    pronunciation: "/get/",
    meaning: "得到",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pm",
    type: "word",
    title: "pm",
    content: "出纳员",
    meaning: "出纳员",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-view",
    type: "word",
    title: "view",
    content: "视野\n/vju:/",
    pronunciation: "/vju:/",
    meaning: "视野",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-online",
    type: "word",
    title: "online",
    content: "联机",
    meaning: "联机",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-first",
    type: "word",
    title: "first",
    content: "首先\n/fә:st/",
    pronunciation: "/fә:st/",
    meaning: "首先",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-services",
    type: "word",
    title: "services",
    content: "服务",
    meaning: "服务",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-click",
    type: "word",
    title: "click",
    content: "咔哒声\n/klik/",
    pronunciation: "/klik/",
    meaning: "咔哒声",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-service",
    type: "word",
    title: "service",
    content: "服务\n/'sә:vis/",
    pronunciation: "/'sә:vis/",
    meaning: "服务",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-price",
    type: "word",
    title: "price",
    content: "价格\n/prais/",
    pronunciation: "/prais/",
    meaning: "价格",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-date",
    type: "word",
    title: "date",
    content: "日期\n/deit/",
    pronunciation: "/deit/",
    meaning: "日期",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-top",
    type: "word",
    title: "top",
    content: "顶部\n/tɒp/",
    pronunciation: "/tɒp/",
    meaning: "顶部",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-people",
    type: "word",
    title: "people",
    content: "人\n/'pi:pl/",
    pronunciation: "/'pi:pl/",
    meaning: "人",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-list",
    type: "word",
    title: "list",
    content: "目录\n/list/",
    pronunciation: "/list/",
    meaning: "目录",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-name",
    type: "word",
    title: "name",
    content: "名字\n/neim/",
    pronunciation: "/neim/",
    meaning: "名字",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-state",
    type: "word",
    title: "state",
    content: "州\n/steit/",
    pronunciation: "/steit/",
    meaning: "州",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-day",
    type: "word",
    title: "day",
    content: "天\n/dei/",
    pronunciation: "/dei/",
    meaning: "天",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-email",
    type: "word",
    title: "email",
    content: "电子信函\n/'i:'meil/",
    pronunciation: "/'i:'meil/",
    meaning: "电子信函",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-health",
    type: "word",
    title: "health",
    content: "健康\n/'helθ/",
    pronunciation: "/'helθ/",
    meaning: "健康",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-world",
    type: "word",
    title: "world",
    content: "世界\n/wә:ld/",
    pronunciation: "/wә:ld/",
    meaning: "世界",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-re",
    type: "word",
    title: "re",
    content: "关于\n/ri:/",
    pronunciation: "/ri:/",
    meaning: "关于",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-next",
    type: "word",
    title: "next",
    content: "下一个\n/'nekst/",
    pronunciation: "/'nekst/",
    meaning: "下一个",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-used",
    type: "word",
    title: "used",
    content: "使用过的\n/'ju:st/",
    pronunciation: "/'ju:st/",
    meaning: "使用过的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-go",
    type: "word",
    title: "go",
    content: "去\n/gou/",
    pronunciation: "/gou/",
    meaning: "去",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-work",
    type: "word",
    title: "work",
    content: "工作\n/wә:k/",
    pronunciation: "/wә:k/",
    meaning: "工作",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-last",
    type: "word",
    title: "last",
    content: "最后的\n/lɑ:st/",
    pronunciation: "/lɑ:st/",
    meaning: "最后的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-products",
    type: "word",
    title: "products",
    content: "产品",
    meaning: "产品",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-music",
    type: "word",
    title: "music",
    content: "音乐\n/'mju:zik/",
    pronunciation: "/'mju:zik/",
    meaning: "音乐",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-buy",
    type: "word",
    title: "buy",
    content: "买\n/bai/",
    pronunciation: "/bai/",
    meaning: "买",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-data",
    type: "word",
    title: "data",
    content: "资料\n/'deitә/",
    pronunciation: "/'deitә/",
    meaning: "资料",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-product",
    type: "word",
    title: "product",
    content: "产品\n/'prɒdʌkt/",
    pronunciation: "/'prɒdʌkt/",
    meaning: "产品",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-system",
    type: "word",
    title: "system",
    content: "系统\n/'sistәm/",
    pronunciation: "/'sistәm/",
    meaning: "系统",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-post",
    type: "word",
    title: "post",
    content: "柱\n/pәust/",
    pronunciation: "/pәust/",
    meaning: "柱",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-add",
    type: "word",
    title: "add",
    content: "增加\n/æd/",
    pronunciation: "/æd/",
    meaning: "增加",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-policy",
    type: "word",
    title: "policy",
    content: "政策\n/'pɒlisi/",
    pronunciation: "/'pɒlisi/",
    meaning: "政策",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-available",
    type: "word",
    title: "available",
    content: "可利用的\n/ә'veilәbl/",
    pronunciation: "/ә'veilәbl/",
    meaning: "可利用的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-copyright",
    type: "word",
    title: "copyright",
    content: "版权\n/'kɒpirait/",
    pronunciation: "/'kɒpirait/",
    meaning: "版权",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-support",
    type: "word",
    title: "support",
    content: "支持\n/sә'pɒ:t/",
    pronunciation: "/sә'pɒ:t/",
    meaning: "支持",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-message",
    type: "word",
    title: "message",
    content: "消息\n/'mesidʒ/",
    pronunciation: "/'mesidʒ/",
    meaning: "消息",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-best",
    type: "word",
    title: "best",
    content: "最好的\n/best/",
    pronunciation: "/best/",
    meaning: "最好的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-software",
    type: "word",
    title: "software",
    content: "软件\n/'sɒftwєә/",
    pronunciation: "/'sɒftwєә/",
    meaning: "软件",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-jan",
    type: "word",
    title: "jan",
    content: "一月\n/dʒæn/",
    pronunciation: "/dʒæn/",
    meaning: "一月",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-good",
    type: "word",
    title: "good",
    content: "善行\n/gud/",
    pronunciation: "/gud/",
    meaning: "善行",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-video",
    type: "word",
    title: "video",
    content: "影像\n/'vidiәu/",
    pronunciation: "/'vidiәu/",
    meaning: "影像",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-well",
    type: "word",
    title: "well",
    content: "井\n/wel/",
    pronunciation: "/wel/",
    meaning: "井",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-info",
    type: "word",
    title: "info",
    content: "信息\n/'infәu/",
    pronunciation: "/'infәu/",
    meaning: "信息",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-rights",
    type: "word",
    title: "rights",
    content: "正当权利",
    meaning: "正当权利",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-public",
    type: "word",
    title: "public",
    content: "公众\n/'pʌblik/",
    pronunciation: "/'pʌblik/",
    meaning: "公众",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-books",
    type: "word",
    title: "books",
    content: "书评",
    meaning: "书评",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-high",
    type: "word",
    title: "high",
    content: "高度\n/hai/",
    pronunciation: "/hai/",
    meaning: "高度",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-links",
    type: "word",
    title: "links",
    content: "高尔夫球场\n/liŋks/",
    pronunciation: "/liŋks/",
    meaning: "高尔夫球场",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-review",
    type: "word",
    title: "review",
    content: "检讨\n/ri'vju:/",
    pronunciation: "/ri'vju:/",
    meaning: "检讨",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-years",
    type: "word",
    title: "years",
    content: "年代",
    meaning: "年代",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-order",
    type: "word",
    title: "order",
    content: "次序\n/'ɒ:dә/",
    pronunciation: "/'ɒ:dә/",
    meaning: "次序",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-privacy",
    type: "word",
    title: "privacy",
    content: "隐私\n/'praivәsi/",
    pronunciation: "/'praivәsi/",
    meaning: "隐私",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-items",
    type: "word",
    title: "items",
    content: "项目",
    meaning: "项目",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-company",
    type: "word",
    title: "company",
    content: "公司\n/'kʌmpәni/",
    pronunciation: "/'kʌmpәni/",
    meaning: "公司",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-group",
    type: "word",
    title: "group",
    content: "团体\n/gru:p/",
    pronunciation: "/gru:p/",
    meaning: "团体",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sex",
    type: "word",
    title: "sex",
    content: "性别\n/seks/",
    pronunciation: "/seks/",
    meaning: "性别",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-many",
    type: "word",
    title: "many",
    content: "多数\n/'meni/",
    pronunciation: "/'meni/",
    meaning: "多数",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-user",
    type: "word",
    title: "user",
    content: "使用者\n/'ju:zә/",
    pronunciation: "/'ju:zә/",
    meaning: "使用者",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-said",
    type: "word",
    title: "said",
    content: "上述的\n/sed/",
    pronunciation: "/sed/",
    meaning: "上述的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-de",
    type: "word",
    title: "de",
    content: "非对映体过量\n/di:/",
    pronunciation: "/di:/",
    meaning: "非对映体过量",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-set",
    type: "word",
    title: "set",
    content: "日落\n/set/",
    pronunciation: "/set/",
    meaning: "日落",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-general",
    type: "word",
    title: "general",
    content: "一般\n/'dʒenәrәl/",
    pronunciation: "/'dʒenәrәl/",
    meaning: "一般",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-research",
    type: "word",
    title: "research",
    content: "研究\n/ri'sә:tʃ/",
    pronunciation: "/ri'sә:tʃ/",
    meaning: "研究",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-university",
    type: "word",
    title: "university",
    content: "大学\n/.ju:ni'vә:siti/",
    pronunciation: "/.ju:ni'vә:siti/",
    meaning: "大学",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-january",
    type: "word",
    title: "january",
    content: "一月\n/'dʒænjuәri/",
    pronunciation: "/'dʒænjuәri/",
    meaning: "一月",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-mail",
    type: "word",
    title: "mail",
    content: "邮件\n/meil/",
    pronunciation: "/meil/",
    meaning: "邮件",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-full",
    type: "word",
    title: "full",
    content: "全部\n/ful/",
    pronunciation: "/ful/",
    meaning: "全部",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-map",
    type: "word",
    title: "map",
    content: "地图\n/mæp/",
    pronunciation: "/mæp/",
    meaning: "地图",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-reviews",
    type: "word",
    title: "reviews",
    content: "评论",
    meaning: "评论",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-program",
    type: "word",
    title: "program",
    content: "节目\n/'prәugræm/",
    pronunciation: "/'prәugræm/",
    meaning: "节目",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-life",
    type: "word",
    title: "life",
    content: "生活\n/laif/",
    pronunciation: "/laif/",
    meaning: "生活",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-know",
    type: "word",
    title: "know",
    content: "知道\n/nәu/",
    pronunciation: "/nәu/",
    meaning: "知道",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-games",
    type: "word",
    title: "games",
    content: "(英)体操课",
    meaning: "(英)体操课",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-way",
    type: "word",
    title: "way",
    content: "路\n/wei/",
    pronunciation: "/wei/",
    meaning: "路",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-days",
    type: "word",
    title: "days",
    content: "一生\n/deiz/",
    pronunciation: "/deiz/",
    meaning: "一生",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-management",
    type: "word",
    title: "management",
    content: "经营\n/'mænidʒmәnt/",
    pronunciation: "/'mænidʒmәnt/",
    meaning: "经营",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-part",
    type: "word",
    title: "part",
    content: "部分\n/pɑ:t/",
    pronunciation: "/pɑ:t/",
    meaning: "部分",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-great",
    type: "word",
    title: "great",
    content: "大的\n/greit/",
    pronunciation: "/greit/",
    meaning: "大的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-united",
    type: "word",
    title: "united",
    content: "联合的\n/ju:'naitid/",
    pronunciation: "/ju:'naitid/",
    meaning: "联合的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-hotel",
    type: "word",
    title: "hotel",
    content: "旅馆\n/hәu'tel/",
    pronunciation: "/hәu'tel/",
    meaning: "旅馆",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-real",
    type: "word",
    title: "real",
    content: "真的\n/'riәl/",
    pronunciation: "/'riәl/",
    meaning: "真的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-item",
    type: "word",
    title: "item",
    content: "项目\n/'aitәm/",
    pronunciation: "/'aitәm/",
    meaning: "项目",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-international",
    type: "word",
    title: "international",
    content: "国际的\n/.intә'næʃәnәl/",
    pronunciation: "/.intә'næʃәnәl/",
    meaning: "国际的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-center",
    type: "word",
    title: "center",
    content: "中心\n/'sentә/",
    pronunciation: "/'sentә/",
    meaning: "中心",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-ebay",
    type: "word",
    title: "ebay",
    content: "电子港湾",
    meaning: "电子港湾",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-must",
    type: "word",
    title: "must",
    content: "必须\n/mʌst/",
    pronunciation: "/mʌst/",
    meaning: "必须",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-store",
    type: "word",
    title: "store",
    content: "商店\n/stɒ:/",
    pronunciation: "/stɒ:/",
    meaning: "商店",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-travel",
    type: "word",
    title: "travel",
    content: "旅行\n/'trævl/",
    pronunciation: "/'trævl/",
    meaning: "旅行",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-comments",
    type: "word",
    title: "comments",
    content: "注解",
    meaning: "注解",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-made",
    type: "word",
    title: "made",
    content: "人工制成的\n/meid/",
    pronunciation: "/meid/",
    meaning: "人工制成的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-development",
    type: "word",
    title: "development",
    content: "发展\n/di'velәpmәnt/",
    pronunciation: "/di'velәpmәnt/",
    meaning: "发展",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-report",
    type: "word",
    title: "report",
    content: "报告\n/ri'pɒ:t/",
    pronunciation: "/ri'pɒ:t/",
    meaning: "报告",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-member",
    type: "word",
    title: "member",
    content: "成员\n/'membә/",
    pronunciation: "/'membә/",
    meaning: "成员",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-details",
    type: "word",
    title: "details",
    content: "详细资料",
    meaning: "详细资料",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-terms",
    type: "word",
    title: "terms",
    content: "条件",
    meaning: "条件",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-hotels",
    type: "word",
    title: "hotels",
    content: "酒店",
    meaning: "酒店",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-send",
    type: "word",
    title: "send",
    content: "发送\n/send/",
    pronunciation: "/send/",
    meaning: "发送",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-type",
    type: "word",
    title: "type",
    content: "类型\n/taip/",
    pronunciation: "/taip/",
    meaning: "类型",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-local",
    type: "word",
    title: "local",
    content: "地方性的\n/'lәukәl/",
    pronunciation: "/'lәukәl/",
    meaning: "地方性的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-using",
    type: "word",
    title: "using",
    content: "使用",
    meaning: "使用",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-results",
    type: "word",
    title: "results",
    content: "结果",
    meaning: "结果",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-office",
    type: "word",
    title: "office",
    content: "办公室\n/'ɒfis/",
    pronunciation: "/'ɒfis/",
    meaning: "办公室",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-education",
    type: "word",
    title: "education",
    content: "教育\n/.edju'keiʃәn/",
    pronunciation: "/.edju'keiʃәn/",
    meaning: "教育",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-national",
    type: "word",
    title: "national",
    content: "国家的\n/'næʃәnәl/",
    pronunciation: "/'næʃәnәl/",
    meaning: "国家的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-design",
    type: "word",
    title: "design",
    content: "设计\n/di'zain/",
    pronunciation: "/di'zain/",
    meaning: "设计",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-posted",
    type: "word",
    title: "posted",
    content: "贴出",
    meaning: "贴出",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-internet",
    type: "word",
    title: "internet",
    content: "因特网\n/'intәnet/",
    pronunciation: "/'intәnet/",
    meaning: "因特网",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-address",
    type: "word",
    title: "address",
    content: "住址\n/ә'dres/",
    pronunciation: "/ә'dres/",
    meaning: "住址",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-community",
    type: "word",
    title: "community",
    content: "社区\n/kә'mju:niti/",
    pronunciation: "/kә'mju:niti/",
    meaning: "社区",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-within",
    type: "word",
    title: "within",
    content: "内部\n/wi'ðin/",
    pronunciation: "/wi'ðin/",
    meaning: "内部",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-states",
    type: "word",
    title: "states",
    content: "美国",
    meaning: "美国",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-area",
    type: "word",
    title: "area",
    content: "区域\n/'єәriә/",
    pronunciation: "/'єәriә/",
    meaning: "区域",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-dvd",
    type: "word",
    title: "dvd",
    content: "数字化视频光盘（Digital Vide",
    meaning: "数字化视频光盘（Digital Vide",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-shipping",
    type: "word",
    title: "shipping",
    content: "装运\n/'ʃipiŋ/",
    pronunciation: "/'ʃipiŋ/",
    meaning: "装运",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-reserved",
    type: "word",
    title: "reserved",
    content: "保留的\n/ri'zә:vd/",
    pronunciation: "/ri'zә:vd/",
    meaning: "保留的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-subject",
    type: "word",
    title: "subject",
    content: "科目\n/'sʌbdʒekt/",
    pronunciation: "/'sʌbdʒekt/",
    meaning: "科目",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-forum",
    type: "word",
    title: "forum",
    content: "论坛\n/'fɒ:rәm/",
    pronunciation: "/'fɒ:rәm/",
    meaning: "论坛",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-based",
    type: "word",
    title: "based",
    content: "立基于\n/beist/",
    pronunciation: "/beist/",
    meaning: "立基于",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-code",
    type: "word",
    title: "code",
    content: "代码\n/kәud/",
    pronunciation: "/kәud/",
    meaning: "代码",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-show",
    type: "word",
    title: "show",
    content: "显示\n/ʃәu/",
    pronunciation: "/ʃәu/",
    meaning: "显示",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-even",
    type: "word",
    title: "even",
    content: "平坦的\n/'i:vәn/",
    pronunciation: "/'i:vәn/",
    meaning: "平坦的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-check",
    type: "word",
    title: "check",
    content: "检查\n/tʃek/",
    pronunciation: "/tʃek/",
    meaning: "检查",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-special",
    type: "word",
    title: "special",
    content: "专辑\n/'speʃәl/",
    pronunciation: "/'speʃәl/",
    meaning: "专辑",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-prices",
    type: "word",
    title: "prices",
    content: "价格（price的复数）",
    meaning: "价格（price的复数）",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-website",
    type: "word",
    title: "website",
    content: "网站（全球资讯网的主机站）",
    meaning: "网站（全球资讯网的主机站）",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-index",
    type: "word",
    title: "index",
    content: "索引\n/'indeks/",
    pronunciation: "/'indeks/",
    meaning: "索引",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-women",
    type: "word",
    title: "women",
    content: "女人\n/'wimin/",
    pronunciation: "/'wimin/",
    meaning: "女人",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-much",
    type: "word",
    title: "much",
    content: "大量\n/mʌtʃ/",
    pronunciation: "/mʌtʃ/",
    meaning: "大量",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sign",
    type: "word",
    title: "sign",
    content: "符号\n/sain/",
    pronunciation: "/sain/",
    meaning: "符号",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-file",
    type: "word",
    title: "file",
    content: "档案\n/fail/",
    pronunciation: "/fail/",
    meaning: "档案",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-link",
    type: "word",
    title: "link",
    content: "环\n/liŋk/",
    pronunciation: "/liŋk/",
    meaning: "环",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-technology",
    type: "word",
    title: "technology",
    content: "技术\n/tek'nɒlәdʒi/",
    pronunciation: "/tek'nɒlәdʒi/",
    meaning: "技术",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-south",
    type: "word",
    title: "south",
    content: "南方\n/sauθ/",
    pronunciation: "/sauθ/",
    meaning: "南方",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-case",
    type: "word",
    title: "case",
    content: "情形\n/keis/",
    pronunciation: "/keis/",
    meaning: "情形",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-project",
    type: "word",
    title: "project",
    content: "计划\n/'prɒdʒekt/",
    pronunciation: "/'prɒdʒekt/",
    meaning: "计划",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-pages",
    type: "word",
    title: "pages",
    content: "页数",
    meaning: "页数",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-uk",
    type: "word",
    title: "uk",
    content: "联合王国\n/ju: 'kei/",
    pronunciation: "/ju: 'kei/",
    meaning: "联合王国",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-version",
    type: "word",
    title: "version",
    content: "一种描述\n/'vә:ʒәn/",
    pronunciation: "/'vә:ʒәn/",
    meaning: "一种描述",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-section",
    type: "word",
    title: "section",
    content: "区段\n/'sekʃәn/",
    pronunciation: "/'sekʃәn/",
    meaning: "区段",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-found",
    type: "word",
    title: "found",
    content: "建立\n/faund/",
    pronunciation: "/faund/",
    meaning: "建立",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-sports",
    type: "word",
    title: "sports",
    content: "(英)运动会\n/spɔ:ts/",
    pronunciation: "/spɔ:ts/",
    meaning: "(英)运动会",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-related",
    type: "word",
    title: "related",
    content: "讲述的\n/ri'leitid/",
    pronunciation: "/ri'leitid/",
    meaning: "讲述的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-security",
    type: "word",
    title: "security",
    content: "安全\n/si'kjuriti/",
    pronunciation: "/si'kjuriti/",
    meaning: "安全",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-county",
    type: "word",
    title: "county",
    content: "县\n/'kaunti/",
    pronunciation: "/'kaunti/",
    meaning: "县",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-american",
    type: "word",
    title: "american",
    content: "美国人\n/ә'merikәn/",
    pronunciation: "/ә'merikәn/",
    meaning: "美国人",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-photo",
    type: "word",
    title: "photo",
    content: "相片\n/'fәutәu/",
    pronunciation: "/'fәutәu/",
    meaning: "相片",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-game",
    type: "word",
    title: "game",
    content: "比赛\n/geim/",
    pronunciation: "/geim/",
    meaning: "比赛",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-members",
    type: "word",
    title: "members",
    content: "成员",
    meaning: "成员",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-power",
    type: "word",
    title: "power",
    content: "力\n/'pauә/",
    pronunciation: "/'pauә/",
    meaning: "力",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-care",
    type: "word",
    title: "care",
    content: "小心\n/kєә/",
    pronunciation: "/kєә/",
    meaning: "小心",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-network",
    type: "word",
    title: "network",
    content: "网络\n/'netwә:k/",
    pronunciation: "/'netwә:k/",
    meaning: "网络",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-systems",
    type: "word",
    title: "systems",
    content: "体制",
    meaning: "体制",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-total",
    type: "word",
    title: "total",
    content: "全体的\n/'tәutl/",
    pronunciation: "/'tәutl/",
    meaning: "全体的",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-place",
    type: "word",
    title: "place",
    content: "地方\n/pleis/",
    pronunciation: "/pleis/",
    meaning: "地方",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-end",
    type: "word",
    title: "end",
    content: "结束\n/end/",
    pronunciation: "/end/",
    meaning: "结束",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-following",
    type: "word",
    title: "following",
    content: "下列各项\n/'fɒlәuiŋ/",
    pronunciation: "/'fɒlәuiŋ/",
    meaning: "下列各项",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-download",
    type: "word",
    title: "download",
    content: "卸载",
    meaning: "卸载",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-without",
    type: "word",
    title: "without",
    content: "没有\n/wi'ðaut/",
    pronunciation: "/wi'ðaut/",
    meaning: "没有",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-per",
    type: "word",
    title: "per",
    content: "每一\n/pә:/",
    pronunciation: "/pә:/",
    meaning: "每一",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-access",
    type: "word",
    title: "access",
    content: "通路\n/'ækses/",
    pronunciation: "/'ækses/",
    meaning: "通路",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-think",
    type: "word",
    title: "think",
    content: "想\n/θiŋk/",
    pronunciation: "/θiŋk/",
    meaning: "想",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-north",
    type: "word",
    title: "north",
    content: "北方\n/nɒ:θ/",
    pronunciation: "/nɒ:θ/",
    meaning: "北方",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  },
  {
    id: "builtin-word-resources",
    type: "word",
    title: "resources",
    content: "资源",
    meaning: "资源",
    emoji: "📘",
    source: "常用英文500词",
    createdAt: "2026-09-21T00:00:00.000Z"
  }
];
